<template>
  <div class="home">
    <div class="left-side">

      <section id="home">
        <div class="bg">
          <img src="@/assets/img/circle-img1.png" alt="">
        </div>
        <div class="center">
          <h1>
            <span class="small scrolled js-scroll fade-in-bottom delay-fade1">ICM</span>
            <br>
            <span class="big scrolled js-scroll fade-in-bottom delay-fade2">Farmak</span>
            <br>
            <span class="bottom">
            <span class="line-wrapper">
              <span class="line1 scrolled js-scroll width-animation delay-width1"></span>
              <span class="line2 scrolled js-scroll width-animation delay-width2"></span>
              <span class="line3 scrolled js-scroll width-animation delay-width3"></span>
              <span class="line4 scrolled js-scroll width-animation delay-width4"></span>
            </span>
              <span class="small m-l scrolled js-scroll fade-in-bottom delay-fade3">S.L.U.</span>
            </span>
          </h1>
          <h3 class="scrolled js-scroll fade-in-bottom delay-fade4">
            a company in the Farmak Group
          </h3>

          <h2 class="scrolled js-scroll fade-in-bottom delay-fade5">
            FARMAK international <br>
            <span class="mr1"></span>IS A THRIVING
            <br>
            <span class="mr2"></span>PHARMACEUTICAL COMPANY
            <br>
            FOCUSED ON <span class="color">SPECIALTY GENERICS</span>
          </h2>

          <div class="col col-mob">
            <p class="support-text">
              Amb el suport de:
            </p>

            <svg class="support-logo" viewBox="0 0 228 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.4573 32.7523C20.7523 32.7523 26.666 25.9672 26.666 17.5975C26.666 9.22771 20.7523 2.44267 13.4573 2.44267C6.16229 2.44267 0.248535 9.22771 0.248535 17.5975C0.248535 25.9672 6.16229 32.7523 13.4573 32.7523Z"
                fill="#E10E20"/>
              <path
                d="M4.23581 25.1506C2.97048 23.0117 2.22363 20.4109 2.22363 17.6036C2.22363 14.7962 2.97048 12.1955 4.23581 10.0565V25.1506Z"
                fill="white"/>
              <path
                d="M7.07471 6.7266C7.80304 6.1311 8.59927 5.63283 9.44487 5.25609V29.9449C8.59927 29.5682 7.80921 29.0699 7.07471 28.4744V6.7266Z"
                fill="white"/>
              <path
                d="M12.2778 4.45396C12.6667 4.40535 13.0617 4.38104 13.4567 4.38104C13.8579 4.38104 14.253 4.40535 14.6418 4.45396V30.7409C14.253 30.7895 13.8579 30.8138 13.4567 30.8138C13.0555 30.8138 12.6667 30.7895 12.2778 30.7409V4.45396Z"
                fill="white"/>
              <path
                d="M17.4814 5.25609C18.3271 5.63891 19.1171 6.13111 19.8516 6.73268V28.4683C19.1233 29.0638 18.3271 29.5621 17.4814 29.9449V5.25609Z"
                fill="white"/>
              <path
                d="M22.6846 10.0625C23.9499 12.2015 24.6906 14.7961 24.6906 17.5974C24.6906 20.3987 23.9499 22.9933 22.6846 25.1323V10.0625Z"
                fill="white"/>
              <path
                d="M1.35913 17.5975C1.35913 14.1217 2.44546 10.9437 4.23543 8.48877V9.31517C2.72938 11.606 1.82823 14.4802 1.82823 17.5975C1.82823 20.7147 2.72321 23.5828 4.23543 25.8797V26.7061C2.44546 24.2512 1.35913 21.0732 1.35913 17.5975Z"
                fill="white"/>
              <path
                d="M22.6846 25.8676C24.1906 23.5768 25.0794 20.7087 25.0794 17.5975C25.0794 14.4864 24.1844 11.6182 22.6846 9.3274V8.49492C24.4745 10.9498 25.5547 14.1218 25.5547 17.5914C25.5547 21.0611 24.4745 24.2391 22.6846 26.688V25.8676Z"
                fill="white"/>
              <path
                d="M26.326 31.1663C26.4186 30.7835 26.5976 30.3946 26.8137 30.0847C26.5421 29.951 26.3137 29.8538 26.073 29.6533C26.5976 28.8755 26.7272 28.3408 26.8137 27.405L26.7766 22.1063C26.431 23.6497 25.5977 25.6671 24.8755 26.7244C24.6657 27.0343 24.5731 27.2288 24.4435 27.4354C24.3694 27.5569 23.9435 28.2435 23.9559 29.0821C23.6596 29.1429 23.388 29.1307 23.0424 29.1064C23.0856 29.471 23.1103 29.5257 23.0115 30.1272C21.7092 30.2245 21.3265 30.9962 19.7772 31.8226C19.0242 32.2236 18.5304 32.4059 17.4009 32.8131C20.0303 32.7827 21.9622 33.1473 23.6102 32.0535C23.7954 32.2966 23.9374 32.5335 24.0608 32.8252C24.2892 32.649 24.7336 32.4302 25.1039 32.3391C25.5298 32.7523 26.0977 32.9164 26.826 32.8495C26.9371 32.2723 26.789 31.5613 26.326 31.1663Z"
                fill="#E10E20"/>
              <path
                d="M26.5297 30.188C26.326 30.267 25.3693 30.6194 25.3693 30.6194L25.357 30.6316C25.3508 30.5465 25.3323 30.4675 25.2952 30.3885L25.2891 30.3703C25.6594 30.1515 25.8939 29.8416 25.8939 29.7991C25.8939 29.793 25.8878 29.793 25.8939 29.793V29.7991C25.9248 29.8416 26.2396 30.1333 26.5297 30.188Z"
                fill="white"/>
              <path
                d="M25.7337 25.7157C26.6965 23.6193 26.4682 23.7105 26.6842 22.8415C26.6533 23.2608 26.6286 23.7895 26.5669 24.1723C26.1472 26.451 25.5485 28.1463 24.8202 30.0118C24.8202 30.0118 24.6226 29.9936 24.5239 30.0118C24.3511 29.8113 24.2955 29.5378 24.2955 29.5378C23.956 28.1585 25.0053 27.3017 25.7337 25.7157Z"
                fill="white"/>
              <path
                d="M23.3264 29.386L24.2214 30.1212V30.1273C24.1967 30.1455 24.1659 30.1698 24.1412 30.1941C24.098 30.2367 24.0609 30.2853 24.0301 30.34L24.0239 30.3521C23.5672 30.1334 23.2585 30.1212 23.2585 30.1212C23.382 29.6412 23.3264 29.386 23.3264 29.386Z"
                fill="white"/>
              <path
                d="M19.2525 32.5699C18.8019 32.6732 18.4377 32.6672 18.1538 32.6793L19.1105 32.3876C21.1844 31.622 21.7091 30.4371 23.1102 30.4128C23.4373 30.4189 23.7089 30.4979 23.9496 30.6376V30.6741C23.9373 30.7652 23.9496 30.8503 23.9743 30.9354V30.9475C23.0052 31.4154 20.7956 32.2175 19.2525 32.5699Z"
                fill="white"/>
              <path
                d="M24.1721 32.5092C24.1165 32.3634 24.0424 32.1264 23.8264 31.8955C24.1165 31.6524 24.1721 31.5248 24.2708 31.2878L24.277 31.2939C24.3696 31.3486 24.4683 31.379 24.5671 31.3851H24.5794L24.1721 32.5092Z"
                fill="white"/>
              <path
                d="M24.3572 30.9719C24.319 30.9344 24.2887 30.8899 24.2681 30.8409C24.2474 30.7918 24.2368 30.7393 24.2368 30.6863C24.2368 30.6332 24.2474 30.5807 24.2681 30.5317C24.2887 30.4827 24.319 30.4381 24.3572 30.4007C24.5176 30.2427 24.7769 30.2427 24.9374 30.4007C25.0978 30.5586 25.0978 30.8139 24.9374 30.9719C24.8993 31.0094 24.8541 31.0392 24.8043 31.0595C24.7545 31.0799 24.7011 31.0903 24.6473 31.0903C24.5934 31.0903 24.54 31.0799 24.4902 31.0595C24.4404 31.0392 24.3952 31.0094 24.3572 30.9719Z"
                fill="white"/>
              <path
                d="M25.246 32.1021C25.0361 31.859 24.9435 31.6706 24.8633 31.3425C24.9682 31.3121 25.0917 31.2514 25.1657 31.1481L26.6039 32.5821C26.0545 32.6307 25.5854 32.5092 25.246 32.1021Z"
                fill="white"/>
              <path
                d="M26.8319 2.32732C26.1035 2.26048 25.5357 2.42455 25.1098 2.83775C24.7394 2.7466 24.295 2.52785 24.0667 2.35163C23.9432 2.63722 23.8013 2.88029 23.6161 3.12335C21.9619 2.02957 20.0361 2.40024 17.4067 2.36378C18.5363 2.77091 19.0301 2.9532 19.7831 3.35425C21.3323 4.17458 21.7088 4.9463 23.0174 5.0496C23.1161 5.65117 23.0914 5.69978 23.0482 6.07045C23.3939 6.04614 23.6655 6.03399 23.9617 6.09476C23.9494 6.93939 24.3753 7.62604 24.4493 7.74149C24.579 7.94809 24.6715 8.14254 24.8814 8.45244C25.6036 9.50975 26.4368 11.5272 26.7825 13.0706L26.8195 7.77187C26.7331 6.83609 26.6035 6.30136 26.0788 5.52357C26.3134 5.32304 26.5479 5.21974 26.8195 5.09213C26.6097 4.78223 26.4245 4.39334 26.3319 4.01052C26.7886 3.61554 26.9368 2.90459 26.8319 2.32732Z"
                fill="#E10E20"/>
              <path
                d="M26.5297 4.98265C26.326 4.90365 25.3693 4.55122 25.3693 4.55122L25.357 4.53906C25.3508 4.62413 25.3323 4.70313 25.2952 4.78212L25.2891 4.80035C25.6594 5.01911 25.8939 5.32901 25.8939 5.37154C25.8939 5.37762 25.8878 5.37762 25.8939 5.37762V5.37154C25.9248 5.32901 26.2396 5.04341 26.5297 4.98265Z"
                fill="white"/>
              <path
                d="M25.7337 9.46104C26.6965 11.5574 26.4682 11.4663 26.6842 12.3352C26.6533 11.9159 26.6286 11.3873 26.5669 11.0045C26.1472 8.72578 25.5485 7.03043 24.8202 5.16495C24.8202 5.16495 24.6226 5.18318 24.5239 5.16495C24.3511 5.36547 24.2955 5.63891 24.2955 5.63891C23.956 7.0122 25.0053 7.86899 25.7337 9.46104Z"
                fill="white"/>
              <path
                d="M23.3264 5.78475L24.2214 5.0495V5.04342C24.1967 5.02519 24.1659 5.00088 24.1412 4.97658C24.098 4.93404 24.0609 4.88543 24.0301 4.83074L24.0239 4.81859C23.5672 5.03734 23.2585 5.0495 23.2585 5.0495C23.382 5.52954 23.3264 5.78475 23.3264 5.78475Z"
                fill="white"/>
              <path
                d="M19.2525 2.60672C18.8019 2.50342 18.4377 2.5095 18.1538 2.49734L19.1105 2.78902C21.1844 3.55466 21.7091 4.73957 23.1102 4.76388C23.4373 4.7578 23.7089 4.67881 23.9496 4.53905V4.50259C23.9373 4.41144 23.9496 4.32637 23.9743 4.2413V4.22915C23.0052 3.75518 20.7956 2.95308 19.2525 2.60672Z"
                fill="white"/>
              <path
                d="M24.1721 2.66756C24.1165 2.81339 24.0424 3.05038 23.8264 3.28128C24.1165 3.52434 24.1721 3.65195 24.2708 3.88893L24.277 3.88286C24.3696 3.82817 24.4683 3.79779 24.5671 3.79171H24.5794L24.1721 2.66756Z"
                fill="white"/>
              <path
                d="M24.9356 4.76809C25.0943 4.61092 25.0935 4.35684 24.9339 4.20059C24.7742 4.04434 24.5161 4.04509 24.3574 4.20227C24.1987 4.35945 24.1995 4.61353 24.3592 4.76977C24.5188 4.92602 24.7769 4.92527 24.9356 4.76809Z"
                fill="white"/>
              <path
                d="M25.246 3.07464C25.0361 3.3177 24.9435 3.50607 24.8633 3.83421C24.9682 3.86459 25.0917 3.92535 25.1657 4.02865L26.6039 2.58852C26.0545 2.53991 25.5854 2.66752 25.246 3.07464Z"
                fill="white"/>
              <path
                d="M0.0321516 32.8495C0.760484 32.9164 1.33451 32.7523 1.75423 32.3391C2.12456 32.4363 2.56897 32.649 2.79735 32.8252C2.92079 32.5396 3.06276 32.2966 3.24793 32.0535C4.9021 33.1473 6.82786 32.7766 9.45727 32.8131C8.32774 32.4059 7.83395 32.2236 7.08093 31.8226C5.53168 31.0023 5.15517 30.2305 3.84664 30.1272C3.74788 29.5257 3.77257 29.4771 3.81578 29.1064C3.47013 29.1307 3.19855 29.1429 2.90228 29.0821C2.91462 28.2375 2.48873 27.5508 2.41466 27.4354C2.28504 27.2288 2.19246 27.0343 1.9826 26.7244C1.26044 25.6671 0.42718 23.6497 0.0815303 22.1063L0.0444961 27.405C0.130908 28.3408 0.260527 28.8755 0.785173 29.6533C0.550625 29.8538 0.316078 29.9571 0.0444961 30.0847C0.254355 30.3946 0.439524 30.7835 0.532109 31.1663C0.0753577 31.5613 -0.0727776 32.2723 0.0321516 32.8495Z"
                fill="#E10E20"/>
              <path
                d="M0.334473 30.188C0.538159 30.267 1.49487 30.6194 1.49487 30.6194L1.50721 30.6316C1.51338 30.5465 1.5319 30.4675 1.56893 30.3885L1.57511 30.3703C1.20477 30.1515 0.97022 29.8416 0.97022 29.7991C0.97022 29.793 0.976393 29.793 0.97022 29.793V29.7991C0.939359 29.8416 0.624571 30.1333 0.334473 30.188Z"
                fill="white"/>
              <path
                d="M1.13071 25.7157C0.167831 23.6193 0.396207 23.7105 0.180176 22.8415C0.204865 23.2608 0.235727 23.7895 0.29745 24.1723C0.717167 26.451 1.31588 28.1463 2.04421 30.0118C2.04421 30.0118 2.24173 29.9936 2.34048 30.0118C2.51331 29.8113 2.56886 29.5378 2.56886 29.5378C2.90834 28.1585 1.85904 27.3017 1.13071 25.7157Z"
                fill="white"/>
              <path
                d="M3.53788 29.386L2.64289 30.1212L2.63672 30.1273C2.66141 30.1455 2.69227 30.1698 2.71696 30.1941C2.76017 30.2367 2.7972 30.2853 2.82806 30.34L2.83423 30.3521C3.29098 30.1334 3.5996 30.1212 3.5996 30.1212C3.48233 29.6412 3.53788 29.386 3.53788 29.386Z"
                fill="white"/>
              <path
                d="M7.61146 32.5699C8.06204 32.6732 8.42621 32.6672 8.71014 32.6793L7.75343 32.3876C5.67953 31.622 5.15489 30.4371 3.75377 30.4128C3.42664 30.4189 3.15506 30.4979 2.91434 30.6376V30.6741C2.92051 30.7652 2.91434 30.8503 2.88965 30.9354V30.9475C3.8587 31.4154 6.06839 32.2175 7.61146 32.5699Z"
                fill="white"/>
              <path
                d="M2.69253 32.5092C2.74808 32.3634 2.82215 32.1264 3.03818 31.8955C2.74808 31.6524 2.69253 31.5248 2.59377 31.2878L2.5876 31.2939C2.49501 31.3486 2.39626 31.379 2.2975 31.3851H2.28516L2.69253 32.5092Z"
                fill="white"/>
              <path
                d="M2.50693 30.9719C2.66741 30.8139 2.66741 30.5587 2.50693 30.4007C2.46886 30.3631 2.42364 30.3333 2.37387 30.313C2.32409 30.2927 2.27072 30.2822 2.21683 30.2822C2.16294 30.2822 2.10958 30.2927 2.0598 30.313C2.01002 30.3333 1.9648 30.3631 1.92673 30.4007C1.88859 30.4382 1.85832 30.4827 1.83767 30.5317C1.81703 30.5807 1.8064 30.6332 1.8064 30.6863C1.8064 30.7393 1.81703 30.7919 1.83767 30.8409C1.85832 30.8899 1.88859 30.9344 1.92673 30.9719C2.08721 31.1299 2.34645 31.1299 2.50693 30.9719Z"
                fill="white"/>
              <path
                d="M1.61816 32.1021C1.82802 31.859 1.92061 31.6706 2.00085 31.3425C1.89592 31.3121 1.77247 31.2514 1.6984 31.1481L0.260254 32.5821C0.809589 32.6307 1.27868 32.5092 1.61816 32.1021Z"
                fill="white"/>
              <path
                d="M0.538557 4.00434C0.445973 4.38716 0.266976 4.77605 0.0509455 5.08595C0.322527 5.21964 0.550902 5.31686 0.791623 5.51739C0.266976 6.29518 0.137358 6.82991 0.0509455 7.76569L0.0879792 13.0644C0.433629 11.521 1.26689 9.50357 1.98905 8.44626C2.19891 8.13636 2.29149 7.94191 2.42111 7.73531C2.49518 7.61378 2.92107 6.92713 2.90872 6.08858C3.20499 6.02781 3.47658 6.03996 3.82223 6.06427C3.77902 5.69968 3.7605 5.64499 3.85309 5.04342C5.15544 4.94619 5.53813 4.17448 7.08738 3.34807C7.8404 2.94702 8.33418 2.76473 9.46372 2.3576C6.83431 2.38798 4.90855 2.02339 3.25437 3.11717C3.0692 2.87411 2.92724 2.63712 2.8038 2.34545C2.57542 2.52167 2.13101 2.74042 1.76067 2.83157C1.33479 2.41837 0.766933 2.2543 0.0386006 2.32114C-0.072501 2.90449 0.0756343 3.61544 0.538557 4.00434Z"
                fill="#E10E20"/>
              <path
                d="M0.334473 4.98265C0.538159 4.90365 1.49487 4.55122 1.49487 4.55122L1.50721 4.53906C1.51338 4.62413 1.5319 4.70313 1.56893 4.78212L1.57511 4.80035C1.20477 5.01911 0.97022 5.32901 0.97022 5.37154C0.97022 5.37762 0.976393 5.37762 0.97022 5.37762V5.37154C0.939359 5.32901 0.624571 5.04341 0.334473 4.98265Z"
                fill="white"/>
              <path
                d="M1.13071 9.46104C0.167831 11.5574 0.396207 11.4663 0.180176 12.3352C0.204865 11.9159 0.235727 11.3873 0.29745 11.0045C0.717167 8.72578 1.31588 7.03043 2.04421 5.16495C2.04421 5.16495 2.24173 5.18318 2.34048 5.16495C2.51331 5.36547 2.56886 5.63891 2.56886 5.63891C2.90834 7.0122 1.85904 7.86899 1.13071 9.46104Z"
                fill="white"/>
              <path
                d="M3.53788 5.78475L2.64289 5.0495L2.63672 5.04342C2.66141 5.02519 2.69227 5.00088 2.71696 4.97658C2.76017 4.93404 2.7972 4.88543 2.82806 4.83074L2.83423 4.81859C3.29098 5.03734 3.5996 5.0495 3.5996 5.0495C3.48233 5.52954 3.53788 5.78475 3.53788 5.78475Z"
                fill="white"/>
              <path
                d="M7.61146 2.60672C8.06204 2.50342 8.42621 2.5095 8.71014 2.49734L7.75343 2.78902C5.67953 3.55466 5.15489 4.73957 3.75377 4.76388C3.42664 4.7578 3.15506 4.67881 2.91434 4.53905V4.50259C2.92051 4.41144 2.91434 4.32637 2.88965 4.2413V4.22915C3.8587 3.75518 6.06839 2.95308 7.61146 2.60672Z"
                fill="white"/>
              <path
                d="M2.69253 2.66756C2.74808 2.81339 2.82215 3.05038 3.03818 3.28128C2.74808 3.52434 2.69253 3.65195 2.59377 3.88893L2.5876 3.88286C2.49501 3.82817 2.39626 3.79779 2.2975 3.79171H2.28516L2.69253 2.66756Z"
                fill="white"/>
              <path
                d="M2.50376 4.76922C2.66339 4.61295 2.66412 4.35887 2.50539 4.20171C2.34665 4.04456 2.08857 4.04384 1.92893 4.20011C1.7693 4.35638 1.76857 4.61046 1.9273 4.76762C2.08604 4.92477 2.34412 4.92549 2.50376 4.76922Z"
                fill="white"/>
              <path
                d="M1.61816 3.07464C1.82802 3.3177 1.92061 3.50607 2.00085 3.83421C1.89592 3.86459 1.77247 3.92535 1.6984 4.02865L0.260254 2.58852C0.809589 2.53991 1.27868 2.66752 1.61816 3.07464Z"
                fill="white"/>
              <path
                d="M19.8516 5.65105V6.24047C19.1171 5.67535 18.3209 5.20139 17.4814 4.8368V4.32637C18.3209 4.66665 19.1109 5.11632 19.8516 5.65105Z"
                fill="white"/>
              <path
                d="M13.4567 3.53035C13.8579 3.53035 14.253 3.55466 14.6418 3.59719V4.07724C14.253 4.02862 13.8579 4.00432 13.4567 4.00432C13.0555 4.00432 12.6667 4.02862 12.2778 4.07116V3.59719C12.6667 3.54858 13.0617 3.53035 13.4567 3.53035Z"
                fill="white"/>
              <path
                d="M9.44487 4.32033V4.83075C8.60544 5.18927 7.81538 5.66324 7.07471 6.22835V5.63893C7.81538 5.11027 8.60544 4.66669 9.44487 4.32033Z"
                fill="white"/>
              <path
                d="M7.07471 29.55V28.9606C7.80921 29.5257 8.60544 29.9997 9.44487 30.3582V30.8686C8.60544 30.5344 7.81538 30.0848 7.07471 29.55Z"
                fill="white"/>
              <path
                d="M13.4567 31.6706C13.0555 31.6706 12.6667 31.6463 12.2778 31.6038V31.1238C12.6667 31.1724 13.0617 31.1906 13.4567 31.1906C13.8579 31.1906 14.253 31.1663 14.6418 31.1177V31.5916C14.253 31.6463 13.8579 31.6706 13.4567 31.6706Z"
                fill="white"/>
              <path
                d="M17.4814 30.8685V30.3581C18.3209 29.9935 19.1109 29.5256 19.8516 28.9544V29.5439C19.1109 30.0847 18.3209 30.5283 17.4814 30.8685Z"
                fill="white"/>
              <path
                d="M40.9349 10.6094H45.8234V16.8135H44.1939L43.947 15.3673C43.3298 16.0722 42.4348 17.1174 40.2992 17.1174C37.4846 17.1174 34.9231 15.1304 34.9231 11.0895C34.9231 7.94792 36.7007 4.98259 40.6387 4.99474C44.2248 4.99474 45.6382 7.28558 45.7678 8.87763H43.3236C43.3236 8.42797 42.4903 6.98784 40.7683 6.98784C39.0277 6.98784 37.4105 8.17275 37.4105 11.1259C37.4105 14.2675 39.1511 15.0878 40.8115 15.0878C41.3485 15.0878 43.1384 14.8812 43.6446 12.5539H40.9226V10.6094H40.9349Z"
                fill="#393B3D"/>
              <path
                d="M53.0386 14.31C52.8596 14.9177 52.2053 15.2397 51.5757 15.2397C49.7364 15.2397 49.6068 13.7996 49.5389 13.1555H55.4828V12.7545C55.4828 8.85941 53.1188 8.05731 51.4091 8.05731C47.6131 8.05731 47.2551 11.3447 47.2551 12.3716C47.2551 15.8839 49.1253 17.0384 51.5696 17.0384C53.0509 17.0384 54.7792 16.3639 55.3779 14.31H53.0386ZM49.6006 11.6971C49.7302 10.573 50.2981 9.89849 51.3782 9.89849C52.1127 9.89849 53.0077 10.3178 53.1373 11.6971H49.6006Z"
                fill="#393B3D"/>
              <path
                d="M64.8336 16.8136H62.556V11.6364C62.556 11.0105 62.5251 9.95318 61.0746 9.95318C60.0624 9.95318 59.2847 10.6277 59.2847 11.928V16.8196H57.0071V8.28214H59.1921V9.5339H59.2229C59.5316 9.02348 60.1858 8.05731 61.8277 8.05731C63.5189 8.05731 64.8397 9.03563 64.8397 10.9133V16.8136H64.8336Z"
                fill="#393B3D"/>
              <path
                d="M72.0496 14.31C71.8706 14.9177 71.2163 15.2397 70.5867 15.2397C68.7474 15.2397 68.6178 13.7996 68.5499 13.1555H74.4938V12.7545C74.4938 8.85941 72.1298 8.05731 70.4201 8.05731C66.6241 8.05731 66.2661 11.3447 66.2661 12.3716C66.2661 15.8839 68.1425 17.0384 70.5806 17.0384C72.0619 17.0384 73.7902 16.3639 74.3889 14.31H72.0496ZM68.6116 11.6971C68.7412 10.573 69.3091 9.89849 70.3892 9.89849C71.1237 9.89849 72.0187 10.3178 72.1483 11.6971H68.6116Z"
                fill="#393B3D"/>
              <path
                d="M75.9873 8.28214H78.1723V9.75873H78.2032C78.6723 8.88979 79.1969 8.05731 80.5795 8.05731C80.7276 8.05731 80.8758 8.07554 81.0177 8.08769V10.3664C80.8202 10.336 80.5795 10.336 80.3635 10.336C78.5858 10.336 78.2649 11.4237 78.2649 12.3716V16.8136H75.9873V8.28214Z"
                fill="#393B3D"/>
              <path
                d="M89.3626 10.5244C89.3626 8.4219 87.1282 8.05731 85.9123 8.05731C84.1346 8.05731 82.2953 8.42798 82.0361 11.0409H84.2334C84.3013 10.5426 84.4926 9.85596 85.6345 9.85596C86.2209 9.85596 87.1344 9.90457 87.1344 10.8525C87.1344 11.3325 86.6961 11.4784 86.3382 11.527L84.2828 11.8308C82.8323 12.0374 81.7583 12.8881 81.7583 14.5592C81.7583 16.3214 83.0915 17.0445 84.4 17.0445C85.9493 17.0445 86.6776 16.3396 87.2023 15.8109C87.2517 16.291 87.2825 16.4186 87.4121 16.8196H89.8687V16.4793C89.591 16.3821 89.3626 16.1573 89.3626 15.1486V10.5244ZM87.1282 13.751C87.1282 14.7901 86.1036 15.4342 85.0913 15.4342C84.6531 15.4342 84.0297 15.1911 84.0297 14.4073C84.0297 13.4776 84.7272 13.271 85.579 13.1251C86.5233 12.9793 86.8998 12.8334 87.1282 12.6572V13.751Z"
                fill="#393B3D"/>
              <path d="M91.4612 5.29857H93.7388V16.8135H91.4612V5.29857Z" fill="#393B3D"/>
              <path
                d="M98.2695 7.27342H95.9919V5.18918H98.2695V7.27342ZM98.2695 8.28212V16.8135H95.9919V8.28212H98.2695Z"
                fill="#393B3D"/>
              <path
                d="M103.01 8.28219H104.429V9.88638H103.01V14.5228C103.01 15.021 103.028 15.2094 103.954 15.2094C104.102 15.2094 104.263 15.1912 104.429 15.179V16.8804C104.071 16.8987 103.713 16.9108 103.355 16.9108H103.059C101.09 16.9108 100.732 16.1756 100.732 15.0636V9.88638H99.5593V8.28219H100.732V5.97311H103.01V8.28219Z"
                fill="#393B3D"/>
              <path
                d="M112.898 10.5244C112.898 8.4219 110.663 8.05731 109.447 8.05731C107.67 8.05731 105.83 8.42798 105.571 11.0409H107.768C107.836 10.5426 108.028 9.85596 109.169 9.85596C109.756 9.85596 110.669 9.90457 110.669 10.8525C110.669 11.3325 110.231 11.4784 109.873 11.527L107.818 11.8308C106.367 12.0374 105.293 12.8881 105.293 14.5592C105.293 16.3214 106.626 17.0445 107.935 17.0445C109.484 17.0445 110.213 16.3396 110.737 15.8109C110.787 16.291 110.817 16.4186 110.947 16.8196H113.404V16.4793C113.126 16.3821 112.898 16.1573 112.898 15.1486V10.5244ZM110.663 13.751C110.663 14.7901 109.639 15.4342 108.626 15.4342C108.188 15.4342 107.565 15.1911 107.565 14.4073C107.565 13.4776 108.262 13.271 109.114 13.1251C110.058 12.9793 110.435 12.8334 110.663 12.6572V13.751Z"
                fill="#393B3D"/>
              <path
                d="M117.49 8.28219H118.91V9.88638H117.49V14.5228C117.49 15.021 117.508 15.2094 118.434 15.2094C118.582 15.2094 118.743 15.1912 118.903 15.179V16.8804C118.545 16.8987 118.187 16.9108 117.829 16.9108H117.533C115.564 16.9108 115.206 16.1756 115.206 15.0636V9.88638H114.033V8.28219H115.206V5.97311H117.484V8.28219H117.49Z"
                fill="#393B3D"/>
              <path
                d="M43.1878 21.3346H40.9041V25.4241H40.8732C40.5152 24.8772 39.8301 24.0933 38.3673 24.0933C36.46 24.0933 34.7688 25.5334 34.7688 28.4866C34.7688 30.8261 35.8428 33.0744 38.4166 33.0744C39.361 33.0744 40.3733 32.7402 40.9226 31.774H40.9535V32.8495H43.1878V21.3346ZM37.1081 28.6507C37.1081 27.3017 37.5957 26.0378 39.0462 26.0378C40.6078 26.0378 41.0028 27.4171 41.0028 28.7783C41.0028 30.0422 40.435 31.2332 38.9845 31.2332C37.5155 31.2271 37.1081 29.6594 37.1081 28.6507Z"
                fill="#393B3D"/>
              <path
                d="M50.3165 30.346C50.1375 30.9536 49.4832 31.2757 48.8475 31.2757C47.0081 31.2757 46.8785 29.8355 46.8106 29.1914H52.7545V28.7904C52.7545 24.8953 50.3905 24.0932 48.6808 24.0932C44.8848 24.0932 44.5269 27.3806 44.5269 28.4075C44.5269 31.9198 46.3971 33.0743 48.8413 33.0743C50.3227 33.0743 52.0509 32.3998 52.6496 30.346H50.3165ZM46.8847 27.7331C47.0143 26.6089 47.5821 25.9344 48.6623 25.9344C49.3968 25.9344 50.2918 26.3537 50.4214 27.7331H46.8847Z"
                fill="#393B3D"/>
              <path
                d="M66.4449 25.1019C66.2474 24.4153 65.8771 23.1149 63.8525 23.1149C62.6798 23.1149 60.9516 23.8866 60.9516 27.1375C60.9516 29.2035 61.7848 31.069 63.8525 31.069C65.2043 31.069 66.1486 30.3155 66.4449 28.9058H68.8891C68.4015 31.4093 66.7412 33.1533 63.8093 33.1533C60.6985 33.1533 58.4641 31.0873 58.4641 27.1071C58.4641 23.0845 60.8281 21.0306 63.8402 21.0306C67.3399 21.0306 68.7595 23.4066 68.8891 25.1019H66.4449Z"
                fill="#393B3D"/>
              <path
                d="M77.5859 26.5603C77.5859 24.4578 75.3515 24.0932 74.1356 24.0932C72.358 24.0932 70.5186 24.4639 70.2594 27.0768H72.4567C72.5246 26.5785 72.716 25.8918 73.8578 25.8918C74.4442 25.8918 75.3577 25.9405 75.3577 26.8884C75.3577 27.3684 74.9195 27.5143 74.5615 27.5629L72.5123 27.8667C71.0618 28.0733 69.9878 28.924 69.9878 30.5951C69.9878 32.3572 71.321 33.0804 72.6234 33.0804C74.1726 33.0804 74.901 32.3755 75.4256 31.8468C75.475 32.3269 75.5058 32.4545 75.6355 32.8555H78.092V32.5213C77.8143 32.4241 77.5859 32.1993 77.5859 31.1906V26.5603ZM75.3515 29.7869C75.3515 30.826 74.3269 31.4701 73.3147 31.4701C72.8764 31.4701 72.253 31.227 72.253 30.4431C72.253 29.5134 72.9505 29.3068 73.8023 29.161C74.7466 29.0152 75.1232 28.8693 75.3515 28.6931V29.7869Z"
                fill="#393B3D"/>
              <path
                d="M82.1779 24.3181H83.5975V25.9223H82.1779V30.5586C82.1779 31.0569 82.1964 31.2453 83.1222 31.2453C83.2704 31.2453 83.4308 31.2271 83.5913 31.2149V32.9163C83.2333 32.9346 82.8753 32.9467 82.5173 32.9467H82.2272C80.2583 32.9467 79.9003 32.2115 79.9003 31.0995V25.9223H78.7275V24.3181H79.9003V22.009H82.1779V24.3181Z"
                fill="#393B3D"/>
              <path
                d="M92.066 26.5603C92.066 24.4578 89.8316 24.0932 88.6156 24.0932C86.838 24.0932 84.9987 24.4639 84.7394 27.0768H86.9368C87.0047 26.5785 87.196 25.8918 88.3379 25.8918C88.9243 25.8918 89.8378 25.9405 89.8378 26.8884C89.8378 27.3684 89.3995 27.5143 89.0415 27.5629L86.9861 27.8667C85.5357 28.0733 84.4617 28.924 84.4617 30.5951C84.4617 32.3572 85.7949 33.0804 87.1034 33.0804C88.6527 33.0804 89.381 32.3755 89.9057 31.8468C89.955 32.3269 89.9859 32.4545 90.1155 32.8555H92.5721V32.5213C92.2943 32.4241 92.066 32.1993 92.066 31.1906V26.5603ZM89.8316 29.7869C89.8316 30.826 88.807 31.4701 87.7947 31.4701C87.3565 31.4701 86.7331 31.227 86.7331 30.4431C86.7331 29.5134 87.4306 29.3068 88.2823 29.161C89.2267 29.0152 89.6032 28.8693 89.8316 28.6931V29.7869Z"
                fill="#393B3D"/>
              <path d="M94.1648 21.3345H96.4424V32.8495H94.1648V21.3345Z" fill="#393B3D"/>
              <path
                d="M106.447 32.8494H104.262V31.6463H104.231C103.713 32.5578 102.799 33.0743 101.596 33.0743C99.8861 33.0743 98.6455 32.1142 98.6455 29.9327V24.318H100.923V29.6107C100.923 30.9232 101.707 31.1845 102.404 31.1845C103.151 31.1845 104.164 30.7652 104.164 29.2461V24.3241H106.441V32.8494H106.447Z"
                fill="#393B3D"/>
              <path
                d="M116.416 32.8494H114.138V27.6723C114.138 27.0464 114.107 25.9891 112.657 25.9891C111.645 25.9891 110.867 26.6636 110.867 27.9639V32.8555H108.589V24.318H110.774V25.5698H110.805C111.114 25.0594 111.768 24.0932 113.41 24.0932C115.101 24.0932 116.422 25.0715 116.422 26.9492V32.8494H116.416Z"
                fill="#393B3D"/>
              <path
                d="M122.952 32.7036C121.878 35.8634 121.582 36.2766 119.595 36.2766C119.286 36.2766 118.897 36.2584 118.57 36.2462V34.4476C118.669 34.4658 118.817 34.4779 119.008 34.4779C119.842 34.4779 120.292 34.3686 120.508 33.1958L117.317 24.318H119.86L121.718 30.6011H121.749L123.526 24.318H125.94L122.952 32.7036Z"
                fill="#393B3D"/>
              <path
                d="M133.803 26.5603C133.803 24.4578 131.575 24.0932 130.353 24.0932C128.575 24.0932 126.736 24.4639 126.476 27.0768H128.674C128.742 26.5785 128.933 25.8918 130.075 25.8918C130.661 25.8918 131.575 25.9405 131.575 26.8884C131.575 27.3684 131.137 27.5143 130.779 27.5629L128.729 27.8667C127.279 28.0733 126.205 28.924 126.205 30.5951C126.205 32.3572 127.538 33.0804 128.847 33.0804C130.396 33.0804 131.124 32.3755 131.649 31.8468C131.698 32.3269 131.729 32.4545 131.859 32.8555H134.315V32.5213C134.037 32.4241 133.809 32.1993 133.809 31.1906V26.5603H133.803ZM131.569 29.7869C131.569 30.826 130.544 31.4701 129.532 31.4701C129.093 31.4701 128.47 31.227 128.47 30.4431C128.47 29.5134 129.168 29.3068 130.019 29.161C130.964 29.0152 131.34 28.8693 131.569 28.6931V29.7869Z"
                fill="#393B3D"/>
              <path
                d="M158.009 5.07155H162.377L168.553 21.321H164.034L163.03 18.4158H157.306L156.252 21.321H151.833L158.009 5.07155ZM158.31 15.2644H162.076L160.218 9.55247H160.168L158.31 15.2644Z"
                fill="#241F0C"/>
              <path
                d="M180.804 10.8819C180.553 9.25694 179.297 8.3706 177.49 8.3706C174.728 8.3706 173.624 10.7834 173.624 13.1962C173.624 15.609 174.678 18.0218 177.49 18.0218C179.498 18.0218 180.653 16.8893 180.804 15.0181H185.122C184.87 19.2036 181.758 21.6656 177.59 21.6656C172.569 21.6656 169.356 17.9233 169.356 13.1962C169.356 8.46908 172.569 4.72678 177.59 4.72678C181.155 4.72678 185.021 6.94262 185.122 10.8819H180.804Z"
                fill="#241F0C"/>
              <path
                d="M198.427 10.8819C198.176 9.25694 196.921 8.3706 195.113 8.3706C192.352 8.3706 191.247 10.7834 191.247 13.1962C191.247 15.609 192.302 18.0218 195.113 18.0218C197.122 18.0218 198.276 16.8893 198.427 15.0181H202.745C202.494 19.2036 199.381 21.6656 195.214 21.6656C190.193 21.6656 186.979 17.9233 186.979 13.1962C186.979 8.46908 190.143 4.72678 195.164 4.72678C198.728 4.72678 202.594 6.94262 202.695 10.8819H198.427Z"
                fill="#241F0C"/>
              <path d="M205.004 5.07155H209.322V21.321H205.004V5.07155Z" fill="#241F0C"/>
              <path
                d="M219.866 4.72683C225.088 4.72683 228 8.46913 228 13.1963C228 17.9234 225.038 21.6657 219.866 21.6657C214.644 21.6657 211.732 17.9234 211.732 13.1963C211.732 8.46913 214.644 4.72683 219.866 4.72683ZM219.866 18.0219C222.627 18.0219 223.732 15.6091 223.732 13.1963C223.732 10.7835 222.678 8.37065 219.866 8.37065C217.105 8.37065 216 10.7835 216 13.1963C216 15.6091 217.054 18.0219 219.866 18.0219ZM223.883 0.689072L220.268 4.08669H217.506L219.766 0.689072H223.883Z"
                fill="#241F0C"/>
              <path
                d="M154.093 28.7564C154.444 28.7564 154.745 28.8549 154.896 29.0519C154.996 29.1503 155.097 29.3473 155.147 29.5935H156.201C156.201 29.2981 156.051 29.0026 155.85 28.7072C155.448 28.1655 154.896 27.9193 154.042 27.9193C153.44 27.9193 152.938 28.1163 152.536 28.5102C152.084 28.9534 151.833 29.5935 151.833 30.4798C151.833 31.2677 152.034 31.8586 152.436 32.3018C152.837 32.7449 153.39 32.9911 154.093 32.9911C154.645 32.9911 155.147 32.8434 155.498 32.4987C155.85 32.1048 156.051 31.7109 156.151 31.1692H155.147C155.097 31.4154 154.996 31.6124 154.896 31.7109C154.695 31.9571 154.444 32.0555 154.093 32.0555C153.741 32.0555 153.44 31.9078 153.239 31.6616C153.038 31.4154 152.888 30.9722 152.888 30.4306C152.888 29.8889 152.988 29.4458 153.189 29.1503C153.44 28.9041 153.691 28.7564 154.093 28.7564Z"
                fill="#241F0C"/>
              <path
                d="M159.967 32.548C159.917 32.4988 159.917 32.4003 159.917 32.3018C159.917 32.1541 159.917 32.0064 159.917 31.9079V30.2829C159.917 29.8398 159.766 29.5443 159.465 29.3966C159.164 29.2489 158.812 29.1504 158.41 29.1504C157.808 29.1504 157.356 29.2981 157.105 29.6428C156.954 29.8398 156.854 30.086 156.854 30.4307H157.758C157.758 30.2829 157.808 30.1845 157.908 30.086C158.009 29.9875 158.159 29.9382 158.41 29.9382C158.611 29.9382 158.762 29.9875 158.862 30.0367C158.963 30.086 159.013 30.1845 159.013 30.3322C159.013 30.4307 158.963 30.5291 158.812 30.5784C158.712 30.6276 158.611 30.6276 158.41 30.6769L158.059 30.7261C157.708 30.7753 157.406 30.8738 157.205 30.9723C156.854 31.1693 156.703 31.4647 156.703 31.9079C156.703 32.2526 156.804 32.4988 157.005 32.6957C157.205 32.8927 157.507 32.9912 157.808 32.9912C158.059 32.9912 158.31 32.9419 158.511 32.7942C158.662 32.6957 158.812 32.5973 158.963 32.4495C158.963 32.548 158.963 32.5973 159.013 32.6465C159.013 32.6957 159.063 32.7942 159.063 32.8435H160.118V32.6957C160.017 32.6465 159.967 32.5973 159.967 32.548ZM158.963 31.4155C158.963 31.7109 158.862 31.9571 158.712 32.0556C158.561 32.1541 158.36 32.2526 158.159 32.2526C158.009 32.2526 157.908 32.2033 157.808 32.1541C157.708 32.1048 157.657 31.9571 157.657 31.8094C157.657 31.6124 157.708 31.514 157.858 31.4155C157.959 31.3662 158.109 31.317 158.31 31.2677L158.511 31.2185C158.611 31.2185 158.712 31.1693 158.762 31.1693C158.812 31.1693 158.862 31.12 158.963 31.0708V31.4155Z"
                fill="#241F0C"/>
              <path
                d="M161.825 28.264H160.871V29.2488H160.369V29.9382H160.871V32.154C160.871 32.4002 160.921 32.5479 161.021 32.6464C161.172 32.7941 161.473 32.8926 161.925 32.8926H162.377V32.2032C162.327 32.2032 162.327 32.2032 162.277 32.2032C162.226 32.2032 162.226 32.2032 162.176 32.2032C161.975 32.2032 161.875 32.2033 161.825 32.154C161.774 32.1048 161.774 32.0063 161.774 31.8586V29.9874H162.377V29.298H161.774V28.264H161.825Z"
                fill="#241F0C"/>
              <path
                d="M165.038 32.4002C165.038 32.4987 165.038 32.548 165.088 32.5972C165.088 32.6464 165.138 32.7449 165.138 32.7942H166.193V32.6957C166.143 32.6464 166.092 32.6464 166.042 32.5972C165.992 32.548 165.992 32.4495 165.992 32.351C165.992 32.2033 165.992 32.0556 165.992 31.9571V30.3321C165.992 29.889 165.841 29.5935 165.54 29.4458C165.239 29.2981 164.887 29.1996 164.486 29.1996C163.883 29.1996 163.431 29.3473 163.18 29.692C163.03 29.889 162.929 30.1352 162.929 30.4798H163.833C163.833 30.3321 163.883 30.2336 163.984 30.1352C164.084 30.0367 164.235 29.9874 164.486 29.9874C164.687 29.9874 164.837 30.0367 164.938 30.0859C165.038 30.1352 165.088 30.2336 165.088 30.3814C165.088 30.4798 165.038 30.5783 164.887 30.6276C164.787 30.6768 164.687 30.6768 164.486 30.7261L164.134 30.7753C163.783 30.8245 163.481 30.8738 163.281 31.0215C162.929 31.2185 162.779 31.5139 162.779 31.9571C162.779 32.3018 162.879 32.548 163.08 32.7449C163.281 32.9419 163.582 33.0404 163.883 33.0404C164.134 33.0404 164.385 32.9911 164.586 32.8434C164.787 32.6464 164.938 32.548 165.038 32.4002ZM163.833 32.154C163.733 32.1048 163.682 31.9571 163.682 31.8094C163.682 31.6124 163.733 31.5139 163.883 31.4154C163.984 31.3662 164.134 31.3169 164.335 31.2677L164.536 31.2185C164.636 31.2185 164.737 31.1692 164.787 31.1692C164.837 31.1692 164.887 31.12 164.988 31.0707V31.4154C164.988 31.7109 164.887 31.9571 164.737 32.0556C164.586 32.154 164.385 32.2525 164.184 32.2525C164.034 32.2525 163.933 32.2033 163.833 32.154Z"
                fill="#241F0C"/>
              <path d="M167.799 27.9688H166.845V32.7944H167.799V27.9688Z" fill="#241F0C"/>
              <path
                d="M170.36 32.9419C170.962 32.9419 171.465 32.745 171.766 32.4003C172.067 32.0064 172.218 31.5632 172.218 31.0708C172.218 30.5784 172.067 30.086 171.766 29.7413C171.465 29.3474 171.013 29.1504 170.36 29.1504C169.757 29.1504 169.255 29.3474 168.954 29.7413C168.653 30.1352 168.502 30.5784 168.502 31.0708C168.502 31.6124 168.653 32.0556 168.954 32.4003C169.255 32.745 169.707 32.9419 170.36 32.9419ZM169.707 30.1845C169.858 29.9875 170.059 29.889 170.36 29.889C170.661 29.889 170.862 29.9875 171.013 30.1845C171.163 30.3814 171.213 30.6769 171.213 31.0215C171.213 31.3662 171.163 31.6617 171.013 31.8586C170.862 32.0556 170.661 32.1541 170.36 32.1541C170.059 32.1541 169.858 32.0556 169.707 31.8586C169.557 31.6617 169.506 31.3662 169.506 31.0215C169.456 30.6769 169.557 30.3814 169.707 30.1845Z"
                fill="#241F0C"/>
              <path
                d="M173.875 30.8738C173.875 30.6769 173.925 30.4799 173.975 30.3322C174.075 30.086 174.327 29.9382 174.628 29.9382C174.879 29.9382 175.08 30.0367 175.18 30.2337C175.23 30.3322 175.28 30.4799 175.28 30.6769V32.8435H176.234V30.4307C176.234 29.9875 176.134 29.6428 175.883 29.4458C175.632 29.2489 175.331 29.1504 174.979 29.1504C174.678 29.1504 174.427 29.1996 174.226 29.3474C174.126 29.4458 174.025 29.5443 173.875 29.7413V29.2489H172.921V32.7942H173.875V30.8738Z"
                fill="#241F0C"/>
              <path d="M178.042 29.2488H177.088V32.8434H178.042V29.2488Z" fill="#241F0C"/>
              <path d="M178.042 27.9688H177.088V28.8551H178.042V27.9688Z" fill="#241F0C"/>
              <path
                d="M180.804 30.5783C180.703 30.6276 180.603 30.6276 180.402 30.6768L180.05 30.7261C179.699 30.7753 179.398 30.8738 179.197 30.9723C178.845 31.1692 178.695 31.4647 178.695 31.9078C178.695 32.2525 178.795 32.4987 178.996 32.6957C179.197 32.8927 179.498 32.9911 179.799 32.9911C180.05 32.9911 180.302 32.9419 180.502 32.7942C180.653 32.6957 180.804 32.5972 180.954 32.4495C180.954 32.548 180.954 32.5972 181.004 32.6464C181.004 32.6957 181.055 32.7942 181.055 32.8434H182.109V32.6957C182.059 32.6464 182.009 32.6464 181.958 32.5972C181.908 32.548 181.908 32.4495 181.908 32.351C181.908 32.2033 181.908 32.0556 181.908 31.9571V30.3321C181.908 29.889 181.758 29.5935 181.456 29.4458C181.155 29.2981 180.804 29.1996 180.402 29.1996C179.799 29.1996 179.348 29.3473 179.096 29.692C178.946 29.889 178.845 30.1352 178.845 30.4798H179.749C179.749 30.3321 179.799 30.2336 179.9 30.1352C180 30.0367 180.151 29.9874 180.402 29.9874C180.603 29.9874 180.753 30.0367 180.854 30.0859C180.954 30.1352 181.004 30.2336 181.004 30.3814C181.004 30.4306 180.954 30.4798 180.804 30.5783ZM181.004 31.4154C181.004 31.7109 180.904 31.9571 180.753 32.0556C180.603 32.154 180.402 32.2525 180.201 32.2525C180.05 32.2525 179.95 32.2033 179.85 32.154C179.749 32.1048 179.699 31.9571 179.699 31.8094C179.699 31.6124 179.749 31.5139 179.9 31.4154C180 31.3662 180.151 31.3169 180.352 31.2677L180.553 31.2185C180.653 31.2185 180.753 31.1692 180.804 31.1692C180.854 31.1692 180.904 31.12 181.004 31.0707V31.4154Z"
                fill="#241F0C"/>
              <path d="M164.185 34.5176H165.641V38.5061H166.695V34.5176H168.201V33.6805H164.185V34.5176Z"
                    fill="#241F0C"/>
              <path
                d="M170.31 34.8623C170.009 34.8623 169.808 34.9115 169.607 35.0592C169.507 35.1577 169.356 35.3054 169.206 35.5516V34.9115H168.302V38.5061H169.256V36.7827C169.256 36.4872 169.306 36.2903 169.356 36.1425C169.507 35.8963 169.758 35.7979 170.109 35.7979C170.159 35.7979 170.159 35.7979 170.21 35.7979C170.26 35.7979 170.31 35.7979 170.36 35.7979V34.8623C170.411 34.8623 170.36 34.8623 170.31 34.8623Z"
                fill="#241F0C"/>
              <path
                d="M174.025 38.2599C173.975 38.2107 173.975 38.1122 173.975 38.0137C173.975 37.866 173.975 37.7182 173.975 37.6198V35.9948C173.975 35.5516 173.824 35.2562 173.523 35.1085C173.222 34.9608 172.87 34.8623 172.469 34.8623C171.866 34.8623 171.414 35.01 171.163 35.3547C171.013 35.5516 170.912 35.7979 170.912 36.1425H171.816C171.816 35.9948 171.866 35.8963 171.966 35.7979C172.067 35.6994 172.218 35.6501 172.469 35.6501C172.669 35.6501 172.82 35.6994 172.92 35.7486C173.021 35.7978 173.071 35.8963 173.071 36.0441C173.071 36.1425 173.021 36.241 172.87 36.2903C172.77 36.3395 172.669 36.3395 172.469 36.3887L172.117 36.438C171.766 36.4872 171.464 36.5365 171.264 36.6842C170.912 36.8811 170.761 37.1766 170.761 37.6198C170.761 37.9645 170.862 38.2107 171.063 38.4076C171.264 38.6046 171.565 38.7031 171.866 38.7031C172.117 38.7031 172.368 38.6538 172.569 38.5061C172.72 38.4076 172.87 38.3091 173.021 38.1614C173.021 38.2599 173.021 38.3091 173.071 38.3584C173.071 38.4076 173.121 38.5061 173.121 38.5553H174.176V38.4076C174.125 38.3584 174.075 38.3091 174.025 38.2599ZM173.021 37.1274C173.021 37.4228 172.92 37.669 172.77 37.7675C172.619 37.866 172.418 37.9644 172.218 37.9644C172.067 37.9644 171.966 37.9152 171.866 37.866C171.766 37.8167 171.715 37.669 171.715 37.5213C171.715 37.3243 171.766 37.2258 171.916 37.1274C172.017 37.0781 172.167 37.0289 172.368 36.9796L172.569 36.9304C172.669 36.9304 172.77 36.8812 172.82 36.8812C172.87 36.8812 172.92 36.8319 173.021 36.7827V37.1274Z"
                fill="#241F0C"/>
              <path
                d="M177.088 35.4039C176.988 35.2562 176.837 35.1085 176.687 35.01C176.536 34.9115 176.335 34.8623 176.084 34.8623C175.582 34.8623 175.231 35.0593 174.929 35.4039C174.628 35.7486 174.478 36.241 174.478 36.8319C174.478 37.3736 174.628 37.8167 174.929 38.1122C175.231 38.4569 175.582 38.6046 175.984 38.6046C176.235 38.6046 176.436 38.5554 176.637 38.4569C176.787 38.3584 176.988 38.2107 177.088 38.0137V38.5061H177.992V33.6805H177.038V35.4039H177.088ZM176.888 37.5705C176.737 37.7675 176.536 37.866 176.285 37.866C176.034 37.866 175.833 37.7675 175.683 37.5705C175.532 37.3736 175.482 37.1274 175.482 36.7827C175.482 36.4872 175.532 36.241 175.683 35.9948C175.833 35.7979 176.034 35.6994 176.285 35.6994C176.486 35.6994 176.637 35.7486 176.787 35.8471C176.988 36.0441 177.139 36.3395 177.139 36.7827C177.139 37.0781 177.038 37.3736 176.888 37.5705Z"
                fill="#241F0C"/>
              <path
                d="M181.958 35.5516C181.808 35.3054 181.607 35.1577 181.306 35.01C181.055 34.9115 180.753 34.8623 180.452 34.8623C179.9 34.8623 179.498 35.01 179.147 35.3547C178.795 35.6994 178.645 36.1425 178.645 36.7827C178.645 37.4228 178.845 37.9152 179.197 38.2107C179.548 38.5061 180 38.6538 180.502 38.6538C181.105 38.6538 181.557 38.4569 181.858 38.1122C182.059 37.9152 182.209 37.669 182.209 37.472H181.255C181.205 37.5705 181.155 37.669 181.055 37.7182C180.904 37.8167 180.753 37.866 180.502 37.866C180.301 37.866 180.101 37.8167 180 37.7182C179.749 37.5705 179.649 37.3243 179.598 36.9796H182.26C182.26 36.6842 182.26 36.438 182.209 36.2903C182.209 35.9948 182.109 35.7486 181.958 35.5516ZM179.649 36.3887C179.699 36.1425 179.749 35.9948 179.9 35.8471C180.05 35.6994 180.201 35.6501 180.452 35.6501C180.653 35.6501 180.854 35.6994 181.004 35.8471C181.155 35.9948 181.255 36.1425 181.255 36.3887H179.649Z"
                fill="#241F0C"/>
              <path d="M193.456 33.6805H192.452V38.5061H193.456V33.6805Z" fill="#241F0C"/>
              <path
                d="M196.368 34.8623C196.067 34.8623 195.816 34.9115 195.615 35.0592C195.515 35.1577 195.414 35.2562 195.264 35.4532V34.9115H194.36V38.4569H195.314V36.5365C195.314 36.3395 195.364 36.1425 195.414 35.9948C195.515 35.7486 195.766 35.6009 196.067 35.6009C196.318 35.6009 196.519 35.6994 196.619 35.8963C196.669 35.9948 196.72 36.1425 196.72 36.3395V38.5061H197.674V36.0933C197.674 35.6501 197.573 35.3054 197.322 35.1085C197.071 34.9608 196.77 34.8623 196.368 34.8623Z"
                fill="#241F0C"/>
              <path
                d="M200.034 37.5706L199.23 34.9608H198.176L199.481 38.5062H200.485L201.791 34.9608H200.787L200.034 37.5706Z"
                fill="#241F0C"/>
              <path
                d="M205.356 35.5516C205.205 35.3054 205.004 35.1577 204.703 35.01C204.452 34.9115 204.151 34.8623 203.849 34.8623C203.297 34.8623 202.895 35.01 202.544 35.3547C202.192 35.6994 202.042 36.1425 202.042 36.7827C202.042 37.4228 202.243 37.9152 202.594 38.2107C202.946 38.5061 203.397 38.6538 203.899 38.6538C204.502 38.6538 204.954 38.4569 205.255 38.1122C205.456 37.9152 205.607 37.669 205.607 37.472H204.653C204.602 37.5705 204.552 37.669 204.452 37.7182C204.301 37.8167 204.151 37.866 203.899 37.866C203.699 37.866 203.498 37.8167 203.397 37.7182C203.146 37.5705 203.046 37.3243 202.996 36.9796H205.657C205.657 36.6842 205.657 36.438 205.607 36.2903C205.607 35.9948 205.506 35.7486 205.356 35.5516ZM203.046 36.3887C203.096 36.1425 203.146 35.9948 203.297 35.8471C203.448 35.6994 203.598 35.6501 203.849 35.6501C204.05 35.6501 204.251 35.6994 204.402 35.8471C204.552 35.9948 204.653 36.1425 204.653 36.3887H203.046Z"
                fill="#241F0C"/>
              <path
                d="M208.117 36.3887C207.565 36.2903 207.214 36.1918 207.113 36.1425C207.013 36.0933 206.963 35.9948 206.963 35.8963C206.963 35.7979 207.013 35.7486 207.113 35.6501C207.214 35.6009 207.364 35.5516 207.565 35.5516C207.816 35.5516 208.017 35.6009 208.117 35.7486C208.168 35.7978 208.218 35.8963 208.218 36.0441H209.172C209.122 35.6009 208.971 35.3054 208.67 35.1085C208.369 34.9115 208.017 34.8623 207.565 34.8623C207.063 34.8623 206.712 34.9608 206.461 35.207C206.21 35.4532 206.059 35.7486 206.059 36.0441C206.059 36.3395 206.159 36.5365 206.31 36.6842C206.461 36.8319 206.762 36.9796 207.164 37.0781C207.716 37.2258 208.067 37.3243 208.168 37.3736C208.268 37.4228 208.318 37.5213 208.318 37.6198C208.318 37.7182 208.268 37.8167 208.168 37.866C208.067 37.9152 207.917 37.9644 207.716 37.9644C207.415 37.9644 207.164 37.9152 207.063 37.7675C207.013 37.7182 206.963 37.5705 206.912 37.4228H205.958C205.958 37.7675 206.109 38.1122 206.36 38.3091C206.611 38.5553 207.063 38.6538 207.615 38.6538C208.168 38.6538 208.62 38.5553 208.871 38.3091C209.122 38.0629 209.272 37.8167 209.272 37.4228C209.272 37.1766 209.172 36.9304 208.971 36.7334C208.82 36.5857 208.519 36.438 208.117 36.3887Z"
                fill="#241F0C"/>
              <path
                d="M211.03 33.976H210.076V34.9608H209.573V35.6502H210.076V37.866C210.076 38.1122 210.126 38.26 210.226 38.3585C210.377 38.5062 210.678 38.6047 211.13 38.6047H211.582V37.9153C211.532 37.9153 211.532 37.9153 211.481 37.9153C211.431 37.9153 211.431 37.9153 211.381 37.9153C211.18 37.9153 211.08 37.9153 211.03 37.866C210.979 37.8168 210.979 37.7183 210.979 37.5706V35.6502H211.582V34.9608H210.979V33.976H211.03Z"
                fill="#241F0C"/>
              <path
                d="M217.205 35.2562C217.055 35.1085 216.954 35.01 216.804 34.9115C216.653 34.8623 216.502 34.8131 216.352 34.8131C216.101 34.8131 215.9 34.8623 215.699 34.9608C215.498 35.0593 215.347 35.207 215.247 35.404C215.197 35.207 215.046 35.1085 214.946 34.9608C214.795 34.8623 214.544 34.7638 214.293 34.7638C213.992 34.7638 213.741 34.8131 213.59 34.9608C213.49 35.0593 213.389 35.1578 213.239 35.3547V34.8131H212.335V38.3584H213.289V36.1918C213.289 35.9948 213.339 35.8471 213.389 35.7486C213.49 35.5517 213.64 35.5024 213.942 35.5024C214.193 35.5024 214.343 35.6009 214.394 35.7486C214.444 35.8471 214.444 35.9948 214.444 36.1918V38.3092H215.398V36.1918C215.398 36.0441 215.448 35.8964 215.498 35.7979C215.599 35.6009 215.799 35.4532 216.05 35.4532C216.301 35.4532 216.452 35.5517 216.502 35.6994C216.553 35.7979 216.553 35.8964 216.553 36.0441V38.3092H217.506V36.0441C217.506 35.7979 217.506 35.6502 217.456 35.5024C217.406 35.5517 217.306 35.404 217.205 35.2562Z"
                fill="#241F0C"/>
              <path
                d="M221.322 35.5516C221.172 35.3054 220.971 35.1577 220.67 35.01C220.419 34.9115 220.117 34.8623 219.816 34.8623C219.264 34.8623 218.862 35.01 218.511 35.3547C218.159 35.6994 218.009 36.1425 218.009 36.7827C218.009 37.4228 218.209 37.9152 218.561 38.2107C218.912 38.5061 219.364 38.6538 219.866 38.6538C220.469 38.6538 220.921 38.4569 221.222 38.1122C221.423 37.9152 221.573 37.669 221.573 37.472H220.619C220.569 37.5705 220.519 37.669 220.419 37.7182C220.268 37.8167 220.117 37.866 219.866 37.866C219.665 37.866 219.465 37.8167 219.364 37.7182C219.113 37.5705 219.013 37.3243 218.963 36.9796H221.624C221.624 36.6842 221.624 36.438 221.573 36.2903C221.573 35.9948 221.473 35.7486 221.322 35.5516ZM219.013 36.3887C219.063 36.1425 219.113 35.9948 219.264 35.8471C219.414 35.6994 219.565 35.6501 219.816 35.6501C220.017 35.6501 220.218 35.6994 220.368 35.8471C220.519 35.9948 220.619 36.1425 220.619 36.3887H219.013Z"
                fill="#241F0C"/>
              <path
                d="M224.184 34.8623C223.883 34.8623 223.632 34.9115 223.431 35.0592C223.331 35.1577 223.23 35.2562 223.08 35.4532V34.9115H222.176V38.4569H223.13V36.5365C223.13 36.3395 223.18 36.1425 223.23 35.9948C223.331 35.7486 223.582 35.6009 223.883 35.6009C224.134 35.6009 224.335 35.6994 224.435 35.8963C224.485 35.9948 224.536 36.1425 224.536 36.3395V38.5061H225.49V36.0933C225.49 35.6501 225.389 35.3054 225.138 35.1085C224.837 34.9608 224.536 34.8623 224.184 34.8623Z"
                fill="#241F0C"/>
              <path
                d="M228 35.6502V34.9608H227.397V33.976H226.443V34.9608H225.941V35.6502H226.443V37.866C226.443 38.1122 226.494 38.26 226.594 38.3585C226.745 38.5062 227.046 38.6047 227.498 38.6047H227.95V37.9153C227.9 37.9153 227.9 37.9153 227.849 37.9153C227.799 37.9153 227.799 37.9153 227.749 37.9153C227.548 37.9153 227.448 37.9153 227.397 37.866C227.347 37.8168 227.347 37.7183 227.347 37.5706V35.6502H228Z"
                fill="#241F0C"/>
              <path
                d="M189.992 35.8471C190.192 35.3055 190.343 34.7146 190.443 34.1237H189.339C189.289 34.4191 189.238 34.6653 189.188 34.813C189.138 34.9608 189.088 35.2562 188.937 35.5517L187.23 33.5328C187.732 33.1881 188.134 32.8927 188.335 32.6464C188.736 32.2033 188.887 31.6616 188.887 31.0707C188.887 30.5783 188.686 30.1352 188.335 29.7412C187.983 29.3965 187.431 29.1996 186.778 29.1996C186.075 29.1996 185.523 29.3965 185.121 29.7905C184.72 30.1844 184.519 30.6768 184.519 31.2677C184.519 31.5631 184.569 31.8586 184.72 32.154C184.87 32.4495 185.121 32.8434 185.523 33.2866C184.77 33.7297 184.318 34.0744 184.017 34.3699C183.565 34.8623 183.364 35.4532 183.364 36.1426C183.364 36.7827 183.565 37.3736 184.017 37.9152C184.469 38.4569 185.172 38.7031 186.176 38.7031C186.828 38.7031 187.431 38.5554 187.933 38.2599C188.234 38.0629 188.536 37.8167 188.887 37.4228L189.791 38.5061H191.297L189.64 36.4872C189.741 36.4872 189.841 36.241 189.992 35.8471ZM185.824 30.5783C186.025 30.2829 186.326 30.0859 186.828 30.0859C187.13 30.0859 187.381 30.1844 187.582 30.3814C187.782 30.5783 187.883 30.8245 187.883 31.0707C187.883 31.4154 187.732 31.7601 187.481 32.0063C187.331 32.2033 187.029 32.4002 186.628 32.6957C186.276 32.3018 186.025 32.0063 185.925 31.7601C185.774 31.5139 185.724 31.2677 185.724 31.0215C185.674 30.923 185.724 30.7753 185.824 30.5783ZM187.531 37.3736C187.18 37.5705 186.778 37.7183 186.276 37.7183C185.874 37.7183 185.473 37.5705 185.121 37.3243C184.77 37.0781 184.569 36.6842 184.569 36.1918C184.569 35.7486 184.72 35.3547 184.971 35.01C185.172 34.813 185.573 34.5176 186.176 34.0744L188.335 36.635C188.134 36.9304 187.883 37.1766 187.531 37.3736Z"
                fill="#241F0C"/>
            </svg>

          </div>

        </div>
        <p class="scroll-down" @click="next()">
          <svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.44015 0H4.93235V12.1843L1.06618 8.31816L0 9.38434L4.62013 14.0045L4.6201 14.0045L5.68628 15.0707L11.3726 9.3844L10.3064 8.31823L6.44015 12.1845V0Z"
                  fill="#009EE0"/>
          </svg>
          scroll down
        </p>
      </section>

      <section id="news">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">
            news
          </h2>
          <div class=" js-scroll fade-in-bottom item item1">
            <div class="col col-svg">
              <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2"
                      d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                      stroke="#009EE0" stroke-width="12"/>
                <path
                  d="M47.3526 17.537C49.6434 21.774 50.4803 26.6457 49.735 31.4043C48.9897 36.1629 46.7033 40.5454 43.2267 43.8791C39.7502 47.2128 35.2757 49.3135 30.49 49.8586C25.7043 50.4038 20.872 49.3633 16.7347 46.8969C12.5975 44.4305 9.38398 40.6745 7.58749 36.2055C5.79101 31.7364 5.51083 26.8013 6.78995 22.1576C8.06908 17.5139 10.8368 13.4183 14.6683 10.4995C18.4998 7.58072 23.1834 6 28 6"
                  stroke="#009EE0" stroke-width="12"/>
              </svg>
            </div>
            <div class="col col-text">
              <p class="m-b-20">
              <span>ICM Farmak S.L. ha sigut beneficiària de la línia d’ajuts
              a inversions empresarials d’alt impacte de creació d’ocupació 2023,</span> impulsada per l’agència per a
                la competitivitat de l’empresa (<a
                href="https://www.accio.gencat.cat" target="_blank">https://www.accio.gencat.cat</a>), per a la Creació
                d’ocupació de personal per una nova planta productiva i de R+D per a productes farmacèutics a Catalunya.
              </p>
              <p>
                Pressupost: <span>1.455.190,00€</span>
              </p>
              <p class="m-b-40">
                Ajut: <span>437.607,00€</span>
              </p>

              <p class="m-b-20">
                <span>ICM Farmak S.L. has been a beneficiary of the line of grants  for high-impact business investments in job creation 2023,</span>
                promoted by the Agency for the Business Competitiveness (<a
                href="https://www.accio.gencat.cat" target="_blank">https://www.accio.gencat.cat</a>) for the creation
                of new employment opportunities for personnel at a new production plant and R&D for pharmaceutical
                products in Catalonia.
              </p>
              <p>
                Budget:<span> 1.455.190,00€</span>
              </p>
              <p>
                Grant:<span> 437.607,00€</span>
              </p>
            </div>
          </div>

          <div class=" js-scroll fade-in-bottom item item1">
            <div class="col col-svg">
              <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2"
                      d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                      stroke="#009EE0" stroke-width="12"/>
                <path
                  d="M37.3671 47.9062C33.0565 49.9346 28.2038 50.509 23.5387 49.5429C18.8736 48.5768 14.6481 46.1225 11.4976 42.5489C8.347 38.9753 6.44161 34.4755 6.06782 29.7261C5.69403 24.9767 6.87205 20.2343 9.42478 16.2118C11.9775 12.1894 15.767 9.10422 20.2236 7.42023C24.6801 5.73624 29.5629 5.5444 34.1378 6.87354C38.7127 8.20268 42.7326 10.981 45.5931 14.7908C48.4535 18.6005 50 23.2359 50 28"
                  stroke="#009EE0" stroke-width="12"/>
              </svg>
            </div>
            <div class="col col-text">
              <p class="m-b-20">
                <span>ICM Farmak S.L. ha sigut beneficiària de la línia d’ajuts a inversions empresarials d’alt impacte en actius fixes 2023, </span>
                impulsada per l’agència per a la competitivitat de l’empresa (<a
                href="https://www.accio.gencat.cat" target="_blank">https://www.accio.gencat.cat</a>), per a la Creació
                d’una nova planta productiva i de R+D per a productes farmacèutics a Catalunya.
              </p>
              <p>
                Inversió: <span>6.252.320,00€</span>
              </p>
              <p class="m-b-40">
                Ajut: <span>500.000,00€</span>
              </p>

              <p class="m-b-20">
                <span>ICM Farmak S.L. has been a beneficiary of the line of grants  for high-impact business investments in fixed assets 2023, </span>
                promoted by the Agency for the Business Competitiveness (<a href="https://www.accio.gencat.cat"
                                                                            target="_blank">https://www.accio.gencat.cat</a>),
                for the creation of a new production plant and R&D for pharmaceutical products in Catalonia.
              </p>
              <p>
                Budget: <span>6.252.320,00€</span>
              </p>
              <p>
                Grant: <span>500.000,00€</span>
              </p>
            </div>
          </div>

          <div class=" js-scroll fade-in-bottom item">
            <div class="col col-svg">
              <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2"
                      d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                      stroke="#009EE0" stroke-width="12"/>
                <path
                  d="M47.3526 17.537C49.6434 21.774 50.4803 26.6457 49.735 31.4043C48.9897 36.1629 46.7033 40.5454 43.2267 43.8791C39.7502 47.2128 35.2757 49.3135 30.49 49.8586C25.7043 50.4038 20.872 49.3633 16.7347 46.8969C12.5975 44.4305 9.38398 40.6745 7.58749 36.2055C5.79101 31.7364 5.51083 26.8013 6.78995 22.1576C8.06908 17.5139 10.8368 13.4183 14.6683 10.4995C18.4998 7.58072 23.1834 6 28 6"
                  stroke="#009EE0" stroke-width="12"/>
              </svg>
            </div>
            <div class="col col-text">
              <p class="m-b-20">
                <span>El projecte “INVERSIONS PRODUCTIVES A LA PLANTA d'ICM FARMAK” de ICM FARMAK, S.L.</span> ha rebut suport en el marc de la línia de subvencions per a projectes d’inversions productives a Catalunya.
              </p>
              <p>
                Pressupost del projecte: <span>1.168.893,94€</span>
              </p>
              <p class="m-b-40">
                Subvenció: <span>224.381,00€</span>
              </p>

              <p class="m-b-20">
                <span>The project "PRODUCTIVE INVESTMENTS AT THE ICM FARMAK PLANT" by ICM FARMAK, S.L.</span> has received support under the grant line for productive investment projects in Catalonia.
              </p>
              <p>
                Project budget: <span>1.168.893,94€</span>
              </p>
              <p>
                Grant: <span>224.381,00€</span>
              </p>
            </div>
          </div>

          <div class="sep">
            <img src="@/assets/img/circle-img-news.png" alt="">

          </div>
        </div>
      </section>

      <section id="values">
        <div class="content js-scroll fade-in-bottom">
          <h2 class=" ">VALUES</h2>

          <div class="button-wrapper ">
            <div class=" item item1">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>QUALITY</p>
            </div>
            <div class=" item item2">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>PARTNERSHIP</p>
            </div>
            <div class=" item item3">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>INNOVATIONS</p>
            </div>
            <div class=" item item4">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>EXPANSION</p>
            </div>
            <div class=" item item5">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>SUSTAINABILITY</p>
            </div>
          </div>

          <div class="our-mission ">
            <div class="blue">
              <h3>Our mission</h3>
              <p>Providing easy access to effective, high-quality medicines to contribute to the health of society</p>
            </div>
            <div class="line1 line js-scroll width-animation2 delay-width1"></div>
            <div class="line2 line js-scroll width-animation2 delay-width2"></div>
            <div class="line3 line js-scroll width-animation2 delay-width3"></div>
          </div>

          <div class="purpose ">
            <div class="line1 line js-scroll width-animation2 delay-width3"></div>
            <div class="line2 line js-scroll width-animation2 delay-width2"></div>
            <div class="line3 line js-scroll width-animation2 delay-width1"></div>
            <div class="white">
              <h3>PURPOSE & AMBITION</h3>
              <p>Become a strong global partner in the specialty care sector while maintaining high standards of
                quality, innovation, and social responsibility</p>
            </div>
          </div>

        </div>
      </section>

      <section id="icm-farmak">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">ICM FARMAK</h2>
          <div class="item-wrapper">
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M41.0047 100.5H124.495V52.7119H41.0047V62.5506" stroke="#009EE0" stroke-width="2"/>
                  <rect x="4.5047" y="27.5" width="36.2075" height="73" stroke="#009EE0" stroke-width="2"/>
                  <rect x="41.2972" y="63.5849" width="71.5849" height="32.2744" stroke="#009EE0" stroke-width="2"/>
                  <rect x="41.2972" y="80.566" width="71.5849" height="5.78302" stroke="#009EE0" stroke-width="2"/>
                  <rect x="86.1656" y="68.3812" width="17.4441" height="5.17761" fill="#009EE0"/>
                  <rect x="41.5047" y="84.5" width="71" height="2" stroke="#009EE0" stroke-width="2"/>
                  <path d="M4.91986 37.8208H41.3585" stroke="#009EE0" stroke-width="2"/>
                  <path d="M11.483 100.792L11.483 27.9151" stroke="#009EE0" stroke-width="2"/>
                  <path d="M18.9 100.792L18.9 27.9151" stroke="#009EE0" stroke-width="2"/>
                  <path d="M26.3169 100.792L26.3169 27.9151" stroke="#009EE0" stroke-width="2"/>
                  <path d="M33.7339 100.792L33.7339 27.9151" stroke="#009EE0" stroke-width="2"/>
                  <path d="M4.91986 48.434H41.3585" stroke="#009EE0" stroke-width="2"/>
                  <path d="M4.91986 59.0472H41.3585" stroke="#009EE0" stroke-width="2"/>
                  <path d="M4.91986 69.6604H41.3585" stroke="#009EE0" stroke-width="2"/>
                  <path d="M4.91986 80.2736H41.3585" stroke="#009EE0" stroke-width="2"/>
                  <path d="M4.91986 90.8868H41.3585" stroke="#009EE0" stroke-width="2"/>
                </svg>
              </div>
              <div class="text-wrapper">
                <p class="color-text">EU-CDMO</p>
                <p class="black-text">MANUFACTURING OF STERILE MEDICINES IN VIALS AND SYRINGES</p>
              </div>
            </div>
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M100.992 76.7097H106.992V111C106.992 112.657 105.649 114 103.992 114C102.335 114 100.992 112.657 100.992 111V76.7097Z"
                    stroke="#009EE0" stroke-width="2"/>
                  <path
                    d="M100.992 91.983H106.992V111C106.992 112.657 105.649 114 103.992 114C102.335 114 100.992 112.657 100.992 111V91.983Z"
                    stroke="#009EE0" stroke-width="2"/>
                  <rect x="97.9922" y="71.7097" width="12" height="4" rx="2" stroke="#009EE0" stroke-width="2"/>
                  <path
                    d="M84.5416 76.7097H90.5416V111C90.5416 112.657 89.1985 114 87.5416 114C85.8848 114 84.5416 112.657 84.5416 111V76.7097Z"
                    stroke="#009EE0" stroke-width="2"/>
                  <path
                    d="M84.5416 91.983H90.5416V111C90.5416 112.657 89.1985 114 87.5416 114C85.8848 114 84.5416 112.657 84.5416 111V91.983Z"
                    stroke="#009EE0" stroke-width="2"/>
                  <rect x="81.5416" y="71.7097" width="12" height="4" rx="2" stroke="#009EE0" stroke-width="2"/>
                  <path
                    d="M68.0911 76.7097H74.0911V111C74.0911 112.657 72.7479 114 71.0911 114C69.4342 114 68.0911 112.657 68.0911 111V76.7097Z"
                    stroke="#009EE0" stroke-width="2"/>
                  <path
                    d="M68.0911 91.983H74.0911V111C74.0911 112.657 72.7479 114 71.0911 114C69.4342 114 68.0911 112.657 68.0911 111V91.983Z"
                    stroke="#009EE0" stroke-width="2"/>
                  <rect x="65.0911" y="71.7097" width="12" height="4" rx="2" stroke="#009EE0" stroke-width="2"/>
                  <rect x="61.5845" y="97.1454" width="49.9155" height="2" stroke="#009EE0" stroke-width="2"/>
                  <mask id="path-11-inside-1_480_143" fill="white">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M28.1335 32C26.4766 32 25.1335 33.3431 25.1335 35C25.1335 36.6569 26.4766 38 28.1335 38H28.6335V69.9313C19.0962 72.7359 12.1335 81.5548 12.1335 92C12.1335 104.703 22.4309 115 35.1335 115C47.836 115 58.1335 104.703 58.1335 92C58.1335 81.5548 51.1708 72.7359 41.6335 69.9313V38H42.1335C43.7903 38 45.1335 36.6569 45.1335 35C45.1335 33.3431 43.7903 32 42.1335 32H28.1335Z"/>
                  </mask>
                  <path
                    d="M28.6335 38H30.6335V36H28.6335V38ZM28.6335 69.9313L29.1977 71.8501L30.6335 71.4279V69.9313H28.6335ZM41.6335 69.9313H39.6335V71.4279L41.0692 71.8501L41.6335 69.9313ZM41.6335 38V36H39.6335V38H41.6335ZM27.1335 35C27.1335 34.4477 27.5812 34 28.1335 34V30C25.3721 30 23.1335 32.2386 23.1335 35H27.1335ZM28.1335 36C27.5812 36 27.1335 35.5523 27.1335 35H23.1335C23.1335 37.7614 25.3721 40 28.1335 40V36ZM28.6335 36H28.1335V40H28.6335V36ZM30.6335 69.9313V38H26.6335V69.9313H30.6335ZM14.1335 92C14.1335 82.4661 20.4884 74.4112 29.1977 71.8501L28.0692 68.0126C17.704 71.0606 10.1335 80.6436 10.1335 92H14.1335ZM35.1335 113C23.5355 113 14.1335 103.598 14.1335 92H10.1335C10.1335 105.807 21.3264 117 35.1335 117V113ZM56.1335 92C56.1335 103.598 46.7315 113 35.1335 113V117C48.9406 117 60.1335 105.807 60.1335 92H56.1335ZM41.0692 71.8501C49.7785 74.4112 56.1335 82.4661 56.1335 92H60.1335C60.1335 80.6436 52.563 71.0606 42.1977 68.0126L41.0692 71.8501ZM39.6335 38V69.9313H43.6335V38H39.6335ZM42.1335 36H41.6335V40H42.1335V36ZM43.1335 35C43.1335 35.5523 42.6858 36 42.1335 36V40C44.8949 40 47.1335 37.7614 47.1335 35H43.1335ZM42.1335 34C42.6858 34 43.1335 34.4477 43.1335 35H47.1335C47.1335 32.2386 44.8949 30 42.1335 30V34ZM28.1335 34H42.1335V30H28.1335V34Z"
                    fill="#009EE0" mask="url(#path-11-inside-1_480_143)"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M84.5979 20.3787C84.6644 20.3966 84.7039 20.4649 84.6861 20.5315C84.6683 20.598 84.5999 20.6374 84.5334 20.6196C84.4669 20.6018 84.4274 20.5334 84.4452 20.4669C84.463 20.4004 84.5314 20.3609 84.5979 20.3787ZM85.1155 18.4469C86.249 18.7506 86.9216 19.9156 86.6179 21.0491C86.357 22.0229 85.4603 22.6565 84.4941 22.6231L82.8652 25.4446C83.7034 26.32 84.0773 27.5992 83.7407 28.8554C83.5609 29.5267 83.202 30.1022 82.7292 30.5443L86.8925 37.7553C86.9296 37.7441 86.967 37.7334 87.0047 37.7233C87.6365 37.554 88.2741 37.5645 88.8632 37.7233L92.5848 31.2773C92.2848 30.7955 92.1774 30.1954 92.3359 29.6039C92.6396 28.4704 93.8046 27.7978 94.9381 28.1015C96.0715 28.4052 96.7441 29.5702 96.4404 30.7037C96.1795 31.6775 95.2828 32.3111 94.3167 32.2777L90.5739 38.7604C90.9375 39.1555 91.2173 39.6381 91.3764 40.1871H94.6354C94.9026 39.6863 95.3687 39.2933 95.9602 39.1348C97.0936 38.8311 98.2587 39.5037 98.5624 40.6371C98.8661 41.7706 98.1934 42.9356 97.06 43.2393C96.0862 43.5003 95.0891 43.0405 94.6349 42.1871H91.377C91.2224 42.7176 90.9469 43.2065 90.5738 43.6134L94.3166 50.0963C95.2828 50.0629 96.1795 50.6966 96.4404 51.6704C96.7441 52.8038 96.0715 53.9689 94.9381 54.2726C93.8046 54.5763 92.6396 53.9036 92.3359 52.7702C92.1774 52.1787 92.2848 51.5785 92.5848 51.0967L88.863 44.6502L88.8609 44.6508C88.1895 44.8307 87.5116 44.8076 86.8922 44.6192L82.7288 51.8304C83.2012 52.2724 83.5598 52.8477 83.7396 53.5186C84.0762 54.7748 83.7022 56.054 82.8641 56.9294L84.493 59.7509C85.4592 59.7175 86.3559 60.3511 86.6168 61.3249C86.9205 62.4584 86.2479 63.6234 85.1144 63.9271C83.981 64.2308 82.8159 63.5582 82.5122 62.4247C82.3537 61.8332 82.4611 61.2331 82.7612 60.7513L81.1318 57.929C79.2418 58.3944 77.3183 57.2638 76.8121 55.3748C76.8022 55.3377 76.7928 55.3005 76.7841 55.2633H68.4583C68.3117 55.8932 67.9928 56.4913 67.5018 56.9823C66.5821 57.902 65.2873 58.2177 64.11 57.9295L62.4811 60.7508C62.9931 61.5709 62.8927 62.6643 62.1799 63.3772C61.3501 64.2069 60.0048 64.2069 59.1751 63.3772C58.3454 62.5474 58.3454 61.2021 59.1751 60.3724C59.6081 59.9394 60.1815 59.7324 60.7488 59.7513L62.3782 56.929C61.0303 55.5248 61.0478 53.2938 62.4305 51.9111C62.4574 51.8842 62.4845 51.8578 62.512 51.832L58.348 44.6197C57.729 44.8076 57.0517 44.8305 56.3809 44.6508L56.3788 44.6502L52.6569 51.0967C52.957 51.5785 53.0644 52.1787 52.9059 52.7702C52.6022 53.9036 51.4371 54.5763 50.3037 54.2726C49.1702 53.9689 48.4976 52.8038 48.8013 51.6704C49.0622 50.6966 49.9589 50.0629 50.9251 50.0963L54.668 43.6134C54.2949 43.2065 54.0194 42.7176 53.8648 42.187H50.6068C50.1527 43.0405 49.1555 43.5002 48.1818 43.2393C47.0483 42.9356 46.3757 41.7706 46.6794 40.6371C46.9831 39.5037 48.1481 38.831 49.2816 39.1347C49.8731 39.2932 50.3391 39.6863 50.6063 40.187H53.8653C54.0245 39.6381 54.3042 39.1555 54.6679 38.7604L50.9251 32.2777C49.9589 32.3111 49.0622 31.6775 48.8013 30.7037C48.4976 29.5702 49.1702 28.4052 50.3037 28.1015C51.4371 27.7978 52.6022 28.4704 52.9059 29.6039C53.0644 30.1954 52.957 30.7955 52.6569 31.2773L56.3785 37.7233C56.9676 37.5645 57.6053 37.554 58.2371 37.7233C58.2743 37.7333 58.3112 37.7438 58.3477 37.7548L62.5116 30.5429C62.4838 30.5168 62.4563 30.4901 62.4291 30.463C61.0464 29.0802 61.0289 26.8492 62.3769 25.445L60.7474 22.6227C60.1802 22.6417 59.6068 22.4346 59.1738 22.0016C58.344 21.1719 58.344 19.8266 59.1738 18.9969C60.0035 18.1671 61.3488 18.1671 62.1785 18.9969C62.8914 19.7097 62.9918 20.8032 62.4798 21.6232L64.1087 24.4446C65.2859 24.1564 66.5808 24.4721 67.5004 25.3917C67.9914 25.8828 68.3103 26.4808 68.457 27.1108H76.7852C76.794 27.0736 76.8033 27.0364 76.8133 26.9992C77.3194 25.1103 79.2429 23.9797 81.1329 24.445L82.7623 21.6227C82.4623 21.1409 82.3548 20.5408 82.5133 19.9493C82.8171 18.8158 83.9821 18.1432 85.1155 18.4469ZM76.8917 29.1108L68.3506 29.1108C68.1784 29.6047 67.895 30.0684 67.5004 30.463C66.6295 31.3339 65.4221 31.6631 64.2967 31.4508L60.0266 38.847C60.773 39.7154 61.0915 40.9256 60.7727 42.1151C60.6283 42.6542 60.3684 43.1315 60.0268 43.5276L64.2969 50.9234C65.4226 50.7106 66.6305 51.0398 67.5018 51.9111C67.8964 52.3057 68.1798 52.7694 68.352 53.2633H76.8905C77.2694 52.1826 78.1582 51.3017 79.3478 50.983C79.8867 50.8386 80.4298 50.825 80.9435 50.9227L85.2138 43.5263C84.8728 43.1305 84.6133 42.6536 84.469 42.1152C84.1504 40.9262 84.4684 39.7166 85.2141 38.8483L80.9436 31.4515C80.4302 31.549 79.8874 31.5353 79.3489 31.391C78.1594 31.0723 77.2705 30.1914 76.8917 29.1108ZM60.5893 61.963C60.638 62.0116 60.717 62.0116 60.7656 61.963C60.8143 61.9143 60.8143 61.8353 60.7656 61.7866C60.717 61.7379 60.638 61.7379 60.5893 61.7866C60.5406 61.8353 60.5406 61.9143 60.5893 61.963ZM50.7331 30.1861C50.7153 30.1195 50.7548 30.0512 50.8213 30.0333C50.8878 30.0155 50.9562 30.055 50.974 30.1215C50.9918 30.188 50.9524 30.2564 50.8859 30.2742C50.8193 30.2921 50.751 30.2526 50.7331 30.1861ZM48.6112 41.1548C48.5934 41.2213 48.6329 41.2896 48.6994 41.3075C48.7659 41.3253 48.8343 41.2858 48.8521 41.2193C48.8699 41.1528 48.8305 41.0844 48.7639 41.0666C48.6974 41.0488 48.629 41.0882 48.6112 41.1548ZM50.7331 52.188C50.7153 52.2545 50.7548 52.3229 50.8213 52.3407C50.8878 52.3585 50.9562 52.3191 50.974 52.2525C50.9918 52.186 50.9524 52.1176 50.8859 52.0998C50.8193 52.082 50.751 52.1215 50.7331 52.188ZM94.5086 30.1861C94.5264 30.1195 94.4869 30.0512 94.4204 30.0333C94.3539 30.0155 94.2855 30.055 94.2677 30.1215C94.2499 30.188 94.2894 30.2564 94.3559 30.2742C94.4224 30.2921 94.4908 30.2526 94.5086 30.1861ZM96.6305 41.1548C96.6483 41.2213 96.6089 41.2897 96.5423 41.3075C96.4758 41.3253 96.4075 41.2858 96.3896 41.2193C96.3718 41.1528 96.4113 41.0844 96.4778 41.0666C96.5443 41.0488 96.6127 41.0883 96.6305 41.1548ZM94.5086 52.188C94.5264 52.2545 94.4869 52.3229 94.4204 52.3407C94.3539 52.3585 94.2855 52.3191 94.2677 52.2525C94.2499 52.186 94.2894 52.1177 94.3559 52.0998C94.4224 52.082 94.4908 52.1215 94.5086 52.188ZM60.7643 20.4111C60.7156 20.3624 60.6367 20.3624 60.588 20.4111C60.5393 20.4598 60.5393 20.5387 60.588 20.5874C60.6367 20.6361 60.7156 20.6361 60.7643 20.5874C60.813 20.5387 60.813 20.4598 60.7643 20.4111ZM84.685 61.8426C84.7028 61.9091 84.6633 61.9774 84.5968 61.9953C84.5303 62.0131 84.4619 61.9736 84.4441 61.9071C84.4263 61.8406 84.4657 61.7722 84.5322 61.7544C84.5988 61.7366 84.6671 61.776 84.685 61.8426Z"
                        fill="#009EE0"/>
                  <path
                    d="M13.1335 92C13.1335 91.6551 13.1414 91.3122 13.1571 90.9713H57.1099C57.1256 91.3122 57.1335 91.6551 57.1335 92C57.1335 104.15 47.2837 114 35.1335 114C22.9832 114 13.1335 104.15 13.1335 92Z"
                    stroke="#009EE0" stroke-width="2"/>
                </svg>
              </div>
              <div class="text-wrapper">
                <p class="color-text">RESEARCH & DEVELOPMENT
                  CENTER</p>
                <p class="black-text">SHARING OF KNOWLEDGE & TECHNOLOGICAL PROCESS IMPROVEMENTS</p>
              </div>
            </div>
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.3392 54.577C14.6485 55.0345 15.2702 55.1546 15.7277 54.8453L23.1834 49.8041C23.6409 49.4948 23.761 48.8731 23.4517 48.4156C23.1423 47.9581 22.5207 47.838 22.0631 48.1473L15.4359 52.6283L10.9549 46.0011C10.6455 45.5435 10.0239 45.4234 9.56634 45.7328C9.10882 46.0421 8.98871 46.6638 9.29806 47.1213L14.3392 54.577ZM34.4728 23.2042L35.0718 24.005L34.4728 23.2042ZM69.4829 13.3862L69.3876 14.3816L69.4829 13.3862ZM101.995 29.6675L101.255 30.3401L101.995 29.6675ZM16.1494 54.2066C18.4815 42.1365 25.2279 31.3687 35.0718 24.005L33.8738 22.4035C23.6316 30.0652 16.6122 41.2687 14.1858 53.8272L16.1494 54.2066ZM35.0718 24.005C44.9156 16.6413 57.1503 13.2103 69.3876 14.3816L69.5782 12.3907C56.8457 11.172 44.1159 14.7418 33.8738 22.4035L35.0718 24.005ZM69.3876 14.3816C81.625 15.553 92.9867 21.2427 101.255 30.3401L102.735 28.9949C94.1321 19.5294 82.3108 13.6095 69.5782 12.3907L69.3876 14.3816ZM101.255 30.3401C109.523 39.4375 114.104 51.2896 114.104 63.5829H116.104C116.104 50.7921 111.338 38.4604 102.735 28.9949L101.255 30.3401Z"
                    fill="#009EE0"/>
                  <path
                    d="M114.529 72.5887C114.22 72.1312 113.598 72.0111 113.14 72.3205L105.685 77.3616C105.227 77.6709 105.107 78.2926 105.416 78.7501C105.726 79.2076 106.347 79.3278 106.805 79.0184L113.432 74.5374L117.913 81.1647C118.223 81.6222 118.844 81.7423 119.302 81.4329C119.759 81.1236 119.879 80.5019 119.57 80.0444L114.529 72.5887ZM94.3953 103.961L93.7963 103.161L94.3953 103.961ZM59.3851 113.78L59.4804 112.784L59.3851 113.78ZM26.8732 97.4982L27.6133 96.8256L26.8732 97.4982ZM112.719 72.9592C110.387 85.0292 103.64 95.797 93.7963 103.161L94.9943 104.762C105.236 97.1006 112.256 85.897 114.682 73.3386L112.719 72.9592ZM93.7963 103.161C83.9525 110.524 71.7178 113.955 59.4804 112.784L59.2899 114.775C72.0224 115.994 84.7522 112.424 94.9943 104.762L93.7963 103.161ZM59.4804 112.784C47.2431 111.613 35.8814 105.923 27.6133 96.8256L26.1332 98.1708C34.7359 107.636 46.5573 113.556 59.2899 114.775L59.4804 112.784ZM27.6133 96.8256C19.3451 87.7282 14.7639 75.8761 14.7639 63.5829H12.7639C12.7639 76.3736 17.5305 88.7053 26.1332 98.1708L27.6133 96.8256Z"
                    fill="#009EE0"/>
                  <path
                    d="M89.7788 63.5829C89.7788 77.6876 86.8806 90.4075 82.242 99.5643C77.5749 108.777 71.3096 114.107 64.678 114.107C58.0464 114.107 51.7811 108.777 47.114 99.5643C42.4754 90.4075 39.5772 77.6876 39.5772 63.5829C39.5772 49.4782 42.4754 36.7582 47.114 27.6014C51.7811 18.3884 58.0464 13.0583 64.678 13.0583C71.3096 13.0583 77.5749 18.3884 82.242 27.6014C86.8806 36.7582 89.7788 49.4782 89.7788 63.5829Z"
                    stroke="#009EE0" stroke-width="2"/>
                  <path
                    d="M105.341 34.5267C101.395 36.7617 95.7254 38.6699 88.8195 40.0443C81.9245 41.4165 74.0684 42.2026 65.977 42.3257C57.886 42.4488 49.8364 41.9046 42.5726 40.7463C35.3016 39.5869 29.0887 37.8551 24.4877 35.7324"
                    stroke="#009EE0" stroke-width="2"/>
                  <path
                    d="M105.341 92.6389C101.395 90.4038 95.7254 88.4956 88.8195 87.1212C81.9245 85.749 74.0684 84.9629 65.977 84.8398C57.886 84.7168 49.8364 85.2609 42.5726 86.4192C35.3016 87.5787 29.0887 89.3104 24.4877 91.4332"
                    stroke="#009EE0" stroke-width="2"/>
                  <line x1="12.7395" y1="62.5829" x2="116.203" y2="62.5829" stroke="#009EE0" stroke-width="2"/>
                  <line x1="63.678" y1="115.107" x2="63.678" y2="13.1566" stroke="#009EE0" stroke-width="2"/>
                </svg>
              </div>
              <div class="text-wrapper">
                <p class="color-text">EU-IMPORTER</p>
                <p class="black-text">IMPORTING OF FDF COMING FROM OTHER COUNTRIES</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section id="eu-cdmo">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">
            EU-CDMO
          </h2>
          <h3 class="js-scroll fade-in-bottom">MANUFACTURING OF STERILE MEDICINES IN VIALS AND SYRINGES</h3>

          <div class="item-wrapper">
            <div class="js-scroll fade-in-bottom item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M47.3526 17.537C49.6434 21.774 50.4803 26.6457 49.735 31.4043C48.9897 36.1629 46.7033 40.5454 43.2267 43.8791C39.7502 47.2128 35.2757 49.3135 30.49 49.8586C25.7043 50.4038 20.872 49.3633 16.7347 46.8969C12.5975 44.4305 9.38398 40.6745 7.58749 36.2055C5.79101 31.7364 5.51083 26.8013 6.78995 22.1576C8.06908 17.5139 10.8368 13.4183 14.6683 10.4995C18.4998 7.58072 23.1834 6 28 6"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>
              <p class="description">Acting as <span>manufacturing facility under the signed TQA</span> with other MAHs
                through B2B model</p>
            </div>
            <div class="js-scroll width-animation2 sep-line"></div>
            <div class="js-scroll fade-in-bottom item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M37.3671 47.9062C33.0565 49.9346 28.2038 50.509 23.5387 49.5429C18.8736 48.5768 14.6481 46.1225 11.4976 42.5489C8.347 38.9753 6.44161 34.4755 6.06782 29.7261C5.69403 24.9767 6.87205 20.2343 9.42478 16.2118C11.9775 12.1894 15.767 9.10422 20.2236 7.42023C24.6801 5.73624 29.5629 5.5444 34.1378 6.87354C38.7127 8.20268 42.7326 10.981 45.5931 14.7908C48.4535 18.6005 50 23.2359 50 28"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>

              <p class="description"><span>Sterile production</span> of <span>liquid medicines</span> in the form of
                <span>solutions and suspensions</span> according to annex 1 of EU-GMP</p>
            </div>
            <div class="js-scroll width-animation2 sep-line"></div>
            <div class="js-scroll fade-in-bottom item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M17.5349 8.64846C21.7718 6.35721 26.6435 5.51977 31.4023 6.26468C36.1611 7.00958 40.5439 9.29567 43.8779 12.772C47.212 16.2484 49.313 20.7228 49.8585 25.5086C50.4039 30.2943 49.3637 35.1268 46.8975 39.2643C44.4313 43.4017 40.6754 46.6155 36.2063 48.4122C31.7372 50.2089 26.8019 50.4892 22.1581 49.2102C17.5143 47.9312 13.4186 45.1634 10.4997 41.3319C7.58079 37.5003 6 32.8167 6 28"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>
              <p class="description">Filling of <span>syringes and vials</span> as a pharmaceutical form for sales as in
                <span>bulk or FDF</span></p>
            </div>
          </div>

          <div class="sep">
            <img src="@/assets/img/circle-img4.png" alt="">

            <div class="float-block">
              <p>Aseptic Vials & Syringes filling Site</p>
            </div>
          </div>

        </div>
      </section>

      <section id="r-d">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">
            RESEARCH &<br>
            DEVELOPMENT CENTER
          </h2>
          <h3 class="js-scroll fade-in-bottom">SHARING OF KNOWLEDGE & TECHNOLOGICAL PROCESS IMPROVEMENTS</h3>

          <div class="js-scroll fade-in-bottom item-wrapper">
            <div class="item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M47.3526 17.537C49.6434 21.774 50.4803 26.6457 49.735 31.4043C48.9897 36.1629 46.7033 40.5454 43.2267 43.8791C39.7502 47.2128 35.2757 49.3135 30.49 49.8586C25.7043 50.4038 20.872 49.3633 16.7347 46.8969C12.5975 44.4305 9.38398 40.6745 7.58749 36.2055C5.79101 31.7364 5.51083 26.8013 6.78995 22.1576C8.06908 17.5139 10.8368 13.4183 14.6683 10.4995C18.4998 7.58072 23.1834 6 28 6"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>

              <p class="description"><span>Pharmaceutical development </span> for high-tech products to increase the
                Farmak company's portfolio</p>
            </div>
            <div class="js-scroll width-animation2 sep-line"></div>
            <div class="item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M37.3671 47.9062C33.0565 49.9346 28.2038 50.509 23.5387 49.5429C18.8736 48.5768 14.6481 46.1225 11.4976 42.5489C8.347 38.9753 6.44161 34.4755 6.06782 29.7261C5.69403 24.9767 6.87205 20.2343 9.42478 16.2118C11.9775 12.1894 15.767 9.10422 20.2236 7.42023C24.6801 5.73624 29.5629 5.5444 34.1378 6.87354C38.7127 8.20268 42.7326 10.981 45.5931 14.7908C48.4535 18.6005 50 23.2359 50 28"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>

              <p class="description">
                <span>Scientific advice</span>
                on preparation/ update of M3 dossiers development
              </p>
            </div>
            <div class="js-scroll width-animation2 sep-line"></div>
            <div class="item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M17.5349 8.64846C21.7718 6.35721 26.6435 5.51977 31.4023 6.26468C36.1611 7.00958 40.5439 9.29567 43.8779 12.772C47.212 16.2484 49.313 20.7228 49.8585 25.5086C50.4039 30.2943 49.3637 35.1268 46.8975 39.2643C44.4313 43.4017 40.6754 46.6155 36.2063 48.4122C31.7372 50.2089 26.8019 50.4892 22.1581 49.2102C17.5143 47.9312 13.4186 45.1634 10.4997 41.3319C7.58079 37.5003 6 32.8167 6 28"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>

              <p class="description">
                Use of laboratories for the purposes of
                <span>analytical and microbiological control</span>
                in accordance with EU and US directives
              </p>
            </div>
          </div>

          <div class="sep">
            <img src="@/assets/img/circle-img5.png" alt="">

            <div class="float-block">
              <p>R&D center + Microbiology control + QC Lab</p>
            </div>
          </div>
        </div>
      </section>

      <section id="eu-importer-d">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">
            EU-IMPORTER
          </h2>
          <h3 class="js-scroll fade-in-bottom">IMPORTING OF FDF TO EU AND ROW COMING FROM OTHER NON-EU COUNTRIES</h3>

          <div class="js-scroll fade-in-bottom item-wrapper">
            <div class="item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M47.3526 17.537C49.6434 21.774 50.4803 26.6457 49.735 31.4043C48.9897 36.1629 46.7033 40.5454 43.2267 43.8791C39.7502 47.2128 35.2757 49.3135 30.49 49.8586C25.7043 50.4038 20.872 49.3633 16.7347 46.8969C12.5975 44.4305 9.38398 40.6745 7.58749 36.2055C5.79101 31.7364 5.51083 26.8013 6.78995 22.1576C8.06908 17.5139 10.8368 13.4183 14.6683 10.4995C18.4998 7.58072 23.1834 6 28 6"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>
              <p class="description">
                <span>Importing of Final Dosage Forms</span>
                from other countries
              </p>
            </div>
            <div class="js-scroll width-animation2 sep-line"></div>
            <div class="item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M37.3671 47.9062C33.0565 49.9346 28.2038 50.509 23.5387 49.5429C18.8736 48.5768 14.6481 46.1225 11.4976 42.5489C8.347 38.9753 6.44161 34.4755 6.06782 29.7261C5.69403 24.9767 6.87205 20.2343 9.42478 16.2118C11.9775 12.1894 15.767 9.10422 20.2236 7.42023C24.6801 5.73624 29.5629 5.5444 34.1378 6.87354C38.7127 8.20268 42.7326 10.981 45.5931 14.7908C48.4535 18.6005 50 23.2359 50 28"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>

              <p class="description">
                <span>Quality Control</span>
                on imported batches
                <span>according to the Ph. Eur. and Marketing Authorization dossier</span>
              </p>
            </div>
            <div class="js-scroll width-animation2 sep-line"></div>
            <div class="item">
              <div class=" icon">
                <svg class="js-scroll rotate-animation" width="56" height="56" viewBox="0 0 56 56" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path opacity="0.2"
                        d="M48.8119 20.868C49.7485 23.601 50.1376 26.4918 49.957 29.3752C49.7764 32.2587 49.0296 35.0783 47.7593 37.6731C46.489 40.268 44.7201 42.5872 42.5535 44.4984C40.3869 46.4096 37.8651 47.8753 35.132 48.8119C32.399 49.7485 29.5082 50.1376 26.6248 49.957C23.7413 49.7764 20.9217 49.0296 18.3269 47.7593C15.732 46.489 13.4128 44.7201 11.5016 42.5535C9.59044 40.3869 8.12471 37.8651 7.18812 35.132C6.25153 32.399 5.86243 29.5082 6.04303 26.6248C6.22362 23.7413 6.97039 20.9217 8.24068 18.3269C9.51097 15.732 11.2799 13.4128 13.4465 11.5016C15.6131 9.59044 18.1349 8.12471 20.868 7.18812C23.601 6.25153 26.4918 5.86243 29.3752 6.04303C32.2587 6.22362 35.0783 6.97039 37.6731 8.24068C40.268 9.51098 42.5872 11.2799 44.4984 13.4465C46.4096 15.6131 47.8753 18.1349 48.8119 20.868L48.8119 20.868Z"
                        stroke="#009EE0" stroke-width="12"/>
                  <path
                    d="M17.5349 8.64846C21.7718 6.35721 26.6435 5.51977 31.4023 6.26468C36.1611 7.00958 40.5439 9.29567 43.8779 12.772C47.212 16.2484 49.313 20.7228 49.8585 25.5086C50.4039 30.2943 49.3637 35.1268 46.8975 39.2643C44.4313 43.4017 40.6754 46.6155 36.2063 48.4122C31.7372 50.2089 26.8019 50.4892 22.1581 49.2102C17.5143 47.9312 13.4186 45.1634 10.4997 41.3319C7.58079 37.5003 6 32.8167 6 28"
                    stroke="#009EE0" stroke-width="12"/>
                </svg>
              </div>
              <p class="description">
                <span>Batch release</span>
                for distribution of products in EU countries
              </p>
            </div>
          </div>

          <div class="js-scroll fade-in-bottom sep">
            <img src="@/assets/img/circle-img6.png" alt="">
          </div>
        </div>
      </section>

      <section id="contacts">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">Contacts</h2>

          <div class="js-scroll fade-in-bottom item" lang="es">
            <h3>Farmacovigilancia</h3>
            <p>
              Una <strong>reacción adversa</strong> es una respuesta nociva y no intencionada a un medicamento. Todos los medicamentos
              pueden causar reacciones adversas. Las reacciones adversas conocidas se describen en el prospecto y en la
              Ficha Técnica de cada medicamento.
            </p>
            <p>
              Se recomienda a los pacientes, profesionales sanitarios y demás usuarios que notifiquen cualquier sospecha
              de reacción adversa.
            </p>
            <p>
              Si sospecha que usted o un paciente ha experimentado una reacción adversa asociada a un medicamento de
              <strong>Farmak</strong>, póngase en contacto con nuestro Departamento de Farmacovigilancia:
            </p>
            <p class="details">
              <strong>Correo electrónico:</strong> <a :href="`mailto:${contacts.email.pharmacovigilance}`">{{
                contacts.email.pharmacovigilance }}</a><br>
              <strong>Teléfono:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
            </p>
            <p>
              También puede notificar directamente una sospecha de reacción adversa a la
              <strong>Agencia Española de Medicamentos y Productos Sanitarios (AEMPS)</strong> a través del portal de
              notificación en línea:
              <a href="https://www.notificaram.es" target="_blank"><strong>www.notificaram.es</strong></a>.
            </p>
            <p>
              La identificación y notificación de sospechas de reacciones adversas contribuyen a mejorar nuestro
              conocimiento sobre la seguridad de los medicamentos y ayudan a garantizar su uso adecuado y seguro.
            </p>
          </div>

          <div class="js-scroll fade-in-bottom item" lang="es">
            <h3>Otras consultas médicas</h3>
            <p>
              Para cualquier otra consulta de carácter médico relacionada con nuestros medicamentos, puede ponerse en
              contacto con nosotros a través de:
            </p>
            <p class="details">
              <strong>Email:</strong> <a :href="`mailto:${contacts.email.pharmacovigilance}`">{{
                contacts.email.pharmacovigilance }}</a><br>
              <strong>Teléfono:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
            </p>
          </div>

          <div class="js-scroll fade-in-bottom item" lang="es">
            <h3>Consultas generales</h3>
            <p>Para cualquier otra consulta de carácter general, puede contactar con nosotros en:</p>
            <p class="details">
              <strong>Email:</strong> <a :href="`mailto:${contacts.email.general}`">{{ contacts.email.general }}</a><br>
              <strong>Teléfono:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
            </p>
          </div>

          <div class="js-scroll fade-in-bottom item" lang="es">
            <h3>Protección de datos personales</h3>
            <p>
              En cumplimiento de la normativa aplicable en materia de protección de datos personales, le informamos de
              que <strong>ICM Farmak, S.L.U.</strong>, como responsable del tratamiento, tratará los datos personales
              facilitados en relación con una sospecha de reacción adversa con la finalidad de gestionar, evaluar y
              realizar el seguimiento de dicha notificación, así como de cumplir con las obligaciones legales y
              regulatorias aplicables en materia de farmacovigilancia.
            </p>
            <p>
              Dicho tratamiento puede incluir datos relativos a la salud y otros datos personales necesarios para la
              adecuada gestión y seguimiento de la notificación.
            </p>
            <p>
              La base jurídica del tratamiento es el cumplimiento de las obligaciones legales aplicables a ICM Farmak,
              S.L.U. en materia de farmacovigilancia (artículo 6.1.c del Reglamento (UE) 2016/679 – RGPD). El
              tratamiento de datos relativos a la salud se realiza por razones de interés público en el ámbito de la
              salud pública, de conformidad con el artículo 9.2.i del RGPD y la normativa aplicable en materia de
              farmacovigilancia.
            </p>
            <p>
              Los datos personales se conservarán durante los plazos establecidos por la normativa aplicable en materia
              de farmacovigilancia y, cuando corresponda, durante el tiempo adicional necesario para atender las
              responsabilidades legales que pudieran derivarse.
            </p>
            <p>
              ICM Farmak, S.L.U. garantiza la confidencialidad y seguridad de sus datos personales. Cuando resulte
              necesario para el cumplimiento de las obligaciones de farmacovigilancia, los datos podrán ser comunicados
              a las autoridades sanitarias competentes, así como a otras compañías del grupo Farmak, socios comerciales
              relacionados con el medicamento objeto de la notificación y a proveedores de servicios que participen en
              la gestión de las actividades de farmacovigilancia. Cuando dichas comunicaciones impliquen una
              transferencia internacional de datos fuera del Espacio Económico Europeo, ICM Farmak, S.L.U. adoptará las
              garantías exigidas por la normativa aplicable en materia de protección de datos.
            </p>
            <p>
              Siempre que resulte posible, la información será comunicada de forma seudonimizada y limitada a los datos
              necesarios para dichas finalidades.
            </p>
            <p>Puede ejercer sus derechos en materia de protección de datos contactando con nosotros a través de:</p>
            <p class="details">
              <strong>Email:</strong> <a :href="`mailto:${contacts.email.dpo}`">{{ contacts.email.dpo }}</a><br>
              <strong>Teléfono:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
            </p>
            <p>
              Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD)
              si considera que el tratamiento de sus datos personales no se ajusta a la normativa aplicable.
            </p>
            <p>
              Para obtener más información sobre el tratamiento de sus datos personales y el ejercicio de sus derechos,
              consulte nuestra
              <a href="/Privacy_notice_Farmak.ch.pdf" target="_blank"><strong>Política de Privacidad</strong></a>.
            </p>
          </div>

          <div class="js-scroll fade-in-bottom en-info">
            <button class="en-info__toggle" type="button" :aria-expanded="enInfoOpen ? 'true' : 'false'"
                    aria-controls="contacts-en" @click="enInfoOpen = !enInfoOpen">
              Information in English
              <span class="en-info__icon" aria-hidden="true"></span>
            </button>
            <div id="contacts-en" class="en-info__panel" :class="{ 'is-open': enInfoOpen }" lang="en">
              <div class="en-info__inner">
                <div class="item">
                  <h3>Pharmacovigilance</h3>
                  <p>
                    An <strong>adverse reaction</strong> is a harmful and unintended response to a medicinal product. All
                    medicinal products may cause adverse reactions. Known adverse reactions are described in the package
                    leaflet and the Summary of Product Characteristics (SmPC) of each medicinal product.
                  </p>
                  <p>
                    Patients, healthcare professionals and other users are encouraged to report any suspected adverse
                    reactions.
                  </p>
                  <p>
                    If you suspect that you or a patient has experienced an adverse reaction associated with a
                    <strong>Farmak</strong> medicinal product, please contact our Pharmacovigilance Department:
                  </p>
                  <p class="details">
                    <strong>Email:</strong> <a :href="`mailto:${contacts.email.pharmacovigilance}`">{{
                      contacts.email.pharmacovigilance }}</a><br>
                    <strong>Telephone:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
                  </p>
                  <p>
                    You may also report a suspected adverse reaction directly to the
                    <strong>Spanish Agency for Medicines and Medical Devices (AEMPS)</strong> through the online reporting
                    portal at <a href="https://www.notificaram.es" target="_blank"><strong>www.notificaram.es</strong></a>.
                  </p>
                  <p>
                    The identification and reporting of suspected adverse reactions helps improve our understanding of the
                    safety of medicinal products and contributes to ensuring their appropriate and safe use.
                  </p>
                </div>

                <div class="item">
                  <h3>Other Medical Enquiries</h3>
                  <p>For any other medical enquiries related to our medicinal products, please contact us at:</p>
                  <p class="details">
                    <strong>Email:</strong> <a :href="`mailto:${contacts.email.pharmacovigilance}`">{{
                      contacts.email.pharmacovigilance }}</a><br>
                    <strong>Telephone:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
                  </p>
                </div>

                <div class="item">
                  <h3>General Enquiries</h3>
                  <p>For any other general enquiries, please contact us at:</p>
                  <p class="details">
                    <strong>Email:</strong> <a :href="`mailto:${contacts.email.general}`">{{ contacts.email.general }}</a><br>
                    <strong>Telephone:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
                  </p>
                </div>

                <div class="item">
                  <h3>Personal Data Protection</h3>
                  <p>
                    In compliance with the applicable personal data protection regulations, we hereby inform you that
                    <strong>ICM Farmak, S.L.U.</strong>, as the data controller, will process the personal data provided in connection with a
                    suspected adverse reaction for the purpose of managing, assessing and following up on such report, as well
                    as complying with the applicable legal and regulatory obligations in the field of pharmacovigilance.
                  </p>
                  <p>
                    Such processing may include health data and other personal data necessary for the proper management and
                    follow-up of the report.
                  </p>
                  <p>
                    The legal basis for the processing is compliance with the legal obligations applicable to ICM Farmak,
                    S.L.U. in the field of pharmacovigilance (Article 6.1(c) of Regulation (EU) 2016/679 – GDPR). The
                    processing of health data is carried out for reasons of public interest in the area of public health, in
                    accordance with Article 9.2(i) of the GDPR and the applicable pharmacovigilance regulations.
                  </p>
                  <p>
                    Personal data will be retained for the periods established by the applicable pharmacovigilance
                    regulations and, where applicable, for the additional period necessary to address any legal liabilities
                    that may arise.
                  </p>
                  <p>
                    ICM Farmak, S.L.U. guarantees the confidentiality and security of your personal data. Where necessary for
                    compliance with pharmacovigilance obligations, the data may be disclosed to the competent health
                    authorities, as well as to other companies within the Farmak Group, business partners related to the
                    medicinal product concerned by the report, and service providers involved in the management of
                    pharmacovigilance activities. Where such disclosures involve an international transfer of personal data
                    outside the European Economic Area, ICM Farmak, S.L.U. will implement the safeguards required under
                    applicable data protection laws.
                  </p>
                  <p>
                    Whenever possible, the information will be disclosed in pseudonymised form and limited to the data
                    necessary for such purposes.
                  </p>
                  <p>You may exercise your data protection rights by contacting us at:</p>
                  <p class="details">
                    <strong>Email:</strong> <a :href="`mailto:${contacts.email.dpo}`">{{ contacts.email.dpo }}</a><br>
                    <strong>Telephone:</strong> <a :href="contacts.phone.href">{{ contacts.phone.label }}</a>
                  </p>
                  <p>
                    You also have the right to lodge a complaint with the Spanish Data Protection Agency (AEPD) if you
                    consider that the processing of your personal data does not comply with the applicable regulations.
                  </p>
                  <p>
                    For further information on the processing of your personal data and the exercise of your rights, please
                    refer to our <a href="/Privacy_notice_Farmak.ch.pdf" target="_blank"><strong>Privacy Policy</strong></a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" class="contact">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">
            <span class="line1">Contact us</span>
            <span class="line2">ICM</span>
            <span class="line3">Farmak</span>
            <span class="line4">S.L.U.</span>
            <span class="line5">a company in the Farmak Group</span>
          </h2>
          <p class="js-scroll fade-in-bottom text">We are looking forward to hearing from you and thank you for your
            interest in Farmak International</p>

          <div class="info js-scroll fade-in-bottom">
            <div class="mark"></div>
            <div class="line">
              <p class="address">
                ICM Farmak S.L.U.
                <br>Avenida de Arraona, 119-123
                <br>08210 Barberà del Vallès, Barcelona, Spain
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>

    <div class="right-side">
      <div class="right-side__country-switch-wrapper">
        <p>Country</p>
        <div class="right-side__country-switch">
          <div @click="drop = !drop" class=" show" v-bind:class="[{ active: drop }]">Spain
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 10.6286L4 5.37138L12 5.37138L8 10.6286Z" fill="white"/>
            </svg>
          </div>
          <div class="hide" v-if="drop">
            <a @click="drop = false" href="https://www.farmak.co.cz/" target="_blank">Czechia</a>
            <a @click="drop = false" href="https://farmakinternational.pl/" target="_blank">Poland</a>
            <a @click="drop = false" href="https://farmak.sk/" target="_blank">Slovakia</a>
            <a @click="drop = false" href="https://www.farmak.ch/" target="_blank">Switzerland</a>
            <a @click="drop = false" href="https://farmak.ae/" target="_blank">UAE</a>
            <a @click="drop = false" href="https://farmak.uk/" target="_blank">UK</a>
            <a @click="drop = false" href="https://farmak.ua/en/worldwide/" target="_blank">Ukraine</a>
          </div>
        </div>
      </div>
      <Transition>
        <picture v-if="getActiveLink ==='home'">
          <img src="@/assets/img/circle-img1.png" alt="">

        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='news'">
          <img src="@/assets/img/circle-img-news.png" alt="">

        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='values'">
          <img src="@/assets/img/circle-img2.png" alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='icm-farmak'">
          <img src="@/assets/img/circle-img3.png" alt="">
        </picture>
      </Transition>
      <Transition>
        <div class="wrapper" v-if="getActiveLink ==='eu-cdmo'">
          <picture>
            <img src="@/assets/img/circle-img4.png"
                 alt="">
          </picture>
          <div class="text-block text-block1">
            <p>Aseptic Vials & Syringes filling Site</p>
          </div>
        </div>
      </Transition>
      <Transition>
        <div class="wrapper" v-if="getActiveLink ==='r-d'">
          <picture>
            <img src="@/assets/img/circle-img5.png"
                 alt="">
          </picture>
          <div class="text-block text-block2">
            <p>R&D center + Microbiology control + QC Lab</p>
          </div>
        </div>

      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='eu-importer-d'">
          <img src="@/assets/img/circle-img6.png"
               alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getContactsActive">
          <img src="@/assets/img/circle-img7.png"
               alt="">
        </picture>
      </Transition>
      <div class="right-side__info">
        <div class="mark"></div>
        <div class="line">
          <div class="col col1">
            <p class="address">
              ICM Farmak S.L.U.<br>
              Avenida de Arraona, 119-123<br>
              08210 Barberà del Vallès, Barcelona, Spain
            </p>
          </div>
          <div class="col">
            <p class="support-text">
              Amb el suport de:
            </p>

            <svg class="support-logo" viewBox="0 0 324 54" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.8784 45.5467C29.1122 45.5467 37.4083 35.9084 37.4083 24.0189C37.4083 12.1294 29.1122 2.49103 18.8784 2.49103C8.64454 2.49103 0.348389 12.1294 0.348389 24.0189C0.348389 35.9084 8.64454 45.5467 18.8784 45.5467Z"
                fill="#038FD0"/>
              <path
                d="M5.94193 34.7483C4.16686 31.7099 3.11914 28.0154 3.11914 24.0275C3.11914 20.0396 4.16686 16.3452 5.94193 13.3068V34.7483Z"
                fill="white"/>
              <path
                d="M9.9248 8.57652C10.9466 7.7306 12.0635 7.02278 13.2498 6.48761V41.5588C12.0635 41.0237 10.9552 40.3158 9.9248 39.4699V8.57652Z"
                fill="white"/>
              <path
                d="M17.2241 5.34812C17.7696 5.27906 18.3238 5.24454 18.878 5.24454C19.4408 5.24454 19.995 5.27906 20.5405 5.34812V42.6895C19.995 42.7586 19.4408 42.7931 18.878 42.7931C18.3151 42.7931 17.7696 42.7586 17.2241 42.6895V5.34812Z"
                fill="white"/>
              <path
                d="M24.5237 6.48761C25.7099 7.03142 26.8183 7.7306 27.8487 8.58515V39.4613C26.8269 40.3072 25.7099 41.015 24.5237 41.5588V6.48761Z"
                fill="white"/>
              <path
                d="M31.8232 13.3153C33.5983 16.3537 34.6374 20.0395 34.6374 24.0188C34.6374 27.9981 33.5983 31.6839 31.8232 34.7223V13.3153Z"
                fill="white"/>
              <path
                d="M1.90674 24.0188C1.90674 19.0814 3.4307 14.567 5.94177 11.0797V12.2536C3.82901 15.5078 2.56481 19.5907 2.56481 24.0188C2.56481 28.447 3.82035 32.5212 5.94177 35.784V36.958C3.4307 33.4707 1.90674 28.9562 1.90674 24.0188Z"
                fill="white"/>
              <path
                d="M31.8232 35.7669C33.936 32.5127 35.1829 28.4384 35.1829 24.0189C35.1829 19.5994 33.9273 15.5252 31.8232 12.271V11.0884C34.3343 14.5757 35.8496 19.0815 35.8496 24.0103C35.8496 28.9391 34.3343 33.4535 31.8232 36.9322V35.7669Z"
                fill="white"/>
              <path
                d="M36.9316 43.2938C37.0615 42.75 37.3126 42.1976 37.6157 41.7574C37.2347 41.5675 36.9143 41.4293 36.5766 41.1445C37.3126 40.0396 37.4944 39.28 37.6157 37.9507L37.5637 30.4237C37.0788 32.6162 35.9099 35.482 34.8968 36.9839C34.6024 37.4242 34.4725 37.7004 34.2906 37.9939C34.1867 38.1665 33.5893 39.1419 33.6066 40.3331C33.191 40.4194 32.81 40.4022 32.3251 40.3676C32.3857 40.8855 32.4203 40.9632 32.2818 41.8178C30.4548 41.9559 29.9179 43.0521 27.7445 44.2261C26.6882 44.7958 25.9955 45.0547 24.4109 45.6331C28.0996 45.5899 30.8098 46.1078 33.1217 44.5541C33.3815 44.8994 33.5806 45.236 33.7538 45.6503C34.0742 45.4 34.6976 45.0893 35.2171 44.9598C35.8146 45.5467 36.6112 45.7798 37.633 45.6849C37.7888 44.8648 37.581 43.8549 36.9316 43.2938Z"
                fill="#038FD0"/>
              <path
                d="M37.2175 41.9041C36.9317 42.0163 35.5896 42.517 35.5896 42.517L35.5723 42.5342C35.5636 42.4134 35.5377 42.3012 35.4857 42.1889L35.4771 42.163C35.9966 41.8523 36.3256 41.4121 36.3256 41.3516C36.3256 41.343 36.317 41.343 36.3256 41.343V41.3516C36.3689 41.4121 36.8105 41.8264 37.2175 41.9041Z"
                fill="white"/>
              <path
                d="M36.1005 35.5511C37.4513 32.5731 37.1309 32.7026 37.434 31.4682C37.3907 32.0638 37.356 32.8148 37.2695 33.3586C36.6807 36.5956 35.8407 39.0038 34.819 41.6538C34.819 41.6538 34.5419 41.6279 34.4034 41.6538C34.1609 41.369 34.083 40.9805 34.083 40.9805C33.6068 39.0211 35.0788 37.804 36.1005 35.5511Z"
                fill="white"/>
              <path
                d="M32.7234 40.7647L33.979 41.8092V41.8178C33.9443 41.8437 33.901 41.8783 33.8664 41.9128C33.8058 41.9732 33.7538 42.0423 33.7105 42.1199L33.7019 42.1372C33.0611 41.8265 32.6282 41.8092 32.6282 41.8092C32.8014 41.1273 32.7234 40.7647 32.7234 40.7647Z"
                fill="white"/>
              <path
                d="M27.0088 45.2877C26.3767 45.4345 25.8658 45.4258 25.4675 45.4431L26.8097 45.0288C29.719 43.9412 30.455 42.2579 32.4206 42.2234C32.8795 42.2321 33.2605 42.3443 33.5982 42.5428V42.5946C33.5809 42.7241 33.5982 42.8449 33.6328 42.9658V42.983C32.2734 43.6477 29.1735 44.7871 27.0088 45.2877Z"
                fill="white"/>
              <path
                d="M33.9099 45.2014C33.832 44.9943 33.7281 44.6576 33.425 44.3296C33.832 43.9843 33.9099 43.8031 34.0485 43.4664L34.0571 43.4751C34.187 43.5527 34.3256 43.5959 34.4641 43.6045H34.4814L33.9099 45.2014Z"
                fill="white"/>
              <path
                d="M34.1695 43.0176C34.116 42.9644 34.0736 42.9011 34.0446 42.8315C34.0156 42.7619 34.0007 42.6873 34.0007 42.6119C34.0007 42.5366 34.0156 42.4619 34.0446 42.3923C34.0736 42.3227 34.116 42.2595 34.1695 42.2062C34.3947 41.9818 34.7584 41.9818 34.9835 42.2062C35.2086 42.4307 35.2086 42.7932 34.9835 43.0176C34.9301 43.071 34.8666 43.1133 34.7968 43.1422C34.727 43.171 34.6521 43.1859 34.5765 43.1859C34.5009 43.1859 34.4261 43.171 34.3562 43.1422C34.2864 43.1133 34.223 43.071 34.1695 43.0176Z"
                fill="white"/>
              <path
                d="M35.4165 44.6231C35.1221 44.2778 34.9922 44.0102 34.8796 43.5441C35.0268 43.5009 35.2 43.4146 35.3039 43.2679L37.3214 45.305C36.5508 45.3741 35.8927 45.2014 35.4165 44.6231Z"
                fill="white"/>
              <path
                d="M37.6415 2.32709C36.6198 2.23214 35.8232 2.4652 35.2257 3.05216C34.7062 2.92268 34.0827 2.61194 33.7623 2.36161C33.5892 2.76731 33.39 3.11258 33.1302 3.45786C30.8097 1.90412 28.1081 2.43067 24.4194 2.37888C26.004 2.95721 26.6967 3.21617 27.7531 3.78587C29.9265 4.95117 30.4547 6.04741 32.2903 6.19416C32.4289 7.04871 32.3942 7.11776 32.3336 7.64431C32.8185 7.60978 33.1995 7.59252 33.6151 7.67883C33.5978 8.87866 34.1953 9.85406 34.2992 10.0181C34.481 10.3116 34.6109 10.5878 34.9053 11.028C35.9184 12.5299 37.0873 15.3957 37.5722 17.5882L37.6242 10.0612C37.503 8.73192 37.3211 7.97232 36.5851 6.86744C36.9142 6.58259 37.2432 6.43585 37.6242 6.25458C37.3298 5.81435 37.07 5.26192 36.9401 4.71811C37.5809 4.15704 37.7887 3.14711 37.6415 2.32709Z"
                fill="#038FD0"/>
              <path
                d="M37.2175 6.09915C36.9317 5.98694 35.5896 5.48629 35.5896 5.48629L35.5723 5.46902C35.5636 5.58987 35.5377 5.70208 35.4857 5.8143L35.4771 5.84019C35.9966 6.15094 36.3256 6.59117 36.3256 6.65159C36.3256 6.66022 36.317 6.66022 36.3256 6.66022V6.65159C36.3689 6.59117 36.8105 6.18547 37.2175 6.09915Z"
                fill="white"/>
              <path
                d="M36.1005 12.4609C37.4513 15.4389 37.1309 15.3094 37.434 16.5437C37.3907 15.9481 37.356 15.1972 37.2695 14.6534C36.6807 11.4164 35.8407 9.00813 34.819 6.35815C34.819 6.35815 34.5419 6.38405 34.4034 6.35815C34.1609 6.64301 34.083 7.03144 34.083 7.03144C33.6068 8.98224 35.0788 10.1993 36.1005 12.4609Z"
                fill="white"/>
              <path
                d="M32.7234 7.23858L33.979 6.19413V6.1855C33.9443 6.1596 33.901 6.12507 33.8664 6.09055C33.8058 6.03012 33.7538 5.96107 33.7105 5.88338L33.7019 5.86612C33.0611 6.17687 32.6282 6.19413 32.6282 6.19413C32.8014 6.87605 32.7234 7.23858 32.7234 7.23858Z"
                fill="white"/>
              <path
                d="M27.0088 2.72407C26.3767 2.57733 25.8658 2.58596 25.4675 2.5687L26.8097 2.98302C29.719 4.07064 30.455 5.75385 32.4206 5.78838C32.8795 5.77974 33.2605 5.66753 33.5982 5.469V5.41721C33.5809 5.28773 33.5982 5.16688 33.6328 5.04604V5.02877C32.2734 4.35549 29.1735 3.21608 27.0088 2.72407Z"
                fill="white"/>
              <path
                d="M33.9099 2.81049C33.832 3.01765 33.7281 3.35429 33.425 3.6823C33.832 4.02758 33.9099 4.20885 34.0485 4.54549L34.0571 4.53686C34.187 4.45917 34.3256 4.41601 34.4641 4.40738H34.4814L33.9099 2.81049Z"
                fill="white"/>
              <path
                d="M34.9808 5.79436C35.2035 5.57109 35.2024 5.21016 34.9784 4.98821C34.7544 4.76625 34.3924 4.76732 34.1697 4.9906C33.9471 5.21387 33.9482 5.5748 34.1721 5.79675C34.3961 6.01871 34.7582 6.01764 34.9808 5.79436Z"
                fill="white"/>
              <path
                d="M35.4165 3.38877C35.1221 3.73404 34.9922 4.00163 34.8796 4.46775C35.0268 4.51091 35.2 4.59723 35.3039 4.74397L37.3214 2.69822C36.5508 2.62916 35.8927 2.81043 35.4165 3.38877Z"
                fill="white"/>
              <path
                d="M0.0451041 45.6849C1.06685 45.7798 1.87212 45.5467 2.46093 44.9598C2.98046 45.0979 3.6039 45.4 3.92427 45.6503C4.09745 45.2446 4.29661 44.8994 4.55637 44.5541C6.87695 46.1078 9.57851 45.5813 13.2672 45.6331C11.6826 45.0547 10.9899 44.7958 9.93352 44.2261C7.76015 43.0608 7.23196 41.9645 5.39628 41.8178C5.25774 40.9632 5.29237 40.8942 5.35299 40.3676C4.86809 40.4022 4.4871 40.4194 4.07147 40.3331C4.08879 39.1333 3.49133 38.1579 3.38742 37.9939C3.20559 37.7004 3.07571 37.4242 2.7813 36.9839C1.76822 35.482 0.599271 32.6162 0.114375 30.4237L0.0624216 37.9507C0.183646 39.28 0.365482 40.0396 1.10148 41.1445C0.772448 41.4293 0.443411 41.5761 0.0624216 41.7574C0.356823 42.1976 0.616589 42.75 0.746472 43.2938C0.105716 43.8549 -0.102097 44.8648 0.0451041 45.6849Z"
                fill="#038FD0"/>
              <path
                d="M0.469238 41.9041C0.754981 42.0163 2.0971 42.517 2.0971 42.517L2.11442 42.5342C2.12308 42.4134 2.14906 42.3012 2.20101 42.1889L2.20967 42.163C1.69014 41.8523 1.3611 41.4121 1.3611 41.3516C1.3611 41.343 1.36976 41.343 1.3611 41.343V41.3516C1.31781 41.4121 0.876205 41.8264 0.469238 41.9041Z"
                fill="white"/>
              <path
                d="M1.58615 35.5511C0.235368 32.5731 0.555746 32.7026 0.252686 31.4682C0.287321 32.0638 0.330615 32.8148 0.417204 33.3586C1.00601 36.5956 1.84592 39.0038 2.86766 41.6538C2.86766 41.6538 3.14475 41.6279 3.28329 41.6538C3.52574 41.369 3.60366 40.9805 3.60366 40.9805C4.0799 39.0211 2.6079 37.804 1.58615 35.5511Z"
                fill="white"/>
              <path
                d="M4.96317 40.7647L3.70763 41.8092L3.69897 41.8178C3.73361 41.8437 3.7769 41.8783 3.81154 41.9128C3.87215 41.9732 3.92411 42.0423 3.9674 42.1199L3.97606 42.1372C4.61681 41.8265 5.04976 41.8092 5.04976 41.8092C4.88524 41.1273 4.96317 40.7647 4.96317 40.7647Z"
                fill="white"/>
              <path
                d="M10.678 45.2877C11.3101 45.4345 11.821 45.4258 12.2193 45.4431L10.8771 45.0288C7.96776 43.9412 7.23176 42.2579 5.2662 42.2234C4.80728 42.2321 4.42629 42.3443 4.08859 42.5428V42.5946C4.09725 42.7241 4.08859 42.8449 4.05396 42.9658V42.983C5.4134 43.6477 8.51327 44.7871 10.678 45.2877Z"
                fill="white"/>
              <path
                d="M3.77705 45.2014C3.85498 44.9943 3.95889 44.6576 4.26195 44.3296C3.85498 43.9843 3.77705 43.8031 3.63851 43.4664L3.62985 43.4751C3.49997 43.5527 3.36143 43.5959 3.22288 43.6045H3.20557L3.77705 45.2014Z"
                fill="white"/>
              <path
                d="M3.51693 43.0176C3.74206 42.7932 3.74206 42.4307 3.51693 42.2062C3.46352 42.1529 3.40009 42.1106 3.33026 42.0817C3.26042 42.0528 3.18556 42.038 3.10996 42.038C3.03436 42.038 2.9595 42.0528 2.88967 42.0817C2.81983 42.1106 2.7564 42.1529 2.70299 42.2062C2.64948 42.2595 2.60703 42.3227 2.57806 42.3923C2.54909 42.462 2.53418 42.5366 2.53418 42.6119C2.53418 42.6873 2.54909 42.7619 2.57806 42.8316C2.60703 42.9012 2.64948 42.9644 2.70299 43.0176C2.92813 43.2421 3.2918 43.2421 3.51693 43.0176Z"
                fill="white"/>
              <path
                d="M2.27043 44.6231C2.56483 44.2778 2.69471 44.0102 2.80728 43.5441C2.66008 43.5009 2.4869 43.4146 2.38299 43.2679L0.365479 45.305C1.13612 45.3741 1.79419 45.2014 2.27043 44.6231Z"
                fill="white"/>
              <path
                d="M0.755118 4.70944C0.625235 5.25325 0.374129 5.80569 0.0710688 6.24591C0.452059 6.43581 0.772436 6.57392 1.11013 6.85877C0.374129 7.96365 0.192293 8.72325 0.0710688 10.0526L0.123022 17.5795C0.607918 15.387 1.77686 12.5213 2.78995 11.0193C3.08435 10.5791 3.21423 10.3029 3.39607 10.0094C3.49998 9.83676 4.09744 8.86136 4.08012 7.67017C4.49575 7.58385 4.87674 7.60111 5.36163 7.63564C5.30102 7.11773 5.27504 7.04004 5.40493 6.18549C7.23195 6.04738 7.7688 4.95113 9.94217 3.7772C10.9985 3.2075 11.6913 2.94854 13.2758 2.37021C9.58716 2.41337 6.88559 1.89546 4.56502 3.44919C4.30525 3.10392 4.1061 2.76727 3.93292 2.35295C3.61254 2.60327 2.9891 2.91402 2.46957 3.04349C1.87211 2.45653 1.0755 2.22347 0.0537507 2.31842C-0.102109 3.14708 0.105704 4.157 0.755118 4.70944Z"
                fill="#038FD0"/>
              <path
                d="M0.469238 6.09915C0.754981 5.98694 2.0971 5.48629 2.0971 5.48629L2.11442 5.46902C2.12308 5.58987 2.14906 5.70208 2.20101 5.8143L2.20967 5.84019C1.69014 6.15094 1.3611 6.59117 1.3611 6.65159C1.3611 6.66022 1.36976 6.66022 1.3611 6.66022V6.65159C1.31781 6.59117 0.876205 6.18547 0.469238 6.09915Z"
                fill="white"/>
              <path
                d="M1.58615 12.4609C0.235368 15.4389 0.555746 15.3094 0.252686 16.5437C0.287321 15.9481 0.330615 15.1972 0.417204 14.6534C1.00601 11.4164 1.84592 9.00813 2.86766 6.35815C2.86766 6.35815 3.14475 6.38405 3.28329 6.35815C3.52574 6.64301 3.60366 7.03144 3.60366 7.03144C4.0799 8.98224 2.6079 10.1993 1.58615 12.4609Z"
                fill="white"/>
              <path
                d="M4.96317 7.23858L3.70763 6.19413L3.69897 6.1855C3.73361 6.1596 3.7769 6.12507 3.81154 6.09055C3.87215 6.03012 3.92411 5.96107 3.9674 5.88338L3.97606 5.86612C4.61681 6.17687 5.04976 6.19413 5.04976 6.19413C4.88524 6.87605 4.96317 7.23858 4.96317 7.23858Z"
                fill="white"/>
              <path
                d="M10.678 2.72407C11.3101 2.57733 11.821 2.58596 12.2193 2.5687L10.8771 2.98302C7.96776 4.07064 7.23176 5.75385 5.2662 5.78838C4.80728 5.77974 4.42629 5.66753 4.08859 5.469V5.41721C4.09725 5.28773 4.08859 5.16688 4.05396 5.04604V5.02877C5.4134 4.35549 8.51327 3.21608 10.678 2.72407Z"
                fill="white"/>
              <path
                d="M3.77705 2.81049C3.85498 3.01765 3.95889 3.35429 4.26195 3.6823C3.85498 4.02758 3.77705 4.20885 3.63851 4.54549L3.62985 4.53686C3.49997 4.45917 3.36143 4.41601 3.22288 4.40738H3.20557L3.77705 2.81049Z"
                fill="white"/>
              <path
                d="M3.51217 5.79599C3.73611 5.574 3.73714 5.21308 3.51446 4.98983C3.29178 4.76659 2.92972 4.76557 2.70578 4.98756C2.48183 5.20954 2.48081 5.57047 2.70349 5.79371C2.92617 6.01696 3.28822 6.01797 3.51217 5.79599Z"
                fill="white"/>
              <path
                d="M2.27043 3.38877C2.56483 3.73404 2.69471 4.00163 2.80728 4.46775C2.66008 4.51091 2.4869 4.59723 2.38299 4.74397L0.365479 2.69822C1.13612 2.62916 1.79419 2.81043 2.27043 3.38877Z"
                fill="white"/>
              <path
                d="M27.8487 7.04864V7.88593C26.8183 7.08317 25.7013 6.40989 24.5237 5.89198V5.1669C25.7013 5.65028 26.8096 6.28904 27.8487 7.04864Z"
                fill="white"/>
              <path
                d="M18.878 4.0361C19.4408 4.0361 19.995 4.07063 20.5405 4.13105V4.81297C19.995 4.74391 19.4408 4.70939 18.878 4.70939C18.3151 4.70939 17.7696 4.74391 17.2241 4.80434V4.13105C17.7696 4.062 18.3238 4.0361 18.878 4.0361Z"
                fill="white"/>
              <path
                d="M13.2498 5.15829V5.88337C12.0722 6.39265 10.9639 7.06593 9.9248 7.8687V7.03141C10.9639 6.28044 12.0722 5.65031 13.2498 5.15829Z"
                fill="white"/>
              <path
                d="M9.9248 40.9978V40.1605C10.9552 40.9633 12.0722 41.6365 13.2498 42.1458V42.8709C12.0722 42.3961 10.9639 41.7574 9.9248 40.9978Z"
                fill="white"/>
              <path
                d="M18.878 44.0102C18.3151 44.0102 17.7696 43.9757 17.2241 43.9152V43.2333C17.7696 43.3024 18.3238 43.3283 18.878 43.3283C19.4408 43.3283 19.995 43.2938 20.5405 43.2247V43.898C19.995 43.9757 19.4408 44.0102 18.878 44.0102Z"
                fill="white"/>
              <path
                d="M24.5237 42.8708V42.1457C25.7013 41.6278 26.8096 40.9632 27.8487 40.1518V40.9891C26.8096 41.7573 25.7013 42.3874 24.5237 42.8708Z"
                fill="white"/>
              <path
                d="M57.4254 14.0922H64.2832V22.9053H61.9973L61.651 20.8509C60.7851 21.8522 59.5295 23.3369 56.5336 23.3369C52.5851 23.3369 48.9917 20.5143 48.9917 14.7741C48.9917 10.3114 51.4855 6.09906 57.0098 6.11632C62.0406 6.11632 64.0235 9.37053 64.2053 11.6321H60.7764C60.7764 10.9933 59.6075 8.94757 57.1916 8.94757C54.7498 8.94757 52.4812 10.6308 52.4812 14.8259C52.4812 19.2885 54.923 20.4538 57.2523 20.4538C58.0056 20.4538 60.5166 20.1603 61.2267 16.8543H57.4081V14.0922H57.4254Z"
                fill="white"/>
              <path
                d="M74.4053 19.349C74.1542 20.2122 73.2364 20.6696 72.3532 20.6696C69.7729 20.6696 69.591 18.6239 69.4958 17.7089H77.8343V17.1392C77.8343 11.6062 74.5179 10.4668 72.1194 10.4668C66.7942 10.4668 66.292 15.1366 66.292 16.5954C66.292 21.5846 68.9156 23.2247 72.3445 23.2247C74.4227 23.2247 76.8471 22.2665 77.6871 19.349H74.4053ZM69.5824 15.6373C69.7642 14.0404 70.5608 13.0822 72.0761 13.0822C73.1065 13.0822 74.362 13.6778 74.5439 15.6373H69.5824Z"
                fill="white"/>
              <path
                d="M90.9523 22.9053H87.7572V15.551C87.7572 14.6619 87.7139 13.1599 85.6791 13.1599C84.259 13.1599 83.168 14.1181 83.168 15.9653V22.9139H79.9729V10.7862H83.0381V12.5643H83.0814C83.5144 11.8393 84.4322 10.4668 86.7355 10.4668C89.108 10.4668 90.961 11.8565 90.961 14.5238V22.9053H90.9523Z"
                fill="white"/>
              <path
                d="M101.075 19.349C100.824 20.2122 99.9061 20.6696 99.0229 20.6696C96.4425 20.6696 96.2607 18.6239 96.1654 17.7089H104.504V17.1392C104.504 11.6062 101.188 10.4668 98.7891 10.4668C93.4639 10.4668 92.9617 15.1366 92.9617 16.5954C92.9617 21.5846 95.594 23.2247 99.0142 23.2247C101.092 23.2247 103.517 22.2665 104.357 19.349H101.075ZM96.252 15.6373C96.4339 14.0404 97.2305 13.0822 98.7458 13.0822C99.7762 13.0822 101.032 13.6778 101.214 15.6373H96.252Z"
                fill="white"/>
              <path
                d="M106.599 10.7862H109.664V12.8837H109.708C110.366 11.6494 111.102 10.4668 113.041 10.4668C113.249 10.4668 113.457 10.4927 113.656 10.51V13.7469C113.379 13.7037 113.041 13.7037 112.738 13.7037C110.245 13.7037 109.794 15.2488 109.794 16.5954V22.9053H106.599V10.7862Z"
                fill="white"/>
              <path
                d="M125.363 13.9713C125.363 10.9847 122.229 10.4668 120.523 10.4668C118.029 10.4668 115.449 10.9933 115.085 14.705H118.168C118.263 13.9972 118.531 13.0218 120.133 13.0218C120.956 13.0218 122.237 13.0909 122.237 14.4374C122.237 15.1194 121.622 15.3265 121.12 15.3956L118.237 15.8272C116.202 16.1207 114.695 17.3291 114.695 19.7029C114.695 22.2061 116.566 23.2333 118.401 23.2333C120.575 23.2333 121.596 22.232 122.332 21.481C122.402 22.163 122.445 22.3442 122.627 22.9139H126.073V22.4305C125.683 22.2924 125.363 21.9731 125.363 20.5402V13.9713ZM122.229 18.5548C122.229 20.0309 120.791 20.9459 119.371 20.9459C118.756 20.9459 117.882 20.6006 117.882 19.4871C117.882 18.1664 118.86 17.8729 120.055 17.6658C121.38 17.4586 121.908 17.2514 122.229 17.0011V18.5548Z"
                fill="white"/>
              <path d="M128.307 6.54791H131.502V22.9053H128.307V6.54791Z" fill="white"/>
              <path
                d="M137.858 9.35327H134.663V6.39255H137.858V9.35327ZM137.858 10.7862V22.9053H134.663V10.7862H137.858Z"
                fill="white"/>
              <path
                d="M144.508 10.7862H146.499V13.065H144.508V19.6511C144.508 20.3589 144.534 20.6265 145.832 20.6265C146.04 20.6265 146.265 20.6006 146.499 20.5834V23.0003C145.997 23.0262 145.495 23.0434 144.992 23.0434H144.577C141.815 23.0434 141.312 21.999 141.312 20.4194V13.065H139.667V10.7862H141.312V7.5061H144.508V10.7862Z"
                fill="white"/>
              <path
                d="M158.379 13.9713C158.379 10.9847 155.245 10.4668 153.539 10.4668C151.045 10.4668 148.465 10.9933 148.101 14.705H151.184C151.279 13.9972 151.547 13.0218 153.149 13.0218C153.972 13.0218 155.253 13.0909 155.253 14.4374C155.253 15.1194 154.639 15.3265 154.136 15.3956L151.253 15.8272C149.218 16.1207 147.711 17.3291 147.711 19.7029C147.711 22.2061 149.582 23.2333 151.417 23.2333C153.591 23.2333 154.613 22.232 155.349 21.481C155.418 22.163 155.461 22.3442 155.643 22.9139H159.089V22.4305C158.7 22.2924 158.379 21.9731 158.379 20.5402V13.9713ZM155.245 18.5548C155.245 20.0309 153.807 20.9459 152.387 20.9459C151.772 20.9459 150.898 20.6006 150.898 19.4871C150.898 18.1664 151.876 17.8729 153.071 17.6658C154.396 17.4586 154.924 17.2514 155.245 17.0011V18.5548Z"
                fill="white"/>
              <path
                d="M164.821 10.7862H166.813V13.065H164.821V19.6511C164.821 20.3589 164.847 20.6265 166.146 20.6265C166.354 20.6265 166.579 20.6006 166.804 20.5834V23.0003C166.302 23.0262 165.8 23.0434 165.298 23.0434H164.882C162.12 23.0434 161.618 21.999 161.618 20.4194V13.065H159.972V10.7862H161.618V7.5061H164.813V10.7862H164.821Z"
                fill="white"/>
              <path
                d="M60.5863 29.3275H57.3825V35.1367H57.3393C56.837 34.3599 55.8759 33.2463 53.8238 33.2463C51.1482 33.2463 48.7756 35.2921 48.7756 39.4872C48.7756 42.8104 50.2823 46.0042 53.893 46.0042C55.2178 46.0042 56.6379 45.5295 57.4085 44.157H57.4518V45.6848H60.5863V29.3275ZM52.0573 39.7202C52.0573 37.804 52.7414 36.0085 54.7762 36.0085C56.9669 36.0085 57.5211 37.968 57.5211 39.9015C57.5211 41.6969 56.7245 43.3888 54.6896 43.3888C52.6288 43.3801 52.0573 41.1531 52.0573 39.7202Z"
                fill="white"/>
              <path
                d="M70.5869 42.1285C70.3357 42.9917 69.4179 43.4492 68.526 43.4492C65.9457 43.4492 65.7639 41.4034 65.6686 40.4884H74.0071V39.9187C74.0071 34.3857 70.6908 33.2463 68.2923 33.2463C62.9671 33.2463 62.4648 37.9161 62.4648 39.3749C62.4648 44.3641 65.0885 46.0042 68.5174 46.0042C70.5955 46.0042 73.02 45.0461 73.8599 42.1285H70.5869ZM65.7725 38.4168C65.9544 36.8199 66.751 35.8618 68.2663 35.8618C69.2967 35.8618 70.5522 36.4574 70.7341 38.4168H65.7725Z"
                fill="white"/>
              <path
                d="M93.2125 34.6792C92.9354 33.7038 92.4159 31.8565 89.5758 31.8565C87.9306 31.8565 85.5061 32.9528 85.5061 37.5708C85.5061 40.5057 86.6751 43.1556 89.5758 43.1556C91.4721 43.1556 92.7969 42.0853 93.2125 40.0827H96.6414C95.9574 43.639 93.6281 46.1164 89.5152 46.1164C85.1511 46.1164 82.0166 43.1815 82.0166 37.5277C82.0166 31.8134 85.3329 28.8958 89.5585 28.8958C94.468 28.8958 96.4596 32.2709 96.6414 34.6792H93.2125Z"
                fill="white"/>
              <path
                d="M108.842 36.7508C108.842 33.7642 105.707 33.2462 104.002 33.2462C101.508 33.2462 98.9275 33.7728 98.5639 37.4845H101.646C101.742 36.7767 102.01 35.8013 103.612 35.8013C104.435 35.8013 105.716 35.8703 105.716 37.2169C105.716 37.8988 105.101 38.106 104.599 38.175L101.724 38.6066C99.6895 38.9001 98.1829 40.1086 98.1829 42.4823C98.1829 44.9856 100.053 46.0128 101.88 46.0128C104.054 46.0128 105.075 45.0115 105.811 44.2605C105.881 44.9424 105.924 45.1237 106.106 45.6934H109.552V45.2186C109.162 45.0805 108.842 44.7611 108.842 43.3282V36.7508ZM105.707 41.3343C105.707 42.8103 104.27 43.7253 102.85 43.7253C102.235 43.7253 101.361 43.38 101.361 42.2665C101.361 40.9459 102.339 40.6524 103.534 40.4452C104.859 40.238 105.387 40.0309 105.707 39.7806V41.3343Z"
                fill="white"/>
              <path
                d="M115.284 33.5657H117.275V35.8445H115.284V42.4306C115.284 43.1384 115.31 43.406 116.609 43.406C116.817 43.406 117.042 43.3801 117.267 43.3628V45.7797C116.765 45.8056 116.262 45.8229 115.76 45.8229H115.353C112.591 45.8229 112.089 44.7784 112.089 43.1988V35.8445H110.444V33.5657H112.089V30.2856H115.284V33.5657Z"
                fill="white"/>
              <path
                d="M129.155 36.7508C129.155 33.7642 126.021 33.2462 124.315 33.2462C121.821 33.2462 119.241 33.7728 118.877 37.4845H121.96C122.055 36.7767 122.323 35.8013 123.925 35.8013C124.748 35.8013 126.029 35.8703 126.029 37.2169C126.029 37.8988 125.415 38.106 124.912 38.175L122.029 38.6066C119.994 38.9001 118.488 40.1086 118.488 42.4823C118.488 44.9856 120.358 46.0128 122.194 46.0128C124.367 46.0128 125.389 45.0115 126.125 44.2605C126.194 44.9424 126.237 45.1237 126.419 45.6934H129.865V45.2186C129.476 45.0805 129.155 44.7611 129.155 43.3282V36.7508ZM126.021 41.3343C126.021 42.8103 124.583 43.7253 123.163 43.7253C122.549 43.7253 121.674 43.38 121.674 42.2665C121.674 40.9459 122.652 40.6524 123.847 40.4452C125.172 40.238 125.7 40.0309 126.021 39.7806V41.3343Z"
                fill="white"/>
              <path d="M132.1 29.3274H135.295V45.6848H132.1V29.3274Z" fill="white"/>
              <path
                d="M149.331 45.6848H146.265V43.9757H146.222C145.495 45.2704 144.213 46.0041 142.525 46.0041C140.126 46.0041 138.386 44.6403 138.386 41.5415V33.5656H141.581V41.084C141.581 42.9485 142.681 43.3196 143.659 43.3196C144.707 43.3196 146.127 42.724 146.127 40.5661V33.5743H149.322V45.6848H149.331Z"
                fill="white"/>
              <path
                d="M163.315 45.6847H160.12V38.3304C160.12 37.4413 160.076 35.9394 158.041 35.9394C156.621 35.9394 155.53 36.8975 155.53 38.7447V45.6934H152.335V33.5656H155.4V35.3438H155.444C155.877 34.6187 156.795 33.2462 159.098 33.2462C161.47 33.2462 163.323 34.636 163.323 37.3032V45.6847H163.315Z"
                fill="white"/>
              <path
                d="M172.484 45.4776C170.978 49.9662 170.562 50.5531 167.774 50.5531C167.341 50.5531 166.796 50.5272 166.337 50.51V47.9549C166.475 47.9808 166.683 47.9981 166.951 47.9981C168.12 47.9981 168.752 47.8427 169.055 46.1768L164.579 33.5656H168.146L170.753 42.491H170.796L173.29 33.5656H176.675L172.484 45.4776Z"
                fill="white"/>
              <path
                d="M187.706 36.7508C187.706 33.7642 184.581 33.2462 182.866 33.2462C180.372 33.2462 177.792 33.7728 177.428 37.4845H180.511C180.606 36.7767 180.875 35.8013 182.476 35.8013C183.299 35.8013 184.581 35.8703 184.581 37.2169C184.581 37.8988 183.966 38.106 183.464 38.175L180.589 38.6066C178.554 38.9001 177.047 40.1086 177.047 42.4823C177.047 44.9856 178.918 46.0128 180.753 46.0128C182.927 46.0128 183.948 45.0115 184.684 44.2605C184.754 44.9424 184.797 45.1237 184.979 45.6934H188.425V45.2186C188.035 45.0805 187.715 44.7611 187.715 43.3282V36.7508H187.706ZM184.572 41.3343C184.572 42.8103 183.135 43.7253 181.714 43.7253C181.1 43.7253 180.225 43.38 180.225 42.2665C180.225 40.9459 181.204 40.6524 182.399 40.4452C183.723 40.238 184.252 40.0309 184.572 39.7806V41.3343Z"
                fill="white"/>
              <path
                d="M225.049 6.22543H231.177L239.84 29.3083H233.501L232.092 25.1814H224.063L222.584 29.3083H216.385L225.049 6.22543ZM225.471 20.7047H230.754L228.148 12.5907H228.078L225.471 20.7047Z"
                fill="white"/>
              <path
                d="M257.027 14.4792C256.674 12.1709 254.914 10.9118 252.378 10.9118C248.504 10.9118 246.954 14.3393 246.954 17.7667C246.954 21.1942 248.433 24.6217 252.378 24.6217C255.195 24.6217 256.815 23.0128 257.027 20.3548H263.084C262.732 26.3004 258.365 29.7978 252.519 29.7978C245.475 29.7978 240.967 24.4818 240.967 17.7667C240.967 11.0517 245.475 5.73566 252.519 5.73566C257.52 5.73566 262.943 8.88332 263.084 14.4792H257.027Z"
                fill="white"/>
              <path
                d="M281.75 14.4792C281.398 12.1709 279.637 10.9118 277.101 10.9118C273.227 10.9118 271.677 14.3393 271.677 17.7667C271.677 21.1942 273.157 24.6217 277.101 24.6217C279.918 24.6217 281.538 23.0128 281.75 20.3548H287.807C287.455 26.3004 283.088 29.7978 277.242 29.7978C270.198 29.7978 265.69 24.4818 265.69 17.7667C265.69 11.0517 270.128 5.73566 277.171 5.73566C282.172 5.73566 287.596 8.88332 287.737 14.4792H281.75Z"
                fill="white"/>
              <path d="M290.977 6.22543H297.034V29.3083H290.977V6.22543Z" fill="white"/>
              <path
                d="M311.826 5.73575C319.151 5.73575 323.236 11.0518 323.236 17.7668C323.236 24.4818 319.081 29.7979 311.826 29.7979C304.501 29.7979 300.415 24.4818 300.415 17.7668C300.415 11.0518 304.501 5.73575 311.826 5.73575ZM311.826 24.6217C315.7 24.6217 317.249 21.1943 317.249 17.7668C317.249 14.3394 315.77 10.9119 311.826 10.9119C307.952 10.9119 306.402 14.3394 306.402 17.7668C306.402 21.1943 307.881 24.6217 311.826 24.6217ZM317.461 0L312.389 4.82642H308.515L311.685 0H317.461Z"
                fill="white"/>
              <path
                d="M219.555 39.8705C220.048 39.8705 220.471 40.0103 220.682 40.2901C220.823 40.43 220.964 40.7098 221.034 41.0596H222.513C222.513 40.6399 222.302 40.2202 222.02 39.8005C221.457 39.0311 220.682 38.6813 219.484 38.6813C218.639 38.6813 217.935 38.9611 217.371 39.5207C216.737 40.1502 216.385 41.0596 216.385 42.3186C216.385 43.4378 216.667 44.2772 217.23 44.9067C217.794 45.5363 218.569 45.886 219.555 45.886C220.33 45.886 221.034 45.6761 221.527 45.1865C222.02 44.6269 222.302 44.0673 222.443 43.2979H221.034C220.964 43.6477 220.823 43.9274 220.682 44.0673C220.4 44.4171 220.048 44.557 219.555 44.557C219.062 44.557 218.639 44.3471 218.357 43.9974C218.076 43.6477 217.864 43.0181 217.864 42.2487C217.864 41.4793 218.005 40.8497 218.287 40.43C218.639 40.0803 218.991 39.8705 219.555 39.8705Z"
                fill="white"/>
              <path
                d="M227.796 45.2565C227.725 45.1866 227.725 45.0467 227.725 44.9068C227.725 44.6969 227.725 44.4871 227.725 44.3472V42.0389C227.725 41.4094 227.514 40.9897 227.091 40.7799C226.669 40.57 226.176 40.4301 225.612 40.4301C224.767 40.4301 224.133 40.64 223.781 41.1296C223.57 41.4094 223.429 41.7591 223.429 42.2488H224.697C224.697 42.0389 224.767 41.899 224.908 41.7591C225.049 41.6192 225.26 41.5493 225.612 41.5493C225.894 41.5493 226.105 41.6192 226.246 41.6892C226.387 41.7591 226.458 41.899 226.458 42.1089C226.458 42.2488 226.387 42.3887 226.176 42.4586C226.035 42.5286 225.894 42.5286 225.612 42.5985L225.119 42.6685C224.626 42.7384 224.204 42.8783 223.922 43.0182C223.429 43.298 223.218 43.7177 223.218 44.3472C223.218 44.8368 223.358 45.1866 223.64 45.4664C223.922 45.7462 224.345 45.8861 224.767 45.8861C225.119 45.8861 225.471 45.8161 225.753 45.6063C225.965 45.4664 226.176 45.3265 226.387 45.1166C226.387 45.2565 226.387 45.3265 226.458 45.3964C226.458 45.4664 226.528 45.6063 226.528 45.6762H228.007V45.4664C227.866 45.3964 227.796 45.3265 227.796 45.2565ZM226.387 43.6477C226.387 44.0674 226.246 44.4172 226.035 44.5571C225.824 44.697 225.542 44.8368 225.26 44.8368C225.049 44.8368 224.908 44.7669 224.767 44.697C224.626 44.627 224.556 44.4172 224.556 44.2073C224.556 43.9275 224.626 43.7876 224.838 43.6477C224.978 43.5778 225.19 43.5078 225.471 43.4379L225.753 43.3679C225.894 43.3679 226.035 43.298 226.105 43.298C226.176 43.298 226.246 43.228 226.387 43.1581V43.6477Z"
                fill="white"/>
              <path
                d="M230.402 39.171H229.064V40.5699H228.359V41.5492H229.064V44.6969C229.064 45.0466 229.134 45.2564 229.275 45.3963C229.486 45.6062 229.909 45.7461 230.543 45.7461H231.177V44.7668C231.106 44.7668 231.106 44.7668 231.036 44.7668C230.965 44.7668 230.965 44.7668 230.895 44.7668C230.613 44.7668 230.472 44.7668 230.402 44.6969C230.332 44.6269 230.332 44.487 230.332 44.2772V41.6191H231.177V40.6399H230.332V39.171H230.402Z"
                fill="white"/>
              <path
                d="M234.91 45.0467C234.91 45.1866 234.91 45.2565 234.98 45.3265C234.98 45.3964 235.051 45.5363 235.051 45.6062H236.53V45.4663C236.459 45.3964 236.389 45.3964 236.319 45.3265C236.248 45.2565 236.248 45.1166 236.248 44.9767C236.248 44.7669 236.248 44.557 236.248 44.4171V42.1088C236.248 41.4793 236.037 41.0596 235.614 40.8498C235.192 40.6399 234.699 40.5 234.135 40.5C233.29 40.5 232.656 40.7099 232.304 41.1995C232.092 41.4793 231.952 41.829 231.952 42.3187H233.219C233.219 42.1088 233.29 41.9689 233.431 41.829C233.572 41.6891 233.783 41.6192 234.135 41.6192C234.417 41.6192 234.628 41.6891 234.769 41.7591C234.91 41.829 234.98 41.9689 234.98 42.1788C234.98 42.3187 234.91 42.4586 234.699 42.5285C234.558 42.5985 234.417 42.5985 234.135 42.6684L233.642 42.7384C233.149 42.8083 232.726 42.8783 232.445 43.0881C231.952 43.3679 231.74 43.7876 231.74 44.4171C231.74 44.9068 231.881 45.2565 232.163 45.5363C232.445 45.8161 232.867 45.956 233.29 45.956C233.642 45.956 233.994 45.886 234.276 45.6762C234.558 45.3964 234.769 45.2565 234.91 45.0467ZM233.219 44.6969C233.079 44.627 233.008 44.4171 233.008 44.2073C233.008 43.9275 233.079 43.7876 233.29 43.6477C233.431 43.5777 233.642 43.5078 233.924 43.4378L234.205 43.3679C234.346 43.3679 234.487 43.298 234.558 43.298C234.628 43.298 234.699 43.228 234.839 43.1581V43.6477C234.839 44.0674 234.699 44.4171 234.487 44.557C234.276 44.6969 233.994 44.8368 233.712 44.8368C233.501 44.8368 233.36 44.7669 233.219 44.6969Z"
                fill="white"/>
              <path d="M238.784 38.7516H237.446V45.6065H238.784V38.7516Z" fill="white"/>
              <path
                d="M242.376 45.8161C243.221 45.8161 243.925 45.5363 244.348 45.0467C244.771 44.4871 244.982 43.8576 244.982 43.1581C244.982 42.4586 244.771 41.7591 244.348 41.2695C243.925 40.7099 243.292 40.4301 242.376 40.4301C241.531 40.4301 240.826 40.7099 240.404 41.2695C239.981 41.8291 239.77 42.4586 239.77 43.1581C239.77 43.9275 239.981 44.5571 240.404 45.0467C240.826 45.5363 241.46 45.8161 242.376 45.8161ZM241.46 41.899C241.672 41.6192 241.953 41.4793 242.376 41.4793C242.799 41.4793 243.08 41.6192 243.292 41.899C243.503 42.1788 243.573 42.5985 243.573 43.0881C243.573 43.5778 243.503 43.9975 243.292 44.2773C243.08 44.5571 242.799 44.697 242.376 44.697C241.953 44.697 241.672 44.5571 241.46 44.2773C241.249 43.9975 241.178 43.5778 241.178 43.0881C241.108 42.5985 241.249 42.1788 241.46 41.899Z"
                fill="white"/>
              <path
                d="M247.306 42.8783C247.306 42.5985 247.377 42.3187 247.447 42.1089C247.588 41.7591 247.94 41.5493 248.363 41.5493C248.715 41.5493 248.997 41.6892 249.138 41.969C249.208 42.1089 249.278 42.3187 249.278 42.5985V45.6762H250.617V42.2488C250.617 41.6192 250.476 41.1296 250.124 40.8498C249.772 40.57 249.349 40.4301 248.856 40.4301C248.433 40.4301 248.081 40.5001 247.799 40.7099C247.658 40.8498 247.518 40.9897 247.306 41.2695V40.57H245.968V45.6063H247.306V42.8783Z"
                fill="white"/>
              <path d="M253.153 40.5699H251.814V45.6761H253.153V40.5699Z" fill="white"/>
              <path d="M253.153 38.7516H251.814V40.0107H253.153V38.7516Z" fill="white"/>
              <path
                d="M257.027 42.4586C256.886 42.5285 256.745 42.5285 256.463 42.5985L255.97 42.6684C255.477 42.7384 255.054 42.8783 254.773 43.0182C254.28 43.298 254.068 43.7176 254.068 44.3472C254.068 44.8368 254.209 45.1866 254.491 45.4663C254.773 45.7461 255.195 45.886 255.618 45.886C255.97 45.886 256.322 45.8161 256.604 45.6062C256.815 45.4663 257.027 45.3265 257.238 45.1166C257.238 45.2565 257.238 45.3265 257.308 45.3964C257.308 45.4663 257.379 45.6062 257.379 45.6762H258.858V45.4663C258.788 45.3964 258.717 45.3964 258.647 45.3265C258.576 45.2565 258.576 45.1166 258.576 44.9767C258.576 44.7669 258.576 44.557 258.576 44.4171V42.1088C258.576 41.4793 258.365 41.0596 257.942 40.8498C257.52 40.6399 257.027 40.5 256.463 40.5C255.618 40.5 254.984 40.7099 254.632 41.1995C254.421 41.4793 254.28 41.829 254.28 42.3187H255.548C255.548 42.1088 255.618 41.9689 255.759 41.829C255.9 41.6891 256.111 41.6192 256.463 41.6192C256.745 41.6192 256.956 41.6891 257.097 41.7591C257.238 41.829 257.308 41.9689 257.308 42.1788C257.308 42.2487 257.238 42.3187 257.027 42.4586ZM257.308 43.6477C257.308 44.0674 257.168 44.4171 256.956 44.557C256.745 44.6969 256.463 44.8368 256.181 44.8368C255.97 44.8368 255.829 44.7669 255.688 44.6969C255.548 44.627 255.477 44.4171 255.477 44.2073C255.477 43.9275 255.548 43.7876 255.759 43.6477C255.9 43.5777 256.111 43.5078 256.393 43.4379L256.674 43.3679C256.815 43.3679 256.956 43.298 257.027 43.298C257.097 43.298 257.168 43.228 257.308 43.1581V43.6477Z"
                fill="white"/>
              <path d="M233.713 48.0544H235.755V53.7202H237.234V48.0544H239.348V46.8653H233.713V48.0544Z" fill="white"/>
              <path
                d="M242.306 48.544C241.883 48.544 241.601 48.614 241.32 48.8238C241.179 48.9637 240.967 49.1736 240.756 49.5233V48.614H239.488V53.7202H240.827V51.272C240.827 50.8523 240.897 50.5725 240.967 50.3627C241.179 50.0129 241.531 49.8731 242.024 49.8731C242.094 49.8731 242.094 49.8731 242.165 49.8731C242.235 49.8731 242.306 49.8731 242.376 49.8731V48.544C242.447 48.544 242.376 48.544 242.306 48.544Z"
                fill="white"/>
              <path
                d="M247.518 53.3705C247.447 53.3005 247.447 53.1606 247.447 53.0207C247.447 52.8109 247.447 52.601 247.447 52.4611V50.1528C247.447 49.5233 247.236 49.1036 246.813 48.8938C246.391 48.6839 245.898 48.544 245.334 48.544C244.489 48.544 243.855 48.7539 243.503 49.2435C243.291 49.5233 243.151 49.8731 243.151 50.3627H244.418C244.418 50.1528 244.489 50.0129 244.63 49.8731C244.771 49.7332 244.982 49.6632 245.334 49.6632C245.616 49.6632 245.827 49.7332 245.968 49.8031C246.109 49.873 246.179 50.0129 246.179 50.2228C246.179 50.3627 246.109 50.5026 245.898 50.5725C245.757 50.6425 245.616 50.6425 245.334 50.7124L244.841 50.7824C244.348 50.8523 243.925 50.9223 243.644 51.1321C243.151 51.4119 242.939 51.8316 242.939 52.4611C242.939 52.9508 243.08 53.3005 243.362 53.5803C243.644 53.8601 244.066 54 244.489 54C244.841 54 245.193 53.93 245.475 53.7202C245.686 53.5803 245.898 53.4404 246.109 53.2306C246.109 53.3705 246.109 53.4404 246.179 53.5104C246.179 53.5803 246.25 53.7202 246.25 53.7901H247.729V53.5803C247.658 53.5104 247.588 53.4404 247.518 53.3705ZM246.109 51.7616C246.109 52.1813 245.968 52.5311 245.757 52.671C245.545 52.8109 245.264 52.9508 244.982 52.9508C244.771 52.9508 244.63 52.8808 244.489 52.8109C244.348 52.7409 244.277 52.5311 244.277 52.3212C244.277 52.0414 244.348 51.9015 244.559 51.7616C244.7 51.6917 244.911 51.6218 245.193 51.5518L245.475 51.4819C245.616 51.4819 245.757 51.4119 245.827 51.4119C245.898 51.4119 245.968 51.342 246.109 51.272V51.7616Z"
                fill="white"/>
              <path
                d="M251.815 49.3135C251.674 49.1036 251.462 48.8938 251.251 48.7539C251.04 48.614 250.758 48.5441 250.406 48.5441C249.701 48.5441 249.208 48.8238 248.786 49.3135C248.363 49.8031 248.152 50.5026 248.152 51.342C248.152 52.1114 248.363 52.7409 248.786 53.1606C249.208 53.6503 249.701 53.8601 250.265 53.8601C250.617 53.8601 250.899 53.7902 251.181 53.6503C251.392 53.5104 251.674 53.3005 251.815 53.0207V53.7202H253.082V46.8653H251.744V49.3135H251.815ZM251.533 52.3912C251.321 52.671 251.04 52.8109 250.688 52.8109C250.335 52.8109 250.054 52.671 249.842 52.3912C249.631 52.1114 249.561 51.7617 249.561 51.272C249.561 50.8523 249.631 50.5026 249.842 50.1529C250.054 49.8731 250.335 49.7332 250.688 49.7332C250.969 49.7332 251.181 49.8031 251.392 49.943C251.674 50.2228 251.885 50.6425 251.885 51.272C251.885 51.6917 251.744 52.1114 251.533 52.3912Z"
                fill="white"/>
              <path
                d="M258.647 49.5233C258.435 49.1736 258.154 48.9637 257.731 48.7539C257.379 48.614 256.956 48.544 256.533 48.544C255.759 48.544 255.195 48.7539 254.702 49.2435C254.209 49.7332 253.998 50.3627 253.998 51.272C253.998 52.1813 254.28 52.8808 254.773 53.3005C255.266 53.7202 255.9 53.93 256.604 53.93C257.449 53.93 258.083 53.6502 258.506 53.1606C258.787 52.8808 258.999 52.5311 258.999 52.2513H257.66C257.59 52.3912 257.52 52.5311 257.379 52.601C257.167 52.7409 256.956 52.8109 256.604 52.8109C256.322 52.8109 256.04 52.7409 255.9 52.601C255.547 52.3912 255.407 52.0414 255.336 51.5518H259.069C259.069 51.1321 259.069 50.7824 258.999 50.5725C258.999 50.1528 258.858 49.8031 258.647 49.5233ZM255.407 50.7124C255.477 50.3627 255.547 50.1528 255.759 49.943C255.97 49.7332 256.181 49.6632 256.533 49.6632C256.815 49.6632 257.097 49.7332 257.308 49.943C257.52 50.1528 257.66 50.3627 257.66 50.7124H255.407Z"
                fill="white"/>
              <path d="M274.776 46.8653H273.368V53.7202H274.776V46.8653Z" fill="white"/>
              <path
                d="M278.862 48.544C278.439 48.544 278.087 48.614 277.805 48.8238C277.664 48.9637 277.524 49.1036 277.312 49.3834V48.614H276.044V53.6502H277.383V50.9223C277.383 50.6425 277.453 50.3627 277.524 50.1528C277.664 49.8031 278.017 49.5933 278.439 49.5933C278.791 49.5933 279.073 49.7332 279.214 50.0129C279.284 50.1528 279.355 50.3627 279.355 50.6425V53.7202H280.693V50.2927C280.693 49.6632 280.552 49.1736 280.2 48.8938C279.848 48.6839 279.425 48.544 278.862 48.544Z"
                fill="white"/>
              <path
                d="M284.003 52.3912L282.876 48.684H281.397L283.229 53.7202H284.637L286.469 48.684H285.06L284.003 52.3912Z"
                fill="white"/>
              <path
                d="M291.47 49.5233C291.258 49.1736 290.977 48.9637 290.554 48.7539C290.202 48.614 289.779 48.544 289.357 48.544C288.582 48.544 288.018 48.7539 287.525 49.2435C287.032 49.7332 286.821 50.3627 286.821 51.272C286.821 52.1813 287.103 52.8808 287.596 53.3005C288.089 53.7202 288.723 53.93 289.427 53.93C290.272 53.93 290.906 53.6502 291.329 53.1606C291.611 52.8808 291.822 52.5311 291.822 52.2513H290.484C290.413 52.3912 290.343 52.5311 290.202 52.601C289.991 52.7409 289.779 52.8109 289.427 52.8109C289.145 52.8109 288.864 52.7409 288.723 52.601C288.371 52.3912 288.23 52.0414 288.159 51.5518H291.892C291.892 51.1321 291.892 50.7824 291.822 50.5725C291.822 50.1528 291.681 49.8031 291.47 49.5233ZM288.23 50.7124C288.3 50.3627 288.371 50.1528 288.582 49.943C288.793 49.7332 289.005 49.6632 289.357 49.6632C289.638 49.6632 289.92 49.7332 290.132 49.943C290.343 50.1528 290.484 50.3627 290.484 50.7124H288.23Z"
                fill="white"/>
              <path
                d="M295.344 50.7124C294.569 50.5725 294.076 50.4326 293.935 50.3627C293.794 50.2927 293.724 50.1528 293.724 50.0129C293.724 49.8731 293.794 49.8031 293.935 49.6632C294.076 49.5933 294.287 49.5233 294.569 49.5233C294.921 49.5233 295.203 49.5933 295.344 49.8031C295.414 49.873 295.485 50.0129 295.485 50.2228H296.823C296.753 49.5933 296.541 49.1736 296.119 48.8938C295.696 48.614 295.203 48.544 294.569 48.544C293.865 48.544 293.372 48.6839 293.02 49.0337C292.667 49.3834 292.456 49.8031 292.456 50.2228C292.456 50.6425 292.597 50.9223 292.808 51.1321C293.02 51.342 293.442 51.5518 294.006 51.6917C294.78 51.9015 295.273 52.0414 295.414 52.1114C295.555 52.1813 295.626 52.3212 295.626 52.4611C295.626 52.601 295.555 52.7409 295.414 52.8109C295.273 52.8808 295.062 52.9508 294.78 52.9508C294.358 52.9508 294.006 52.8808 293.865 52.671C293.794 52.601 293.724 52.3912 293.653 52.1813H292.315C292.315 52.671 292.526 53.1606 292.879 53.4404C293.231 53.7901 293.865 53.93 294.64 53.93C295.414 53.93 296.048 53.7901 296.4 53.4404C296.753 53.0907 296.964 52.7409 296.964 52.1813C296.964 51.8316 296.823 51.4819 296.541 51.2021C296.33 50.9922 295.907 50.7824 295.344 50.7124Z"
                fill="white"/>
              <path
                d="M299.429 47.2851H298.091V48.684H297.386V49.6633H298.091V52.811C298.091 53.1607 298.161 53.3706 298.302 53.5104C298.513 53.7203 298.936 53.8602 299.57 53.8602H300.204V52.8809C300.133 52.8809 300.133 52.8809 300.063 52.8809C299.993 52.8809 299.993 52.8809 299.922 52.8809C299.64 52.8809 299.5 52.8809 299.429 52.811C299.359 52.741 299.359 52.6011 299.359 52.3913V49.6633H300.204V48.684H299.359V47.2851H299.429Z"
                fill="white"/>
              <path
                d="M308.093 49.1037C307.881 48.8938 307.741 48.7539 307.529 48.614C307.318 48.5441 307.107 48.4741 306.895 48.4741C306.543 48.4741 306.261 48.5441 305.98 48.684C305.698 48.8239 305.487 49.0337 305.346 49.3135C305.275 49.0337 305.064 48.8938 304.923 48.684C304.712 48.5441 304.36 48.4042 304.007 48.4042C303.585 48.4042 303.233 48.4741 303.021 48.684C302.881 48.8239 302.74 48.9638 302.528 49.2436V48.4741H301.26V53.5104H302.599V50.4327C302.599 50.1529 302.669 49.943 302.74 49.8031C302.881 49.5233 303.092 49.4534 303.514 49.4534C303.867 49.4534 304.078 49.5933 304.148 49.8031C304.219 49.943 304.219 50.1529 304.219 50.4327V53.4404H305.557V50.4327C305.557 50.2228 305.628 50.013 305.698 49.8731C305.839 49.5933 306.121 49.3834 306.473 49.3834C306.825 49.3834 307.036 49.5233 307.107 49.7332C307.177 49.8731 307.177 50.013 307.177 50.2228V53.4404H308.515V50.2228C308.515 49.8731 308.515 49.6632 308.445 49.4534C308.375 49.5233 308.234 49.3135 308.093 49.1037Z"
                fill="white"/>
              <path
                d="M313.868 49.5233C313.657 49.1736 313.375 48.9637 312.953 48.7539C312.601 48.614 312.178 48.544 311.755 48.544C310.981 48.544 310.417 48.7539 309.924 49.2435C309.431 49.7332 309.22 50.3627 309.22 51.272C309.22 52.1813 309.501 52.8808 309.995 53.3005C310.488 53.7202 311.121 53.93 311.826 53.93C312.671 53.93 313.305 53.6502 313.728 53.1606C314.009 52.8808 314.221 52.5311 314.221 52.2513H312.882C312.812 52.3912 312.742 52.5311 312.601 52.601C312.389 52.7409 312.178 52.8109 311.826 52.8109C311.544 52.8109 311.262 52.7409 311.121 52.601C310.769 52.3912 310.628 52.0414 310.558 51.5518H314.291C314.291 51.1321 314.291 50.7824 314.221 50.5725C314.221 50.1528 314.08 49.8031 313.868 49.5233ZM310.628 50.7124C310.699 50.3627 310.769 50.1528 310.981 49.943C311.192 49.7332 311.403 49.6632 311.755 49.6632C312.037 49.6632 312.319 49.7332 312.53 49.943C312.742 50.1528 312.882 50.3627 312.882 50.7124H310.628Z"
                fill="white"/>
              <path
                d="M317.883 48.544C317.461 48.544 317.109 48.614 316.827 48.8238C316.686 48.9637 316.545 49.1036 316.334 49.3834V48.614H315.066V53.6502H316.404V50.9223C316.404 50.6425 316.475 50.3627 316.545 50.1528C316.686 49.8031 317.038 49.5933 317.461 49.5933C317.813 49.5933 318.095 49.7332 318.236 50.0129C318.306 50.1528 318.376 50.3627 318.376 50.6425V53.7202H319.715V50.2927C319.715 49.6632 319.574 49.1736 319.222 48.8938C318.799 48.6839 318.376 48.544 317.883 48.544Z"
                fill="white"/>
              <path
                d="M323.236 49.6633V48.684H322.391V47.2851H321.053V48.684H320.349V49.6633H321.053V52.811C321.053 53.1607 321.123 53.3706 321.264 53.5104C321.476 53.7203 321.898 53.8602 322.532 53.8602H323.166V52.8809C323.096 52.8809 323.096 52.8809 323.025 52.8809C322.955 52.8809 322.955 52.8809 322.884 52.8809C322.603 52.8809 322.462 52.8809 322.391 52.811C322.321 52.741 322.321 52.6011 322.321 52.3913V49.6633H323.236Z"
                fill="white"/>
              <path
                d="M269.916 49.943C270.198 49.1736 270.409 48.3342 270.55 47.4948H269.001C268.93 47.9145 268.86 48.2643 268.789 48.4741C268.719 48.684 268.648 49.1037 268.437 49.5233L266.042 46.6555C266.747 46.1658 267.31 45.7461 267.592 45.3964C268.155 44.7669 268.367 43.9974 268.367 43.1581C268.367 42.4586 268.085 41.829 267.592 41.2695C267.099 40.7798 266.324 40.5 265.408 40.5C264.422 40.5 263.647 40.7798 263.084 41.3394C262.52 41.899 262.239 42.5985 262.239 43.4378C262.239 43.8575 262.309 44.2772 262.52 44.6969C262.732 45.1166 263.084 45.6762 263.647 46.3057C262.591 46.9353 261.957 47.4249 261.534 47.8446C260.9 48.5441 260.619 49.3834 260.619 50.3627C260.619 51.272 260.9 52.1114 261.534 52.8808C262.168 53.6503 263.154 54 264.563 54C265.479 54 266.324 53.7902 267.028 53.3705C267.451 53.0907 267.874 52.741 268.367 52.1814L269.634 53.7202H271.748L269.423 50.8524C269.564 50.8524 269.705 50.5026 269.916 49.943ZM264.07 42.4586C264.352 42.0389 264.774 41.7591 265.479 41.7591C265.901 41.7591 266.254 41.899 266.535 42.1788C266.817 42.4586 266.958 42.8083 266.958 43.1581C266.958 43.6477 266.747 44.1373 266.394 44.4871C266.183 44.7669 265.76 45.0467 265.197 45.4663C264.704 44.9068 264.352 44.4871 264.211 44.1373C264 43.7876 263.929 43.4378 263.929 43.0881C263.859 42.9482 263.929 42.7384 264.07 42.4586ZM266.465 52.1114C265.972 52.3912 265.408 52.6011 264.704 52.6011C264.14 52.6011 263.577 52.3912 263.084 52.0415C262.591 51.6917 262.309 51.1321 262.309 50.4327C262.309 49.8031 262.52 49.2435 262.873 48.7539C263.154 48.4741 263.718 48.0544 264.563 47.4249L267.592 51.0622C267.31 51.4819 266.958 51.8316 266.465 52.1114Z"
                fill="white"/>
            </svg>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import {mapActions, mapGetters} from "vuex";

export default {
  name: 'HomeView',

  computed: {
    ...mapGetters(['getActiveLink', 'getContactsActive'])
  },

  data: () => ({
    drop: false,
    enInfoOpen: false,
    contacts: {
      phone: {label: '+(34) 93 852 41 24', href: 'tel:+34938524124'},
      email: {
        pharmacovigilance: 'farmacovigilancia@farmak.es',
        general: 'info@farmak.es',
        dpo: 'dpo@farmak.es',
      },
    },
  }),

  methods: {
    ...mapActions(['switchLink']),

    next() {

      if (window.matchMedia("(min-width: 1080px)").matches) {
        window.scrollTo({
          top: document.getElementById('news').offsetTop - 79,
          left: 0,
          behavior: "smooth",
        });
      } else if (window.matchMedia("(max-width: 1079px)").matches) {
        window.scrollTo({
          top: document.getElementById('news').offsetTop - 64,
          left: 0,
          behavior: "smooth",
        });
      }
    },

  },

  mounted() {
    const headings = document.querySelectorAll('section');

    const scrollElements = document.querySelectorAll(".js-scroll");

    const elementInView = (el, dividend = 1) => {
      const elementTop = el.getBoundingClientRect().top;

      return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) / dividend
      );
    };

    const elementOutofView = (el) => {
      const elementTop = el.getBoundingClientRect().top;

      return (
        elementTop > (window.innerHeight || document.documentElement.clientHeight)
      );
    };

    const displayScrollElement = (element) => {
      element.classList.add("scrolled");
    };

    const hideScrollElement = (element) => {
      element.classList.remove("scrolled");
    };

    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        if (elementInView(el, 1.1)) {
          displayScrollElement(el);
        } else if (elementOutofView(el)) {
          hideScrollElement(el)
        }
      })
    }
    if (window.matchMedia("(min-width: 861px)").matches) {
      window.addEventListener("scroll", () => {

        handleScrollAnimation()

        headings.forEach(ha => {
          const rect = ha.getBoundingClientRect();

          if (rect.top + 200 < window.innerHeight && rect.bottom - 200 >= 0) {
            const location = window.location.toString().split('#')[0];
            this.switchLink(ha.id);
            history.replaceState(null, null, location + '#' + ha.id);
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/styles";

.js-scroll {
  opacity: 0;
  @media screen and (max-width: 1024px) {
    opacity: 1;
  }
}

.scrolled.fade-in-bottom {
  animation: fade-in-bottom .6s ease-in-out both;

  &.delay-fade1 {
    animation-delay: .5s;
  }

  &.delay-fade2 {
    animation-delay: .6s;
  }

  &.delay-fade3 {
    animation-delay: 1200ms;
  }

  &.delay-fade4 {
    animation-delay: 1400ms;
  }

  &.delay-fade5 {
    animation-delay: 1500ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.width-animation {
  animation: width-animation .6s ease-in-out both;

  &.delay-width1 {
    animation-delay: 900ms;
  }

  &.delay-width2 {
    animation-delay: 1000ms;
  }

  &.delay-width3 {
    animation-delay: 1100ms;
  }

  &.delay-width4 {
    animation-delay: 1200ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.width-animation2 {
  animation: width-animation .6s ease-in-out both;

  &.delay-width1 {
    animation-delay: 100ms;
  }

  &.delay-width2 {
    animation-delay: 200ms;
  }

  &.delay-width3 {
    animation-delay: 300ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.rotate-animation {
  animation: rotate-animation .8s ease-in-out both;

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

@keyframes fade-in-bottom {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes width-animation {
  0% {
    width: 0;
    opacity: 0;
  }
  100% {
    width: 100%;
    opacity: 1;
  }
}

@keyframes rotate-animation {
  0% {
    opacity: 0;
    transform: rotate(0deg);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}

.home {
  display: flex;
  justify-content: center;
  width: 100%;

  .left-side {
    max-width: 50%;
    min-width: 50%;
    width: 100%;

    @media screen and (max-width: 1080px) {
      max-width: 100%;
      min-width: 1px;
    }
  }

  .right-side {

    display: flex;
    flex-direction: column;

    max-width: 50%;
    min-width: 50%;
    width: 100%;

    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
    min-height: calc((var(--vh, 1vh) * 100));
    max-height: calc((var(--vh, 1vh) * 100));
    height: 100%;
    background: $blue-50;

    padding: 0 40px;

    @media screen and (max-width: 1080px) {
      display: none;
    }

    .wrapper {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto 0;
      max-width: 680px;
      max-height: 680px;
      width: 100%;

      .text-block {
        position: absolute;
        bottom: 115px;
        padding: 10px;
        background: $blue-80;
        max-width: 208px;

        width: 100%;

        line-height: 120%; /* 19.2px */
        text-transform: uppercase;
        font-family: $reg;
        font-size: 16px;
        color: white;
        @media screen and (max-height: 750px) {
          bottom: 160px;
        }


        &.text-block1 {
          left: 40px;
        }

        &.text-block2 {
          right: 40px;
        }
      }
    }

    picture {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto 0;
      max-width: 680px;
      width: 100%;

      img {
        //position: absolute;
        //top: 50%;
        //left: 50%;
        //
        //transform: translate(-50%, -50%);
        margin-top: -60px;
        max-height: 680px;
        min-width: 1px;
        width: auto;
        height: 100%;
        display: block;
        padding: 40px;
        object-fit: contain;
        overflow: visible;
        @media screen and (max-height: 750px) {
          margin-top: 0;
        }
      }
    }

    &__info {
      margin: auto 0 0 0;
      max-width: 600px;
      width: 100%;
      background: rgba(0, 158, 224, 0.50);
      padding-top: 10px;
      padding-bottom: 44px;
      position: relative;

      .mark {
        width: 16px;
        height: 16px;

        background: $crimson;
        border-radius: 50%;
        margin-bottom: 15px;
      }

      .line {
        width: 100%;
        padding-bottom: 16px;
        margin-bottom: 24px;
        border-bottom: 2px solid $white;

        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
          margin-bottom: 0;
        }
      }

      .col {
        &.col1 {
          max-width: 220px;
        }
      }

      .address {
        color: $white;
        font-size: 16px;
        font-family: $bold;
        line-height: 120%;
        //letter-spacing: -0.04em;
      }

      .sales-mail {
        position: relative;
        font-size: 18px;
        line-height: 120%;
        font-family: $bold;
        color: $white;

        display: inline-flex;
        align-items: center;
        text-decoration: none;
        //letter-spacing: -0.04em;
        p {
          display: flex;
          align-items: center;
          transition: transform .2s ease;
        }

        @media screen and (min-width: 1240px) {
          &:hover {
            p {
              transform: translateY(-2px);
            }
          }
        }

        svg {
          display: block;
          width: 21px;
          height: auto;
          margin-left: 10px;
        }

        &:before {
          content: '';
          width: 100%;
          height: 2px;
          bottom: -4px;
          left: 0;
          right: 0;
          position: absolute;

          background: $white;
        }
      }

      .support-text {
        font-family: $bold;
        color: var(--White, #FFF);
        font-size: 16px;
        font-style: normal;
        line-height: 136%; /* 21.76px */
        letter-spacing: -0.32px;
        text-transform: uppercase;
        margin-bottom: 20px;
      }

      .support-logo {
        max-width: 324px;
        width: 100%;
        height: auto;
        display: block;
      }
    }

    &__country-switch-wrapper {
      max-width: 600px;
      position: absolute;
      width: 100%;
      left: 0;
      top: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      z-index: 10;

      p {
        line-height: 136%;
        font-family: $bold;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        text-transform: uppercase;
        padding: 4px 6px;
      }
    }

    &__country-switch {
      position: relative;

      .show {
        color: white;
        font-size: 12px;
        line-height: 136%;
        font-family: $bold;
        text-transform: uppercase;
        padding: 8px 12px;
        min-width: 110px;

        display: flex;
        align-items: center;
        cursor: pointer;

        &.active {
          color: $black-100;
          background: rgba(255, 255, 255, 1);

          svg {
            transform-origin: center;
            transform: rotate(180deg);

            path {
              fill: $black-100;
            }
          }
        }

        svg {
          display: block;
          width: 16px;
          height: auto;
          margin-left: 9px;
        }
      }

      .hide {
        position: absolute;
        top: 100%;
        left: 0;

        display: flex;
        flex-direction: column;
        background: #26ADE5;
        width: 100%;

        a {
          padding: 8px 12px;
          text-transform: uppercase;

          text-decoration: none;
          color: white;
          font-size: 12px;
          font-family: $bold;
          line-height: 136%;

          @media screen and (min-width: 1240px) {
            &:hover {
              background: rgba(255, 255, 255, 0.30);
            }
          }
        }
      }
    }
  }
}

#home {
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 78px 40px 0 40px;
  background: $black-10;

  @media screen and (max-width: 1080px) {
    min-height: calc(((var(--vh, 1vh) * 100) - 64px));
    align-items: center;
    padding: 62px 0 0 0;
  }

  .bg {
    display: none;
    background: $blue-50;
    margin: 0 -20px;
    width: 100%;
    max-height: calc(((var(--vh, 1vh) * 30)));
    height: 100%;
    overflow: hidden;
    position: relative;

    img {
      display: block;
      width: calc(100% - 40px);
      height: 100%;
      margin-top: 50px;
      max-height: calc(((var(--vh, 1vh) * 48)));
      object-fit: contain;
    }

    @media screen and (max-width: 1080px) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(((var(--vh, 1vh) * 100) - 174px));
    max-width: 600px;
    width: 100%;

    @media screen and (max-width: 1080px) {
      max-width: 420px;
      padding: 20px 20px 0 20px;
      min-height: calc(((var(--vh, 1vh) * 70) - 171px));
    }
  }

  .scroll-down {
    color: $blue-50;
    font-family: $bold;
    font-size: 12px;
    margin: auto 0 40px 0;
    padding-top: 40px;

    display: flex;
    align-items: center;
    cursor: pointer;

    max-width: 600px;
    width: 100%;

    text-transform: uppercase;
    transition: color .2s ease;

    @media screen and (max-width: 1080px) {
      margin: auto 0 60px 0;
      padding: 33px 20px 0 20px;
      max-width: 380px;
    }

    @media screen and (min-width: 1240px) {
      &:hover {
        color: $blue-80;

        svg {
          path {
            fill: $blue-80;
          }
        }
      }
    }

    svg {
      width: 12px;
      height: auto;
      display: block;
      margin-right: 12px;

      path {
        transition: fill .2s ease;
      }
    }
  }

  h1 {
    color: $blue-50;
    font-family: $bold;
    letter-spacing: -0.04em;

    span {
      display: inline-block;

      &.small {
        font-size: 80px;
        line-height: 78%;

        @media screen and (max-width: 1230px) {
          font-size: 64px;
        }
        @media screen and (max-width: 1080px) {
          font-size: 40px;
        }

        &.m-l {
          margin-left: 20px;
          @media screen and (max-width: 1230px) {
            margin-left: 16px;
          }
        }
      }

      &.big {
        font-size: 120px;
        line-height: 78%;
        text-transform: uppercase;

        @media screen and (max-width: 1230px) {
          font-size: 98px;
        }
        @media screen and (max-width: 1080px) {
          font-size: 64px;
        }
      }

      &.bottom {
        display: flex;
        align-items: center;
      }

      &.line-wrapper {
        max-width: 350px;
        width: 100%;
        display: flex;
        flex-direction: column;

        @media screen and (max-width: 1230px) {
          max-width: 60%;
        }

        > span {
          width: 100%;
          margin-bottom: 7px;
          background: $blue-50;
          @media screen and (max-width: 1080px) {
            margin-bottom: 3px;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &.line1 {
        height: 16px;
        @media screen and (max-width: 1080px) {
          height: 8px;
        }
      }

      &.line2 {
        height: 10px;
        @media screen and (max-width: 1080px) {
          height: 5px;
        }
      }

      &.line3 {
        height: 5px;
        @media screen and (max-width: 1080px) {
          height: 2px;
        }
      }

      &.line4 {
        height: 2px;
        @media screen and (max-width: 1080px) {
          height: 1px;
        }
      }
    }
  }

  h2 {
    color: $black-80;
    font-family: $bold;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: -0.04em;
    margin-top: 24px;
    text-transform: uppercase;

    @media screen and (max-width: 1230px) {
      font-size: 24px;
    }
    @media screen and (max-width: 1080px) {
      font-size: 18px;
    }

    .mr1 {
      margin-right: 40px;
      @media screen and (max-width: 1230px) {
        margin-right: 20px;
      }
    }

    .mr2 {
      margin-right: 73px;
      @media screen and (max-width: 1230px) {
        margin-right: 40px;
      }
    }

    //@media screen and (max-width: 1280px) {
    //  font-size: 28px;
    //}
    //
    //@media screen and (max-width: 1080px) {
    //  font-size: 18px;
    //}

    .color {
      color: $blue-60;
    }
  }

  h3 {
    margin: 4px 0 0 auto;
    color: $black-100;
    line-height: 120%;
    font-size: 18px;
    font-family: $bold;
    @media screen and (max-width: 1080px) {
      font-size: 16px;
    }
  }

  .col {
    &.col-mob {
      margin-top: 40px;
      display: none;
      @media screen and (max-width: 1080px) {
        display: block;
      }
    }
  }

  .support-text {
    font-family: $bold;
    color: var(--White, #393B3D);
    font-size: 14px;
    font-style: normal;
    line-height: 136%; /* 21.76px */
    letter-spacing: -0.32px;
    text-transform: uppercase;
    margin-bottom: 20px;
  }

  .support-logo {
    width: 70%;
    height: auto;
    display: block;
  }
}

#news {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));
  background: $black-10;

  .sep {
    padding: 8px 0;
    background: $blue-50;

    display: none;
    justify-content: center;
    align-items: center;
    position: relative;

    @media screen and (max-width: 1080px) {
      display: flex;
    }

    .float-block {

      background: $blue-80;
      padding: 10px;
      position: absolute;
      left: 16px;
      bottom: 16px;

      max-width: 163px;
      width: 100%;

      p {
        font-size: 12px;
        color: white;
        font-family: $reg;
        text-transform: uppercase;
        line-height: 120%;
      }
    }

    img {
      max-width: 220px;
      width: 100%;
      height: auto;
      display: block;
    }

  }

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: calc(((var(--vh, 1vh) * 100) - 64px));

  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: $black-60;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 49px;
    text-transform: uppercase;
    @media screen and (max-width: 1080px) {
      margin-bottom: 24px;
      font-size: 24px;
    }
  }

  h3 {
    font-size: 40px;
    letter-spacing: -2px;
    text-transform: uppercase;
    font-family: $bold;
    color: $black-100;
    margin-bottom: 20px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }

  .item {
    display: flex;
    padding: 32px 0;

    @media screen and (max-width: 1080px) {
      padding: 24px 0;
    }

    &.item1 {

      border-bottom: 2px solid var(--Blue-50, #009EE0);
      margin-bottom: 40px;
      @media screen and (max-width: 1080px) {
        margin-bottom: 0;
      }
    }

    .col {

      &.col-svg {
        margin-right: 24px;

        svg {
          max-width: 56px;
          min-width: 56px;
          width: 100%;
          height: auto;
          display: block;

          @media screen and (max-width: 1080px) {
            max-width: 40px;
            min-width: 40px;
          }
        }
      }

      &.col-text {
        p {
          color: var(--black, #231F20);
          font-family: $bold;
          font-size: 18px;
          font-style: normal;
          line-height: 130%;
          letter-spacing: -0.36px;

          @media screen and (max-width: 1080px) {
            font-size: 16px;
          }


          &.m-b-20 {
            margin-bottom: 20px;
          }

          &.m-b-40 {
            margin-bottom: 40px;
          }

          span {
            color: #009EE0;
          }

          a {
            color: var(--black, #231F20);
            font-family: $bold;
            font-size: 18px;
            font-style: normal;
            line-height: 130%;
            letter-spacing: -0.36px;

            @media screen and (max-width: 1080px) {
              font-size: 16px;

            }
            @media screen and (max-width: 375px) {
              word-break: break-all;
            }

            @media screen and (min-width: 1024px) {
              &:hover {
                text-decoration: none;
              }
            }
          }
        }
      }
    }
  }
}

#values {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: #F1F1F1;

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      padding-bottom: 60px;

      max-width: 380px;
    }
  }

  h2 {
    color: $black-60;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 49px;
    @media screen and (max-width: 1080px) {
      margin-bottom: 24px;
      font-size: 24px;
    }
  }

  .button-wrapper {
    transition: transform .2s ease;
    padding-bottom: 240px;

    @media screen and (max-width: 1080px) {
      padding-bottom: 120px;
    }

    @media screen and (min-width: 1240px) {
      &:hover {
        transform: scale(.83);
      }
    }

    .item {
      margin-top: -1px;
      border: 1px solid var(--blue-50, #009EE0);
      padding: 16px 24px;
      display: flex;
      align-items: center;

      cursor: pointer;
      transform-origin: center;

      transition: transform .2s ease;
      background: #F1F1F1;
      overflow: hidden;
      position: relative;

      @media screen and (max-width: 1080px) {
        padding: 12px 24px;
      }

      &:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 59.16%, rgba(38, 173, 229, 0.17) 100%);

      }

      @media screen and (min-width: 1240px) {
        &:hover {

          &.item5 {
            transform: scale(1.20);
            z-index: 3;
          }

          &.item4 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item5 {
              transform: scale(1.1);
              z-index: 2;
            }
          }

          &.item3 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item4 {
              transform: scale(1.1);
              z-index: 2;
            }
          }

          &.item2 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item3 {
              transform: scale(1.1);
              z-index: 2;
            }
          }

          &.item1 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item2 {
              transform: scale(1.1);
              z-index: 2;
            }
          }
        }

        &:has(+ .item:hover) {
          transform: scale(1.1);
          z-index: 2;
        }
      }

      &:first-child {
        margin-top: 0
      }

      svg {
        display: block;
        width: 33px;
        height: auto;
        margin-right: 24px;
      }

      p {
        font-size: 32px;
        font-family: $bold;
        line-height: 110%;
        color: $blue-60;
        @media screen and (max-width: 1080px) {
          font-size: 20px;
        }
      }
    }
  }

  .our-mission {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .line {
      background: $blue-50;
      width: 100%;
      margin: 4px 0;


      &.line1 {
        height: 12px;
        max-width: calc(100% - 100px);

        margin-top: 8px;

        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 50px);
        }
      }

      &.line2 {
        height: 6px;
        max-width: calc(100% - 150px);

        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 76px);
        }
      }

      &.line3 {
        height: 2px;
        max-width: calc(100% - 200px);
        margin-bottom: 0;
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 104px);
        }
      }
    }

    .blue {
      background: $blue-50;
      padding: 60px;
      @media screen and (max-width: 1080px) {
        padding: 32px;
      }

      h3 {
        text-transform: uppercase;
        font-size: 44px;
        font-family: $bold;
        color: white;
        line-height: 120%;
        margin-bottom: 24px;

        @media screen and (max-width: 1080px) {
          font-size: 32px;
        }
      }

      p {
        font-size: 20px;
        font-family: $bold;
        color: white;
        line-height: 120%;

        @media screen and (max-width: 1080px) {
          font-size: 16px;

        }
      }
    }
  }

  .purpose {
    display: flex;
    flex-direction: column;
    align-items: center;

    .line {
      background: white;
      width: 100%;
      margin: 4px 0;

      &.line1 {
        margin-top: 0;

        height: 2px;
        max-width: calc(100% - 200px);
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 104px);
        }
      }

      &.line2 {
        height: 6px;
        max-width: calc(100% - 150px);
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 76px);
        }
      }

      &.line3 {
        height: 12px;
        max-width: calc(100% - 100px);
        margin-bottom: 8px;
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 50px);
        }
      }
    }

    .white {
      background: white;
      padding: 80px 60px;

      @media screen and (max-width: 1080px) {
        padding: 32px;
      }

      h3 {
        font-size: 44px;
        font-family: $bold;
        color: #231F20;
        line-height: 120%;
        margin-bottom: 24px;
        letter-spacing: -1.76px;

        @media screen and (max-width: 1080px) {
          letter-spacing: -1.28px;
          font-size: 32px;
        }
      }

      p {
        font-size: 20px;
        font-family: $bold;
        color: #231F20;
        line-height: 120%;
        letter-spacing: -0.8px;
        @media screen and (max-width: 1080px) {
          letter-spacing: -0.64px;
          font-size: 16px;
        }
      }
    }
  }
}

#icm-farmak {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: $blue-50;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: calc(((var(--vh, 1vh) * 100) - 64px));
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: white;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 40px;
    letter-spacing: -1.6px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;

    .item {
      padding: 40px 20px;
      background: white;
      display: flex;
      align-items: center;
      margin-bottom: 3px;
      @media screen and (max-width: 1240px) {
        padding: 24px 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        max-width: 128px;
        min-width: 128px;
        width: 100%;
        margin-right: 24px;
        @media screen and (max-width: 1240px) {
          max-width: 80px;
          min-width: 80px;
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .text-wrapper {
        display: flex;
        align-items: center;

        @media screen and (max-width: 1080px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .color-text {
        max-width: 192px;
        min-width: 192px;
        width: 100%;
        margin-right: 24px;
        font-size: 24px;
        font-family: $bold;
        letter-spacing: -0.96px;
        text-transform: uppercase;
        color: $blue-60;
        @media screen and (max-width: 1240px) {
          font-size: 24px;
          max-width: 175px;
          min-width: 175px;
        }
        @media screen and (max-width: 1080px) {
          margin-bottom: 8px;
          max-width: 100%;
          min-width: 1px;
          margin-right: 0;
        }
        @media screen and (max-width: 355px) {
          font-size: 18px;
        }
      }

      .black-text {
        color: $black-100;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: -0.64px;
        font-family: $bold;
        @media screen and (max-width: 355px) {
          font-size: 14px;
        }
      }
    }
  }
}

#eu-cdmo {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: calc(((var(--vh, 1vh) * 100) - 64px));

  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: $black-60;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 49px;
    @media screen and (max-width: 1080px) {
      margin-bottom: 24px;
      font-size: 24px;
    }
  }

  h3 {
    font-size: 40px;
    letter-spacing: -2px;
    text-transform: uppercase;
    font-family: $bold;
    color: $black-100;
    margin-bottom: 20px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 422px;
    width: 100%;
    margin: 0 auto;
    @media screen and (max-width: 1080px) {
      max-width: 100%;
    }

    .sep-line {
      width: 100%;
      height: 2px;
      background: #009EE0;
    }

    .item {
      display: flex;
      padding: 32px 0;

      &:last-child {
        border-bottom: none;
      }

      p {
        font-size: 20px;
        font-family: $bold;
        line-height: 130%;
        letter-spacing: -0.4px;
        color: #231F20;

        @media screen and (max-width: 1080px) {
          font-size: 16px;
        }

        span {
          color: $blue-60;

        }
      }

      .icon {
        min-width: 56px;
        min-height: 56px;
        margin-right: 24px;

        @media screen and (max-width: 1080px) {
          min-width: 40px;
          min-height: 40px;
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }
  }

  .sep {
    padding: 8px 0;
    background: $blue-50;

    display: none;
    justify-content: center;
    align-items: center;
    position: relative;

    @media screen and (max-width: 1080px) {
      display: flex;
    }

    .float-block {

      background: $blue-80;
      padding: 10px;
      position: absolute;
      left: 16px;
      bottom: 16px;

      max-width: 163px;
      width: 100%;

      p {
        font-size: 12px;
        color: white;
        font-family: $reg;
        text-transform: uppercase;
        line-height: 120%;
      }
    }

    img {
      max-width: 220px;
      width: 100%;
      height: auto;
      display: block;
    }

  }
}

#r-d {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));


  @media screen and (max-width: 1080px) {
    justify-content: center;
    min-height: calc(((var(--vh, 1vh) * 100) - 64px));

    padding: 0 20px;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;


    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: $black-60;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 49px;
    @media screen and (max-width: 1080px) {
      margin-bottom: 24px;
      font-size: 24px;
    }
  }

  h3 {
    font-size: 40px;
    letter-spacing: -2px;
    text-transform: uppercase;
    font-family: $bold;
    color: $black-100;
    margin-bottom: 20px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 422px;
    width: 100%;
    margin: 0 auto;
    @media screen and (max-width: 1080px) {
      max-width: 100%;
    }

    .sep-line {
      width: 100%;
      height: 2px;
      background: #009EE0;
    }

    .item {
      display: flex;
      padding: 32px 0;

      &:last-child {
        border-bottom: none;
      }

      p {
        font-size: 20px;
        font-family: $bold;
        line-height: 130%;
        letter-spacing: -0.4px;
        color: #231F20;

        @media screen and (max-width: 1080px) {
          font-size: 16px;
        }

        span {
          color: $blue-60;

        }
      }

      .icon {
        min-width: 56px;
        min-height: 56px;
        margin-right: 24px;

        @media screen and (max-width: 1080px) {
          min-width: 40px;
          min-height: 40px;
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }
  }

  .sep {
    padding: 8px 0;
    background: $blue-50;

    display: none;
    justify-content: center;
    align-items: center;
    position: relative;

    @media screen and (max-width: 1080px) {
      display: flex;
    }

    .float-block {

      background: $blue-80;
      padding: 10px;
      position: absolute;
      right: 16px;
      bottom: 16px;

      max-width: 163px;
      width: 100%;

      p {
        font-size: 12px;
        color: white;
        font-family: $reg;
        text-transform: uppercase;
        line-height: 120%;
      }
    }

    img {
      max-width: 220px;
      width: 100%;
      height: auto;
      display: block;
    }

  }
}

#eu-importer-d {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: calc(((var(--vh, 1vh) * 100) - 64px));
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;


    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: $black-60;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 49px;
    @media screen and (max-width: 1080px) {
      margin-bottom: 24px;
      font-size: 24px;
    }
  }

  h3 {
    font-size: 40px;
    letter-spacing: -2px;
    text-transform: uppercase;
    font-family: $bold;
    color: $black-100;
    margin-bottom: 20px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 422px;
    width: 100%;
    margin: 0 auto;
    @media screen and (max-width: 1080px) {
      max-width: 100%;
    }

    .sep-line {
      width: 100%;
      height: 2px;
      background: #009EE0;
    }

    .item {
      display: flex;
      padding: 32px 0;

      &:last-child {
        border-bottom: none;
      }

      p {
        font-size: 20px;
        font-family: $bold;
        line-height: 130%;
        letter-spacing: -0.4px;
        color: #231F20;

        @media screen and (max-width: 1080px) {
          font-size: 16px;
        }

        span {
          color: $blue-60;

        }
      }

      .icon {
        min-width: 56px;
        min-height: 56px;
        margin-right: 24px;

        @media screen and (max-width: 1080px) {
          min-width: 40px;
          min-height: 40px;
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }
  }

  .sep {
    padding: 8px 0;
    background: $blue-50;

    display: none;
    justify-content: center;
    align-items: center;
    position: relative;

    @media screen and (max-width: 1080px) {
      display: flex;
    }

    .float-block {

      background: $blue-80;
      padding: 10px;
      position: absolute;
      left: 16px;
      bottom: 16px;

      max-width: 163px;
      width: 100%;

      p {
        font-size: 12px;
        color: white;
        font-family: $reg;
        text-transform: uppercase;
        line-height: 120%;
      }
    }

    img {
      max-width: 220px;
      width: 100%;
      height: auto;
      display: block;
    }

  }
}

#contacts {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: $black-10;

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: $black-60;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 49px;
    text-transform: uppercase;
    @media screen and (max-width: 1080px) {
      margin-bottom: 24px;
      font-size: 24px;
    }
  }

  .item {
    padding: 32px 0;
    border-bottom: 2px solid $blue-50;

    @media screen and (max-width: 1080px) {
      padding: 24px 0;
    }

    &:first-of-type {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    // The framed toggle below replaces the separator line
    &:has(+ .en-info) {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .en-info {
    margin-top: 40px;

    // Framed button so the toggle reads as a control, not as another heading
    &__toggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 18px 20px;
      background: none;
      border: 2px solid $blue-50;
      cursor: pointer;
      text-align: left;
      color: $blue-50;
      font-family: $bold;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: -0.32px;
      text-transform: uppercase;
      transition: background-color .2s ease, color .2s ease;

      @media screen and (min-width: 1024px) {
        &:hover {
          background: rgba(0, 158, 224, .08);
        }
      }

      &:focus-visible {
        outline: 2px solid $blue-80;
        outline-offset: 3px;
      }

      &[aria-expanded="true"] {
        background: $blue-50;
        color: $white;

        .en-info__icon::after {
          transform: scaleY(0);
        }
      }
    }

    // Plus that turns into a minus: the vertical bar collapses when expanded
    &__icon {
      position: relative;
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin-left: 16px;

      &::before,
      &::after {
        content: '';
        position: absolute;
        background: currentColor;
        transition: transform .3s ease;
      }

      &::before {
        left: 0;
        top: 7px;
        width: 16px;
        height: 2px;
      }

      &::after {
        left: 7px;
        top: 0;
        width: 2px;
        height: 16px;
      }
    }

    // Collapsed by default; grid rows 0fr -> 1fr animate the real content height
    &__panel {
      display: grid;
      grid-template-rows: 0fr;
      opacity: 0;
      visibility: hidden;
      transition: grid-template-rows .4s ease, opacity .4s ease, visibility 0s linear .4s;

      &.is-open {
        grid-template-rows: 1fr;
        opacity: 1;
        visibility: visible;
        transition: grid-template-rows .4s ease, opacity .4s ease, visibility 0s;
      }
    }

    &__inner {
      min-height: 0;
      overflow: hidden;

      > .item:first-child {
        padding-top: 32px;
      }
    }
  }

  h3 {
    color: $black-100;
    font-family: $bold;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: -0.4px;
    text-transform: uppercase;
    margin-bottom: 16px;

    @media screen and (max-width: 1080px) {
      font-size: 18px;
    }
  }

  p {
    color: $black-100;
    font-family: $reg;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: -0.16px;

    @media screen and (max-width: 1080px) {
      font-size: 15px;
    }

    & + p {
      margin-top: 12px;
    }
  }

  strong {
    font-family: $bold;
    color: $blue-50;
  }

  // Contact labels (Email:, Telephone:) stay in text color; only the values are blue
  .details strong {
    color: inherit;
  }

  a {
    color: $blue-60;
    text-decoration: underline;
    overflow-wrap: anywhere;

    @media screen and (min-width: 1024px) {
      &:hover {
        text-decoration: none;
      }
    }
  }
}

#contact {
  padding: 0 40px;

  display: flex;
  justify-content: flex-end;

  background: $blue-50;

  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 79px;
    padding-bottom: 40px;

    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      padding-bottom: 60px;
      max-width: 380px;
    }

    h2 {
      display: block;
      color: white;
      margin: auto 0;
      font-family: $bold;

      @media screen and (max-width: 1080px) {
        margin: 0 0 80px 0;
      }

      span {
        display: flex;
      }

      .line1 {
        display: block;
        margin-bottom: 26px;
        font-size: 32px;

        letter-spacing: -1.6px;
        text-transform: uppercase;

        @media screen and (max-width: 1080px) {
          font-size: 28px;
          margin-bottom: 80px;
          letter-spacing: -1.4px;

        }
      }

      .line2 {
        font-size: 80px;
        line-height: 78%;
        letter-spacing: -3.2px;
        text-transform: uppercase;
        @media screen and (max-width: 1080px) {
          font-size: 32px;
          margin-bottom: 4px;
          letter-spacing: -1.28px;
        }
      }

      .line3 {
        font-size: 120px;
        line-height: 78%;
        letter-spacing: -4.8px;
        text-transform: uppercase;
        @media screen and (max-width: 1080px) {
          font-size: 64px;
          letter-spacing: -2.56px;


        }
      }

      .line4 {
        font-size: 80px;
        line-height: 78%;
        letter-spacing: -3.2px;
        text-transform: uppercase;

        justify-content: flex-end;

        @media screen and (max-width: 1080px) {
          font-size: 32px;
          letter-spacing: -1.28px;


        }
      }

      .line5 {
        font-size: 20px;
        line-height: 100%; /* 20px */
        letter-spacing: -0.8px;
        justify-content: flex-end;
        @media screen and (max-width: 1080px) {
          font-size: 16px;
          letter-spacing: -0.64px;

        }
      }
    }

    .text {
      line-height: 120%;

      font-family: $reg;
      color: $white;
      font-size: 20px;
      letter-spacing: -0.4px;
      margin: auto 0 0 0;

      @media screen and (max-width: 1080px) {
        font-size: 16px;
        margin-bottom: 26px;
      }
    }
  }

  .info {
    margin: auto 0 0 0;
    max-width: 600px;
    width: 100%;
    background: $blue-50;
    position: relative;
    display: none;

    @media screen and (max-width: 1080px) {
      display: block;
    }

    .mark {
      width: 12px;
      height: 12px;

      background: $crimson;
      border-radius: 50%;
      margin-bottom: 7px;
    }

    .line {
      width: 100%;
      padding-bottom: 32px;
      margin-bottom: 32px;
      border-bottom: 2px solid $white;

      display: flex;
      justify-content: space-between;

      @media screen and (max-width: 500px) {
        flex-direction: column;
      }

      &:last-child {
        border-bottom: 0;
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }

    .address {
      color: $white;
      font-size: 15px;
      font-family: $bold;
      line-height: 120%;
    }

    .sales-mail {
      position: relative;
      font-size: 15px;
      line-height: 120%;
      font-family: $bold;
      color: $white;

      display: inline-flex;
      align-items: center;
      text-decoration: none;
      //letter-spacing: -0.04em;

      p {
        display: flex;
        align-items: center;
        transition: transform .2s ease;
      }

      @media screen and (min-width: 1240px) {
        &:hover {
          p {
            transform: translateY(-2px);
          }
        }
      }

      svg {
        display: block;
        width: 14px;
        height: auto;
        margin-left: 10px;
      }

      &:before {
        content: '';
        width: 100%;
        height: 2px;
        bottom: -4px;
        left: 0;
        right: 0;
        position: absolute;

        background: $white;
      }
    }
  }
}

</style>
